angular.module('stwo.core', ["ui.router", "ngSanitize", "pascalprecht.translate", "n3-line-chart", "dcbImgFallback"]);

angular.module('stwo.core')
    .filter('getValue', function () {
        return function (obj, fields) {
            var s = null;
            if (obj) {
                
                var recursiveGet = function(ob, remStr) {
                    if (!ob) {
                        return null;
                    }
                    if (remStr.indexOf(".") >= 0) {
                        var k = remStr.substring(0, remStr.indexOf("."))
                        return recursiveGet(ob[k], remStr.substring(k.length + 1, remStr.length));
                    } else {
                        return ob[remStr];
                    }
                }
                
                s = recursiveGet(obj, fields)
            }
            return s;
        };
    });

angular.module('stwo.core')
    .filter('isEmpty', function () {
        var bar;
        return function (obj) {
            for (bar in obj) {
                if (obj.hasOwnProperty(bar)) {
                    return false;
                }
            }
            return true;
        };
    });

angular.module('stwo.core')
    .filter('propertyContains', function () {
        return function (arr, prop, value) {
            var outArr = [];
            if (!value || value === "") {
                return arr;
            } else {
                for (var n = 0; n < arr.length; n++) {
                    if (arr[n] && arr[n][prop] && arr[n][prop].indexOf(value) >= 0) {
                        outArr.push(arr[n]);
                    }
                }
                return outArr;
            }
        };
    });
angular.module('stwo.core')
    .filter('replaceParameters', function () {
        return function (str, arr) {
            var s = str;
            if (arr) {
                for (var n = 0; n < arr.length; n++) {
                    s = s.replace("{" + n + "}", arr[n]);
                }
            }
            return s;
        };
    });
angular.module('stwo.core')
    .filter('percentage', function () {
        return function (floatNumber, opts) {
            if (opts && opts.indexOf('invert') >= 0) {
                floatNumber = 1 - floatNumber;
            }
            if (opts && opts.indexOf('tenths') >= 0) {
                floatNumber = Math.round(floatNumber * 10) / 10;
            }
            return String(Math.round(floatNumber * 100)) + "%";
        };
    });
angular.module('stwo.core').
  run(function() {
    FastClick.attach(document.body);
  });
angular.module('stwo.core').provider('moduleStore', function() {

    var _modules = {};
    var _links = [];
    var _categories = [];
    var _rootLinks = [];
    var _states = {
            missingCustomer : "^",
            notLoggedIn : "^"
    };
    var _notificationHandlers = {};
    var _serviceRepository = {};

    var _possibleFiltersPerClazz = {};
    var _flags = {};
    
    this.hasAccess = function(link, accessMap) {
        if (!accessMap) {
            return false;
        }
        if (link.categoryDependency) {
            for (var n = 0; n < _links.length; n++) {
                if (_links[n].category === link.categoryDependency && this.hasAccess(_links[n], accessMap)) {
                    return true;
                }
            }
        } else {
            return !link.access || accessMap[link.access[0]][link.access[1]];
        }
    }
    
    this.hasController = function(link, controllerName) {
        if (link.controllers && _.indexOf(link.controllers, controllerName) > -1) {
            return true;
        }
        if (link.categoryDependency) {
            for (var n = 0; n < _links.length; n++) {
                if (_links[n].category === link.categoryDependency && _links[n].controllers && _.indexOf(_links[n].controllers, controllerName) > -1) {
                    return true;
                }
            }
        }
        return false;
    }

    this.removeLink = function(linkIndex) {
        _links.splice(linkIndex, 1);
    }
    //	{name: "alarm", links: [{label:"ALARMS", category: "" , sref: "secure.content.alarm", sort: 15}]}
    this.registerLink = function(link) {
        link.hasAccess = this.hasAccess;
        link.hasController = this.hasController;
        
        if (stwoGlobal.linkCategoryOverride && stwoGlobal.linkCategoryOverride[link.module] && stwoGlobal.linkCategoryOverride[link.module][link.id]) {
            link.category = stwoGlobal.linkCategoryOverride[link.module][link.id];
        }
        
        
        if (_links.length === 0) {
            _links.push(link)
        } else {
            for (var place = 0; place < _links.length; place++) {//keep the links and rootlinks sorted according to the "sort" value
                if (link.sort < _links[place].sort) {
                    _links.splice(place, 0, link);
                    break;
                }
            }
            if (place === _links.length) {
                _links.push(link);
            }
        }
        if (link.category === "navigation") {
                if (_rootLinks.length === 0) {
                        _rootLinks.push(link)
                } else {
                        for (var place = 0; place < _rootLinks.length; place++) {//keep the links and rootlinks sorted according to the "sort" value
                                if (link.sort < _rootLinks[place].sort) {
                                        _rootLinks.splice(place, 0, link);
                                        break;
                                }
                        }
                    if (place === _rootLinks.length) {
                        _rootLinks.push(link);
                    }
                }
        }
        if (!link.category || link.category == "") {//this test is temporary while I manage to change everywhere with meaningful cathegory names
                console.log("NO category was given. See moduleStoreProvider");
        }
    }
    this.registerModule = function(moduleInfo) {
        if (moduleInfo.categories) {
            var categoryExists = false;
            
            for (var n = 0; n < _categories.length; n++) {
                if (moduleInfo.name === _categories[n].name) {
                    categoryExists = true;
                    console.log("Module attempted to add existing category", _categories[n].name, moduleInfo);
                    break;
                }
            }
            if (!categoryExists) {
                for (var n = 0; n < moduleInfo.categories.length; n++) {
                    if (_categories.length === 0) {
                        _categories.push(moduleInfo.categories[n])
                    } else {
                        for (var place = 0; place < _categories.length; place++) {
                            if (moduleInfo.categories[n].sort < _categories[place].sort) {
                                    _categories.splice(place, 0, moduleInfo.categories[n]);
                                    break;
                            }
                        }
                        if (place === _categories.length) {
                            _categories.push(moduleInfo.categories[n]);
                        }
                    }
                }
            }
        }
        
        if (moduleInfo.links) {
            for (var n = 0; n < moduleInfo.links.length; n++) {
                moduleInfo.links[n].module = moduleInfo.name;
                this.registerLink(moduleInfo.links[n]);
            }
        }
        
        if (moduleInfo.notificationHandlers) {
            _notificationHandlers[moduleInfo.name] = moduleInfo.notificationHandlers;
        }
        
        _modules[moduleInfo.name] = moduleInfo;
    }

    this.modules = function() {
        return _modules;
    };
    this.categories = function() {
        return _categories;
    };
    this.flags = function() {
        return _flags;
    };
    this.states = function() {
        return _states;
    };
    this.getPossibleFiltersForClazz = function(clazz) {
        return _possibleFiltersPerClazz[clazz];
    };
    this.addPossibleFilter = function(clazz, filter) {
        if (!_possibleFiltersPerClazz[clazz]) {
            _possibleFiltersPerClazz[clazz] = [];
        }
        for (var n = 0; n < _possibleFiltersPerClazz[clazz].length; n++) {
            if (filter.id === _possibleFiltersPerClazz[clazz][n].id) {
                console.log("Duplicate filter", JSON.stringify(filter));
                return;
            }
        }
        _possibleFiltersPerClazz[clazz].push(filter);
        return _possibleFiltersPerClazz[clazz];
    };
    this.notificationHandlers = function() {
        return _notificationHandlers;
    };
    this.links = function() {
        return _links;
    };
    this.stateDependentLinks = function(currentState, scope) {
        var l = [];
        
        for (var k in _modules) {
            if (_modules[k]["stateDependentLinks"]) {
                for (var n2 = 0; n2 < _modules[k]["stateDependentLinks"].length; n2++) {
                    var r = _modules[k]["stateDependentLinks"][n2](currentState, scope);
                    if (r) {
                        for (var n3 = 0; n3 < r.length; n3++) {
                            l.push(r[n3]);
                        }
                    }
                }
            }
        }
        
        l.sort(function(a, b) {
            return a.sort - b.sort;
        })
        
        return l;
    };
    this.serviceRepository = function() {
        return _serviceRepository;
    };
    this.linksOfCategory = function(category, module) {
        var linkList = [];
        for (var n = 0; n < _links.length; n++) {
            if ( (!module || _links[n].module === module) && (!category || _links[n].category === category) ) {
                linkList.push(_links[n]);
            }
        }
        return linkList;
    };
    this.rootLinks = function() {
        return _rootLinks;
    };

    this.access = function(module, minimumAccess) {
        if (stwoGlobal && stwoGlobal.moduleAccessOverride && stwoGlobal.moduleAccessOverride[module]) {
            return stwoGlobal.moduleAccessOverride[module];
        } else {
            return minimumAccess;
        }
    };
    this.$get = function() {
        return this;
    };
    
    this.defaultLanguage = function() {
        return localStorage["language"] && _.find(stwoGlobal.availableLanguages, function(lang) { return localStorage["language"] === lang.code; }) ? localStorage["language"] : stwoGlobal.defaultLanguage;
    }

}); 
angular.module('stwo.core').factory('timerService', function($interval) {

    var i = {};
    
    
    var timers = {};
    var intervals = {one: 1000, five: 5000, ten: 10000, twenty: 20000, thirty: 30000, sixty: 60000, onetwenty: 120000, threehundred: 300000};
    var lastUpdate = {};
    
    i.timers = function() {
        return timers;
    }
    
    $interval(function() {
        var now = (new Date()).getTime();
        for (var interval in intervals) {
            if (!lastUpdate[interval]) {
                lastUpdate[interval] = 0;
            }
            if (now - lastUpdate[interval] > intervals[interval]) {
                lastUpdate[interval] = now;
                if (!timers[interval]) {
                    timers[interval] = 0;
                }
                timers[interval]++;
            }
        }
    }, 900);
        
    return i;
});
angular.module('stwo.core').factory('utilService', function ($translate, $filter) {

    var i = {};
    var translations = {};
    $translate(["XGUARD_MINUTES", "XGUARD_MINUTE", "XGUARD_HOUR", "XGUARD_HOURS", "XGUARD_TIME_MEASURE_TEMPLATE", "XGUARD_TIMESTAMP_TODAY"])
        .then(function (data) {
            translations = {
                hour: data['XGUARD_HOUR'],
                hours: data['XGUARD_HOURS'],
                minute: data['XGUARD_MINUTE'],
                minutes: data['XGUARD_MINUTES'],
                timeTemplate: data['XGUARD_TIME_MEASURE_TEMPLATE'],
                today: data['XGUARD_TIMESTAMP_TODAY']
            };
        });
    
    i.clone = function(obj) {
        if (null == obj || "object" != typeof obj) return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
    }
    
    i.isResponseValid = function(response, checkLength) {
        return response&&response.data&&response.data.result&&(checkLength?response.data.result.length>0:true);
    }

    i.getFormattedDateFromTimestamp = function (date, todayLength) {
        var dd = moment.tz(date, "YYYY-MM-DDTHH:mm:ss.SSS", "UTC");
        if(!todayLength)
            todayLength = 43200000;
        var retD = false;
        if(new Date() - dd.toDate() < todayLength)
            retD = translations.today + ", " + $filter("amDateFormat")(date, 'HH:mm:ss');
        else
            retD = $filter("amDateFormat")(date, 'YYYY-DD-MM, HH:mm:ss');
        return retD;
    }

    i.checkNestedProperty = function (object) {
        var args = Array.prototype.slice.call(arguments, 1);

        for (var i = 0; i < args.length; i++) {
            if (!object || !object.hasOwnProperty(args[i])) {
              return false;
            }
            object = object[args[i]];
        }
        return true;
    }
        
    return i;
});
angular.module('stwo.core').factory('smarttrackerService', function($http, $location, $translate, $q, moduleStore, pushService, decorationService, amMoment, deploymentApiService, socketioService) {
    // change these URLs accordingly
    var baseUrlApi = 'api3/';
    var baseUrl = stwoGlobal.smarttrackerUrl;//'https://stage.smarttracker.no/web/';

    var user = {};
    var token = null;
    var customer = null;
    var availableCustomers = [];
    var provider = null;
    var availableProviders = [];
    var accessRights = {};
    var customerData = null;



    //example user {username: 'brukernavn', token: 'TOKENTOKEN'}
    var tokens = [];
    
    var _language = moduleStore.defaultLanguage();

    //restoring previously stored tokens
    if (localStorage["tokens"] && localStorage["tokens"] !== null) {
        var storedTokens = JSON.parse(localStorage["tokens"]);
        for (var n = 0; n < storedTokens.length; n++) {
                tokens.push(storedTokens[n]);
        }
    }
    
    
    var deferredLoginData = {login: {started: false, done: false, promises: []}};
    
    

    var i = {};
    
    i.url = function() {
        return baseUrl;
    }
    
    i.language = function(languageCode) {
        if (languageCode) {
            localStorage["language"] = languageCode;
            $translate.use(languageCode);
            
            var amLocale = languageCode;
            var amLocaleRewrites = {no: "nb"};
            if (amLocaleRewrites[languageCode]) {
                amLocale = amLocaleRewrites[languageCode];
            }
            console.log("Setting moment locale: " + amLocale)
            amMoment.changeLocale(amLocale);
                
            _language = languageCode;
        }
        return _language;
    }
    
    i.isLoggedInDelayed = function() {
        var defer = $q.defer();
        
        if (i.isLoggedIn()) {
            defer.resolve();
            return defer.promise;
        }

        
        if (deferredLoginData.login.done) {
            if (i.isLoggedIn()) {
                defer.resolve();
            } else {
                defer.reject();
            }
            return defer.promise;
        }
        
        if (!deferredLoginData.login.started) {

            // check url token
            var urlToken = ($location.search() || {}).token;
            if(typeof urlToken !== 'undefined') { 

                console.log('URL TOKEN LOGIN');

                deferredLoginData.login.started = true;
                deferredLoginData.login.done = false;
                deferredLoginData.login.promises = [];
                deferredLoginData.login.promises.push(defer);

                i.addUser({
                        username : 'temporary-login-token',
                        token : urlToken,
                        persist: true
                });

                i.selectUser('temporary-login-token', urlToken, true).then(function() {

                    history.pushState({}, window.title, $location.absUrl().replace('?token='+urlToken, ''));

                    deferredLoginData.login.done = true;
                    for (var n = 0; n < deferredLoginData.login.promises.length; n++) {
                        deferredLoginData.login.promises[n].resolve();
                    }
                    
                }, function() {
                    deferredLoginData.login.done = true;
                    for (var n = 0; n < deferredLoginData.login.promises.length; n++) {
                        deferredLoginData.login.promises[n].reject();
                    }
                })

            } else {

                if (!stwoGlobal.disableRememberUser && localStorage["lastUsername"] && localStorage["lastUsername"] !== "" && localStorage["lastUsername"] !== "null") {
                    deferredLoginData.login.started = true;
                    deferredLoginData.login.done = false;
                    deferredLoginData.login.promises = [];
                    deferredLoginData.login.promises.push(defer);
                    i.selectUser(localStorage["lastUsername"], null, true).then(function() {
                        deferredLoginData.login.done = true;
                        for (var n = 0; n < deferredLoginData.login.promises.length; n++) {
                            deferredLoginData.login.promises[n].resolve();
                        }
                        
                    }, function() {
                        deferredLoginData.login.done = true;
                        for (var n = 0; n < deferredLoginData.login.promises.length; n++) {
                            deferredLoginData.login.promises[n].reject();
                        }
                    })

                } else {
                    deferredLoginData.login.started = true;
                    deferredLoginData.login.done = true;
                    defer.reject();
                }

            }

        } else {
            deferredLoginData.login.promises.push(defer);
        }
        
        return defer.promise;
    }
    


    i.persistUsers = function() {
        var tokensToPersist = [];
        for (var n = 0; n < tokens.length; n++) {
            if (tokens[n].persist) {
                tokensToPersist.push(tokens[n]);
            }
        }
        localStorage["tokens"] = JSON.stringify(tokensToPersist);
    }

    i.addUser = function(userInfo) {
            i.removeUser(userInfo.username);
            tokens.push(userInfo);
            i.persistUsers();
    }
    i.removeUser = function(username) {
            for (var n = tokens.length - 1; n >= 0; n--) {
                    if (tokens[n].username === username) {
                            tokens.splice(n, 1);
                    }
            }
            i.persistUsers();
    }
    i.getUsers = function() {
            return tokens;
    }

    i.isLoggedIn = function() {
            return user && user.user && token;
    }

    i.getLoggedInUser = function() {
            return user;
    }

    i.getCustomerId = function() {
            return customer;
    }

    i.getProviderId = function() {
            return provider;
    }

    i.getAvailableCustomers = function() {
            return availableCustomers;
    }

    i.getAccessRights = function() {
            return accessRights;
    }

    i.getAvailableProviders = function() {
            return availableProviders;
    }

    i.changeProvider = function(newProviderId) {
            return $http({
                    method : 'PUT',
                    url : baseUrl + "api2/index",
                    data : {
                            provider : newProviderId
                    },
                    headers : {
                            "X-Auth-Token" : token
                    }
            }).then(function(response) {
                    $http.get(baseUrl + baseUrlApi, {
                            headers : {
                                    "X-Auth-Token" : token
                            }
                    }).then(function(response) {
                            if (moduleStore.serviceRepository()["notificationService"]) {
                                moduleStore.serviceRepository()["notificationService"].clear();
                            }
                            i.updateUserData(response.data);
                            return response;
                    });
            });
    }

    i.changeCustomer = function(newCustomerId) {
        return new Promise(function (resolve, reject)  {
            $http({
                    method : 'PUT',
                    url : baseUrl + "api2/index",
                    data : {
                            customer : newCustomerId
                    },
                    headers : {
                            "X-Auth-Token" : token
                    }
            }).then(function(response) {
                    $http.get(baseUrl + baseUrlApi, {
                            headers : {
                                    "X-Auth-Token" : token
                            }
                    }).then(function(response) {

                            if (moduleStore.serviceRepository()["notificationService"]) {
                                moduleStore.serviceRepository()["notificationService"].clear();
                            }
                            i.updateUserData(response.data);
                            resolve(response);

                            deploymentApiService.delete('/v1/cache/session')

                    });
            });
        });
    }

    i.login = function(user, renew) {
            var xsrf = {
                    token : "true",
                    username : user.username,
                    password : user.password,
                    /*createNewToken:true,
                    expireOtherTokens:true,*/
                    replacementPassword : renew ? user.replacementPassword : undefined
            };
            return $http({
                    method : 'POST',
                    url : baseUrl + "api2/login",
                    data : xsrf,
                    headers : {
                            'Content-Type' : 'application/json'
                    }
            }).then(function(response) {
                    console.log(response);
                    console.log(response.headers("X-Auth-Token"));
                    console.log(response.data.token);
                    
                    i.addUser({
                            username : user.username,
                            token : response.data.token,
                            persist: user.persist
                    });
                    
                    return response;
            });
    }

    i.selectUser = function(username, suppliedToken, doNotRedirect) {
                    
        if (!suppliedToken) {
            for (var n = tokens.length - 1; n >= 0; n--) {
                if (tokens[n].username === username) {
                    token = tokens[n].token;
                }
            }
        } else {
            token = suppliedToken;
        }

        localStorage.setItem('authToken', token);
        localStorage["lastUsername"] = username;
        
        return $http.get(baseUrl + baseUrlApi, {
                headers : {
                        "X-Auth-Token" : token
                }
            }).then(function(response) {
                i.updateUserData(response.data);
                return response;
            }, function(response) {
                if (response && response.data && response.data.tokenNotFound) {
                    $location.path('/logout');
                }
                if (!doNotRedirect) {
                    if (user) {
                        $location.path('/logout');
                    } else {
                        $location.path('/login');
                    }
                    $location.replace();
                    return response;
                }
        });

    }

    i.refreshUser = function() {
            return $http.get(baseUrl + baseUrlApi, {
                    headers : {
                            "X-Auth-Token" : token
                    }
            }).then(function(response) {
                    i.updateUserData(response.data);
                    return response;
            }, function(response) {
                    if (user) {
                            $location.path('/logout');
                    } else {
                            $location.path('/login');
                    }
                    $location.replace();
                    return;
            });

    }
    
    i.getUserData = function() {
        return user;
    }

    i.isAlarmCenter = function() {
        return customerData != null && customerData.alarmCenter;
    }

    i.updateUserData = function(data) {
        data = angular.fromJson(angular.toJson(data));
        for (var k in user) {
            delete user[k];
        }
        for (var k in data) {
            user[k] = data[k];
        }

        customer        = data && data.customer ? data.customer.id : null;
        provider        = data && data.provider ? data.provider.id : null;
        customerData    = data && data.customer ? data.customer : null;

        availableCustomers.splice(0, availableCustomers.length);
        if (data && data.customers) {
            for (var n = 0; n < data.customers.length; n++) {
                availableCustomers.push(data.customers[n]);
            }
        }

        availableProviders.splice(0, availableProviders.length);
        if (data && data.providers) {
            for (var n = 0; n < data.providers.length; n++) {
                availableProviders.push(data.providers[n]);
            }
        }
        
        for (var k in accessRights) {
            delete accessRights[k];
        }
        for (var k in user.access) {
            accessRights[k] = user.access[k];
        }
        
        var userLanguage = stwoGlobal.defaultLanguage;
        if (data && data.user && data.user.language) {
            userLanguage = data.user.language;
            console.log("Language gotten from user settings: " + userLanguage)
        }
        var languageAmongDefined = false;
        for (var n = 0; n < stwoGlobal.availableLanguages.length; n++) {
            if (stwoGlobal.availableLanguages[n].code === userLanguage) {
                languageAmongDefined = true;
                break;
            }
        }
        if (!languageAmongDefined) {
            userLanguage = localStorage["language"] ? localStorage["language"] : stwoGlobal.defaultLanguage;
        }
        i.language(userLanguage);
        
        moduleStore.serviceRepository()["pushService"].configure(token, user, customer, provider);
        moduleStore.serviceRepository()["pushService"].reconnect();
        moduleStore.serviceRepository()["decorationService"].refresh();
        
        if (moduleStore.serviceRepository()["notificationService"]) {
            moduleStore.serviceRepository()["notificationService"].poll();
        }
    }

    i.logout = function() {
        for (var k in user) {
            delete user[k];
        }
        for (var n = tokens.length - 1; n >= 0; n--) {
            if (!tokens[n].persist) {
                tokens.splice(n, 1);
            }
        }
        i.persistUsers();
        
        if (moduleStore.serviceRepository()["notificationService"]) {
            moduleStore.serviceRepository()["notificationService"].clear();
        }
        if (moduleStore.serviceRepository()["pushService"]) {
            moduleStore.serviceRepository()["pushService"].disconnect();
        }
    }
    
    i.getToken = function() {
        return token;
    }

    i.authGet = function(url, opts) {
            if (!token) {
                    if (i.isLoggedIn()) {
                            $location.path('/logout');
                    } else {
                            $location.path('/login');
                    }
                    $location.replace();
                    return;
            }

            return $http.get(baseUrl + baseUrlApi + url, {
                    headers : {
                            "X-Auth-Token" : token
                    }
            }).then(function(response) {
                    return response;
            }, function(response) {
                    if (!opts || !opts.onErrorDoNotRedirect) {
                            if (i.isLoggedIn()) {
                                    $location.path('/logout');
                            } else {
                                    $location.path('/login');
                            }
                            $location.replace();
                    }
                    return response;
            });
    }

    i.authPost = function(url, data) {
            if (!token) {
                    if (i.isLoggedIn()) {
                            $location.path('/logout');
                    } else {
                            $location.path('/login');
                    }
                    $location.replace();
                    return;
            }

            return $http.post(baseUrl + baseUrlApi + url, data, {
                    headers : {
                            "X-Auth-Token" : token
                    }
            });
    }

    i.authPut = function(url, data) {
            if (!token) {
                    if (i.isLoggedIn()) {
                            $location.path('/logout');
                    } else {
                            $location.path('/login');
                    }
                    $location.replace();
                    return;
            }

            return $http.put(baseUrl + baseUrlApi + url, data, {
                    headers : {
                            "X-Auth-Token" : token
                    }
            });
    }

    i.authDelete = function(url) {
            if (!token) {
                    if (i.isLoggedIn()) {
                            $location.path('/logout');
                    } else {
                            $location.path('/login');
                    }
                    $location.replace();
                    return;
            }

            return $http["delete"] (baseUrl + baseUrlApi + url, {
                    data: "",
                    headers : {
                            "X-Auth-Token" : token
                    }
            });
    }


    var ps_key = "pushSubscriptionKey";
    i.isPushSubscriptionEnabled = function () {
        return localStorage[ps_key];
    }

    i.togglePushSubscription = function() {
        if(localStorage[ps_key] != '')
            localStorage[ps_key] = '';
        else 
            localStorage[ps_key] = ps_key;
        console.log(localStorage[ps_key]);
        console.log(ps_key);
        console.log(localStorage[ps_key] != '');

    }

    i.getAuthToken = function() {
        return token;
    }

    moduleStore.serviceRepository()["smarttrackerService"] = i;
    return i;

});

angular.module('stwo.core').factory('pushService', function($http, $location, $translate, $q, $timeout, moduleStore) {
    
    var url = null;
    
    var ws = null;
    
    var pushShouldBeConnected = false;
    var pushEnabled = false;
    
    var harvestedMessages = [];
    var nextHarvestedMessages = [];
    var pushChanged = {counter: 0};
    
    var waitingForReconnect = false;
    
    var listeners = [];
    var messageSoFar = null;
    
    function onOpen(evt) {
        console.log("CONNECTED");
    }
    function onClose(evt) {
        console.log("DISCONNECTED, RETRYING CONNECTION IN 5000 MS");
        if (pushShouldBeConnected) {
            if (waitingForReconnect) {
                console.log("RETRY CANCELLED, WAITING FOR RECONNECT");
                return;
            }
            waitingForReconnect = true;
            $timeout(function() {
                i.reconnect();
            }, 5000, false)
        }
    }
    function onMessage(evt) {
         //console.log('onMessage', evt.data, evt.data ? evt.data.length : "");
        
        if (pushEnabled && evt.data) {
            try {
                nextHarvestedMessages.push(JSON.parse(evt.data));
                console.log("socketMessage: whole message parsable")
                messageSoFar = null;
            } catch (err) {
                console.log("socketMessage: cannot parse message as JSON, adding to messageSoFar")
                if (!messageSoFar) {
                    //console.log("socketMessage: messageSoFar is empty")
                    messageSoFar = String(evt.data);
                } else {
                    //console.log("socketMessage: appending to messageSoFar")
                    messageSoFar = messageSoFar + String(evt.data);
                    
                    try {
                        //console.log("socketMessage: attempting to parse messageSoFar")
                        nextHarvestedMessages.push(JSON.parse(messageSoFar));
                        messageSoFar = null;
                        console.log("socketMessage: messageSoFar parsed, message ok")
                    } catch (err) {
                        console.log("socketMessage: unable to parse messageSoFar, waiting for more")
                    }
                }
            }
        } 
    }
    function onError(evt) {
        console.log("ERROR, RETRYING IN 5000 MS");
        if (waitingForReconnect) {
            console.log("RETRY CANCELLED, WAITING FOR RECONNECT");
            return;
        }
        waitingForReconnect = true;
        $timeout(function() {
            i.reconnect();
        }, 5000, false)
    }
    
    var util = {
        mergeState: function(obj, push) {
            if (obj.hasOwnProperty("tags") && push.hasOwnProperty("tags")) {
                while (obj.tags.length) {
                    obj.tags.splice(0, 1);
                }
                for (var n = 0; n < push.tags.length; n++) {
                    obj.tags.push(push.tags[n]);
                }
                console.log("Pushservice merged tags" + obj.name)
            }
            if (obj.hasOwnProperty("properties") && push.hasOwnProperty("properties")) {
                while (obj.properties.length) {
                    obj.properties.splice(0, 1);
                }
                for (var n = 0; n < push.properties.length; n++) {
                    obj.properties.push(push.properties[n]);
                }
                console.log("Pushservice merged properties" + obj.name)
            }
        },
        mergePosition: function(obj, push) {
            if (push.position && push.position.valid) {
                if (!obj.lastValidPosition) {
                    obj.lastValidPosition = {valid: true};
                }
                obj.lastValidPosition.latitude = push.position.latitude;
                obj.lastValidPosition.longitude = push.position.longitude;
                obj.lastValidPosition.floor = push.position.floor;
                obj.lastValidPosition.address = push.position.address;
                if (push.position.textual && push.position.textual !== "") {
                    obj.lastValidPosition.address = push.position.textual + (obj.lastValidPosition.address && obj.lastValidPosition.address !== "" ? ", " + obj.lastValidPosition.address: "") ;
                }
                if(push.position.accuracy) {
                    obj.lastValidPosition.accuracy = push.position.accuracy;
                }
                if(push.observation && push.observation.properties) {
                    obj.lastPosition.properties = push.observation.properties;
                }

                obj.lastValidPosition.insideZones = push.position.insideZones;
                obj.lastValidPosition.timestamp = push.position.timestamp;
                console.log("Pushservice merged lat lon position" + obj.name)
            }
            if (push.position && obj.lastPosition) {
                obj.lastPosition.timestamp = push.position.timestamp;
            }
            if (push.position && push.position.location && push.position.location.locationId) {
                if (!obj.lastValidPosition) {
                    obj.lastValidPosition = {};
                }
                obj.lastValidPosition.location = push.position.location;
                obj.lastValidPosition.coordinate = push.position.coordinate;
                obj.lastValidPosition.address = push.position.address;
                if (push.position.textual && push.position.textual !== "") {
                    obj.lastValidPosition.address = push.position.textual + (obj.lastValidPosition.address && obj.lastValidPosition.address !== "" ? ", " + obj.lastValidPosition.address: "");
                }
                console.log("Pushservice merged indoor position" + obj.name)
            }
        }
    }
    
    var i = {};
    
    i.listen = function(processFn) {
        listeners.push(processFn);
    }
    
    i.processNewPushMessages = function() {
        harvestedMessages = nextHarvestedMessages;
        
        for (var m = 0; m < harvestedMessages.length; m++) {
            for (var n = 0; n < listeners.length; n++) {
                listeners[n](harvestedMessages[m], util);
            }
        }
        if (nextHarvestedMessages.length > 0) {
            pushChanged.counter++;
        }
        nextHarvestedMessages = [];
    }

    
    i.process = function(processFn) {
        for (var n = 0; n < harvestedMessages.length; n++) {
            processFn(harvestedMessages[n], util);
        }
    }
    
    i.changed = function() {
        return pushChanged;
    }
    
    i.configure = function(token, user, customer, provider) {
        url = moduleStore.serviceRepository()["smarttrackerService"].url();
        
        if (url.indexOf("/") === 0) {
            url = window.location.protocol.toLowerCase() + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + url;
        }
        
        url = url.replace("http", "ws").replace("/web/", "/push/") + "api3/" + customer + "/event?X-Auth-Token=" + token;
        
        if (pushEnabled && pushShouldBeConnected && ws && ws.readyState < 2) {
            i.reconnect();
        }
    }
    
    i.enabled = function (newPushEnabledValue) {
        pushEnabled = newPushEnabledValue;
        if (pushEnabled && pushShouldBeConnected && (!ws || ws.readyState > 1)) {
            i.reconnect();
        }
    }
    
    i.reconnect = function() {
        waitingForReconnect = false;
        if (pushEnabled) {
            ws = new WebSocket(url);
            ws.onopen = function(evt) { onOpen(evt) };
            ws.onclose = function(evt) { onClose(evt) };
            ws.onmessage = function(evt) { onMessage(evt) };
            ws.onerror = function(evt) { onError(evt) };
        }
        pushShouldBeConnected = true;
    }
    
    i.disconnect = function() {
        if (ws) {
            ws.close();
        }
        pushShouldBeConnected = false;
    }

    moduleStore.serviceRepository()["pushService"] = i;
    return i;
});

angular.module('stwo.core').factory('socketioService', function ($http, $location, $translate, $q, $timeout, moduleStore) {

    // init
    var i = {
        callbacks: {},
        state: {
            connected: false,
            connecting: false,
            authenticated: false,
        },
    };

    // Function: Connect
    i.connect = function(){

        // service
        var smarttrackerService = moduleStore.serviceRepository()["smarttrackerService"];

        // check already connected
        if(i.state.connected === true || i.state.connecting === true) { 

            return;

        }

        // set
        i.state.connecting = true;

        // log
        console.log('Class: socketioService', '- Function: Connect');

        // create socket instance
        i.socket = io(stwoGlobal.deploymentApiUrl + '/?x-auth-token=' + smarttrackerService.getToken(), {
          transports: ['websocket']
        });

        i.socket.on('reconnect_attempt', function() {
          i.socket.io.opts.transports = ['polling', 'websocket'];
        });

        i.socket.on('connect', i.onConnect);
        i.socket.on('authenticated', i.onAuthenticated);
        i.socket.on('subscribed', i.onSubscribe);
        i.socket.on('unsubscribed', i.onUnsubscribe);
        i.socket.on('message', i.onMessage);

    }

    // Function: checkConnected
    i.isConnected = function(){

        return i.state.connected || false;

    }

    i.isAuthenticated = function(){

        return i.state.authenticated || false;

    }

    // Function: Subscribe
    i.subscribe = function(objectName, callback){

        // log
        console.log('Class: socketioService', '- Function: Subscribe');

        // check connection
        if(i.isConnected() === false || i.isAuthenticated() === false){

            // log
            console.log('Class: socketioService', '- Function: Subscribe', '- Error: Not connected, waiting 200ms');
            setTimeout(function(){

                // retry
                i.subscribe(objectName, callback)

            }, 250);
            return;

        }

        // save
        this.callbacks[objectName] = callback;

        // emit
        i.socket.emit('subscribe', objectName);

    }

    // Function: Subscribe
    i.unsubscribe = function(object){

        // log
        console.log('Class: socketioService', '- Function: Unsubscribe');

        // check connection
        if(i.isConnected() === false){

            // log
            console.log('Class: socketioService', '- Function: Unsubscribe', '- Error: Not connected');
            return;

        }

        // emit
        i.socket.emit('unsubscribe', object);

    }

    // Event: Connected
    i.onConnect = function(message) {

        // log
        console.log('Class: socketioService', '- Event: onConnect');

        // set connected
        i.state.connecting = false;
        i.state.connected = true;

    }

    // Event: Connected
    i.onAuthenticated = function(message) {

        // log
        console.log('Class: socketioService', '- Event: onAuthenticated');

        // set connected
        i.state.authenticated = true;

    }

    // Event: Connected
    i.onSubscribe = function(message) {

        // log
        console.log('Class: socketioService', '- Event: onSubscribe', '- Message:', message);

    }

    // Event: Connected
    i.onUnsubscribe = function(message) {

        // log
        console.log('Class: socketioService', '- Event: onUnsubscribe', '- Message:', message);

    }

    // Event: Connected
    i.onMessage = function(message) {

        // log
        console.log('Class: socketioService', '- Event: onMessage', '- Message:', message);

        // send to listeners
        var callback = i.callbacks[message.objectName];
        if(typeof callback === 'function'){

            // execute
            callback(message.data);

        }

    }

    // be done
    moduleStore.serviceRepository()["socketioService"] = i;
    return i;

});
angular.module('stwo.core').factory('overlayService', function(smarttrackerService) {

    // constants
    var max = 100;
    var updateInProgress = false;

    var TIMESTAMP_KEY = "OverlayPreviousCheckTS";
    var OVERLAYS_KEY = "OverlaysWhenPreviousCheck";
    var OVERLAYS_CID_KEY = "OverlayPreviousCustomerID";

    // reload overlays
    var reloadOverlays = function(offset, elements, fn) {

        // don't proceed when updating
        if (updateInProgress && offset == 0) {

            try {

                // parse current cache
                fn(JSON.parse(localStorage[OVERLAYS_KEY]));

            } catch (e) {

                // fallback
                fn([])

            }
            return;

        };

        // set to updating
        updateInProgress = true;

        // defaults
        if (!elements) {
            elements = []
        }

        // get overlays from smarttracker
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/document/?select=@&type:equals=ACR_OVERLAY&max=" + max + "&offset=" + offset + "&sort=name&order=asc")
            .then(function(response) {

                // define constants
                var data = response.data;
                elements = elements.concat(response.data.result);

                // paging
                if (elements.length < data.total && response.data.result.length > 0) {

                    reloadOverlays(offset + max + 1, elements, fn);

                } else {

                    // return elements
                    localStorage[OVERLAYS_KEY] = JSON.stringify(elements);
                    localStorage[TIMESTAMP_KEY] = Date.now();
                    localStorage[OVERLAYS_CID_KEY] = smarttrackerService.getCustomerId();
                    updateInProgress = false;

                    if (fn) {

                        fn(elements);

                    }

                }

            });
    }

    // get overlays
    var i = {};
    i.getOverlays = function(fn) {

        // retrieve access rights
        var access = smarttrackerService.getAccessRights();

        // check access
        if (access['document']['get']) {

            // make sure keys are defined
            if (!localStorage[TIMESTAMP_KEY]) {
                localStorage[TIMESTAMP_KEY] = new Date();
                localStorage[OVERLAYS_KEY] = [];
                localStorage[OVERLAYS_CID_KEY] = smarttrackerService.getCustomerId();
            }

            console.log("DIff: ", Date.now() - localStorage[TIMESTAMP_KEY], Date.now(), localStorage[TIMESTAMP_KEY]);

            // check localStorage keys
            if (Date.now() - localStorage[TIMESTAMP_KEY] > 3600 * 1000 ||  localStorage[OVERLAYS_CID_KEY] != smarttrackerService.getCustomerId()) {

                reloadOverlays(0, [], fn);

            } else {

                try {

                    return fn(JSON.parse(localStorage[OVERLAYS_KEY]));

                } catch (e) {

                    console.log('Parsing OverlaysWhenPrevisousCheck failed, reloading overlays');
                    reloadOverlays(0, [], fn);
                    
                }

            }

        } else {

            return fn([])

        }
    }

    return i;
});
angular.module('stwo.core').factory('mapService', function($http, $location, smarttrackerService, overlayService) {
    // change these URLs accordingly

    var availableLayers = {
                osm : {
                    code : "osm",
                    name : 'OpenStreetMap',
                    url : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    type : 'xyz',
                    transitionEffect: 'resize',
                    layerParams : {
                        maxZoom: 21,
                        maxNativeZoom: 19,
                        attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                    }
                }
                //otm : {
                //    code : "otm",
                //    name : 'Thunderforest.Transport',
                //    type : 'xyz',
                //    url : 'https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png',
                //    layerParams : {
                //        attribution: '&copy; <a href="http://www.opencyclemap.org">OpenCycleMap</a>, &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                //    }
                //},
                //nsk : {
                //    code : "nsk",
                //    name : 'Statens Kartverk',
                //    url : 'https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=topo2&zoom={z}&x={x}&y={y}',
                //    type : 'xyz',
                //    layerParams : {
                //        attribution: '&copy; <a href="http://statkart.no">Kartverket</a>'
                //    }
                //},
                //ocm : {
                //    code : "ocm",
                //    name : 'Thunderforest.OpenCycleMap',
                //    type : 'xyz',
                //    url : 'https://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png',
                //    layerParams : {
                //        attribution: '&copy; <a href="http://www.opencyclemap.org">OpenCycleMap</a>, &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
                //    }
                //}

            };


    var _chosenLayer = localStorage["mapLayer"] ? localStorage["mapLayer"] : "osm";

    var i = {};

    i.getAvailableLayers = function() {
        return availableLayers;
    }

    i.chosenLayer = function(layerCode) {
        if (layerCode) {
            _chosenLayer = layerCode;

            localStorage["mapLayer"] = layerCode;
        }
        return _chosenLayer;
    }

    i.basicMapDesign = function(scope, leafletData, mapId){
        scope.layers = {
            baselayers : angular.fromJson(angular.toJson(i.getAvailableLayers()))
        };
        scope.savedCenters = {
            osloCenter : { //Changed to The Netherlands coordinates
                lat: 52.386617,
                lng: 5.799990,
                zoom: 8
            }
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                if (position.coords) {
                    scope.savedCenters.osloCenter.lat = position.coords.latitude;
                    scope.savedCenters.osloCenter.lng = position.coords.longitude;
                }
            })
        }

        leafletData.getMap(mapId).then(function (map) {
            /*map.zoomControl.setPosition("bottomright");*/

            var l = i.getAvailableLayers();

            for (var k in l) {
                if (!scope.layers.baselayers[k]) {
                    scope.layers.baselayers[k] = l[k];
                }
            }

            var layersToDelete = [];
            for (var k in scope.layers.baselayers) {
                if (k !== _chosenLayer) {
                    layersToDelete.push(k);
                }
            }
            for (var n = 0; n < layersToDelete.length; n++) {
                delete scope.layers.baselayers[layersToDelete[n]]
            }

        });
    };

    var SELECTED_OVERLAY_KEY = "selectedOverlayLevel";
    i.selectedOverlayLevel = function() {
        var selectedOverlayLevel = localStorage[SELECTED_OVERLAY_KEY];
        if(!selectedOverlayLevel) {
            localStorage[SELECTED_OVERLAY_KEY] = "0";
            selectedOverlayLevel = "0";
        }
        return selectedOverlayLevel;
    }
    
    i.loadOverlays = function(map, level) {
        if(level && level != "") {
            localStorage[SELECTED_OVERLAY_KEY] = level;
        } else {
            level = i.selectedOverlayLevel();
        }

        overlayService.getOverlays(function (overlaysList) {
            if(map.overlayLayer) {
                map.overlayLayer.setLevel(level);
            } else {
                L.layerGroup.overlay(overlaysList, level).addTo(map);
            }
        })
    }

    i.makeNamedIcon = function(name, color, icon, colorDark){
        if(!color){
            color = "#1972B9";
        }
        if(!colorDark){
            colorDark = "#005f9e";
        }
        if (!icon) {
            icon = "mdi mdi-map-marker";
        }
        var micon = L.divIcon({
            type: 'div',
            iconAnchor: [19, 32],
            className: 'myleaflet-div-icon',
            html: '<div><div class="pin"><i class="' + icon + '" style="color:' + color + '"></i></div><div class="name label" style="background-color:' + color + '; border-color:' + colorDark + '"><span>' + name + '</span></div></div>',
            popupAnchor:  [0, 0]
        });
        return micon;
    };

    return i;
}); 
angular.module('stwo.core').factory('contentCacheService', function($q, smarttrackerService) {
    var cache = {};
    
    var i = {};
    
    i.put = function(clazz, id, obj) {
        if (!cache[clazz]) {
            cache[clazz] = {};
        }
        if (cache[clazz][id]) {
            var scrubbedOfAngularVars = angular.fromJson(angular.toJson(obj));
            for (var k in scrubbedOfAngularVars) {
                cache[clazz][id][k] = scrubbedOfAngularVars[k];
            }
        } else {
            cache[clazz][id] = angular.fromJson(angular.toJson(obj));
        }
    }
    
    i.putMany = function(clazz, arr, idField) {
        var f = idField ? idField : "id";
        for (var n = 0; n < arr.length; n++) {
            i.put(clazz, arr[n][f], arr[n]);
        }
    }
    
    i.get = function(clazz, id) {
        if (cache[clazz] && cache[clazz][id]) {
            return cache[clazz][id];
        }
        return null;
    }
    
    var downloadCache = {};
    
    var beginDownloading = function(url, initialPromise, opts) {
        var now = (new Date()).getTime();
        var cacheId = url + (opts ? opts.max : "");
        var defer = $q.defer();
        
        downloadCache[cacheId] = {expiry: now + (opts && opts.timeToLive ? opts.timeToLive : 60000), url: url, inProgress: true, data: [], promises: [], downloadPromise: defer, offset: 0, max: opts && opts.max ? opts.max : 15};
        downloadCache[cacheId].promises.push(initialPromise);
                
        doDownload(downloadCache[cacheId]);
        
        return defer.promise;
    }
    
    var doDownload = function(cacheData) {
        smarttrackerService.authGet(cacheData.url + (cacheData.url.indexOf("?") > 0 ? '&' : '?') + 'offset=' + cacheData.offset + '&max=' + cacheData.max).then(function(response) {
            for (var n = 0; n < response.data.result.length; n++) {
                cacheData.data.push(response.data.result[n]);
            }
            if (response.data.result.length < cacheData.max) {
                cacheData.inProgress = false;
                cacheData.downloadPromise.resolve(cacheData);
            } else {
                cacheData.offset += cacheData.max;
                doDownload(cacheData);
            }
        }, function() {
            cacheData.inProgress = false;
            cacheData.expiry = 0;
            cacheData.downloadPromise.reject();
        });
    }
    
    i.download = function(url, opts) {
        var now = (new Date()).getTime();
        var defer = $q.defer();
        var cacheId = url + (opts ? opts.max : "");
        
        if (downloadCache[cacheId] && !downloadCache[cacheId].inProgress && downloadCache[cacheId].expiry > now) {
            //console.log("Content cache hit for " + cacheId)
            defer.resolve(downloadCache[cacheId].data);
        } else {
            //console.log("Content cache MISS for " + cacheId, now, downloadCache[cacheId])
            if (downloadCache[cacheId] && downloadCache[cacheId].inProgress) {
                //console.log("Content cache IN PROGRESS for " + cacheId)
                downloadCache[cacheId].promises.push(defer);
            } else {
                //console.log("Content cache request for " + cacheId)
                beginDownloading(url, defer, opts).then(function(cacheData) {
                    //console.log("Content cache request complete " + cacheId + " for " + downloadCache[cacheId].promises.length + " promises")
                    for (var n = 0; n < downloadCache[cacheId].promises.length; n++) {
                        downloadCache[cacheId].promises[n].resolve(cacheData.data);
                    }
                }, function() {
                    //console.log("Content cache request fail " + cacheId)
                    for (var n = 0; n < downloadCache[cacheId].promises.length; n++) {
                        downloadCache[cacheId].promises[n].reject();
                    }
                })
            }
        }
        return defer.promise;
    }
    
    i.fromCache = function(url, opts) {
        var cacheId = url + (opts ? opts.max : "");
        
        i.download(url, opts);
        
        if (downloadCache[cacheId] && !downloadCache[cacheId].inProgress) {
            return downloadCache[cacheId].data;
        } else {
            return null;
        }
    }
    
    i.invalidate = function(urlPrefix) {
        for (var k in downloadCache) {
            if (k.indexOf(urlPrefix) === 0) {
                console.log("Invalidating: " + k)
                delete downloadCache[k];
            }
        }
    }
    
    return i;
});
angular.module('stwo.core')
    .filter('notificationFromModule', function () {
        return function (arr, moduleId) {
            var out = [];
            if(arr) {
                for (var n = 0; n < arr.length; n++) {
                    if (arr[n].module === moduleId) {
                        out.push(arr[n]);
                    }
                }
                return out;
            }
        };
    }).filter('notificationWithLevel', function () {
        return function (arr, level) {
            var out = [];
            if(arr) {
                for (var n = 0; n < arr.length; n++) {
                    if (arr[n].level == level) {
                        out.push(arr[n]);
                    }
                }
                return out;
            }
        };
    });

angular.module('stwo.core').factory('notificationService', function (moduleStore, $state, smarttrackerService, utilService) {

    var i = {
        ignored: {},
        changed: {dismissed: 0, added: 0, updated: 0, removed: 0},
        audio: {
            muted: false, //localStorage["stwo-mute"] === "true", // for backwards compability
            snoozed: false,
            ignoreSnooze: localStorage["stwo-ignore-snooze"] !== "false"
        }
    };

    var notifications = [];

    var sounds = [
        {'name':'Alert', 'file':'core/mp3/alarms/Alert.mp3'},
        {'name':'Alarm', 'file':'core/mp3/alarms/Alarm.mp3'},
        {'name':'What', 'file':'core/mp3/alarms/What.mp3'},
        {'name':'Wake Up', 'file':'core/mp3/alarms/WakeUp.mp3'},
        {'name':'Mirror', 'file':'core/mp3/alarms/Mirror.mp3'},
        {'name':'Beep Beep', 'file':'core/mp3/alarms/BeepBeep.mp3'},
        {'name':'Jump', 'file':'core/mp3/alarms/Jump.mp3'},
        {'name':'Shake', 'file':'core/mp3/alarms/Shake.mp3'},
        {'name':'Gooday', 'file':'core/mp3/alarms/Gooday.mp3'},
        {'name':'Done', 'file':'core/mp3/alarms/Done.mp3'},
        {'name':'Toss It', 'file':'core/mp3/alarms/TossIt.mp3'},
        {'name':'Tornado', 'file':'core/mp3/alarms/Tornado.mp3'},
        {'name':'Alarm Clock', 'file':'core/mp3/alarms/AlarmClock.mp3'},
        {'name':'Dive', 'file':'core/mp3/alarms/Dive.mp3'}
    ];

    i.add = function (notification) {
        
        var updated = false;

        notification.dismiss = i.dismiss;
        notification.view = i.view;

        for (var n = notifications.length - 1; n >= 0; n--) {
            if (notifications[n].id === notification.id) {
                notifications[n] = notification;
                updated = true;
                i.changed.updated++;

                if (notifications[n].level == 'warning') {
                    Push.create(notifications[n].name, {
                        // body: 'Warning!',
                        icon: 'customization/images/notification-warning.png',
                        timeout: 8000,
                        onClick: function () {
                            window.focus();
                            this.close();
                            $state.go("secure.content.alarm-screen-xguard-detail", {id: notifications[n].alarmId});
                        }
                    });
                }
                else if (notifications[n].level == 'danger') {
                    Push.create(notifications[n].name, {
                        // body: 'Alarm! ID: ' + notifications[n].alarmId,
                        icon: 'customization/images/notification-danger.png',
                        timeout: 8000,
                        onClick: function () {
                            window.focus();
                            this.close();
                            $state.go("secure.content.alarm-screen-xguard-detail", {id: notifications[n].alarmId});
                        }
                    });
                }
                else if (notifications[n].level == 'notification') {
                    Push.create(notifications[n].name, {
                        // body: 'Notification!',
                        icon: 'customization/images/notification-normal.png',
                        timeout: 8000,
                        onClick: function () {
                            window.focus();
                            this.close();
                            $state.go("secure.content.alarm-screen-xguard-detail", {id: notifications[n].alarmId});
                        }
                    });
                }

                /*console.log(notifications[n]);*/
                break;
            }
        }
        if (!updated) {
            notifications.push(notification);
            i.changed.added++;
        }
        notifications.sort(function (a, b) {
            return a.time > b.time ? 1 : -1;
        })
    }

    i.remove = function (notification) {
        for (var n = notifications.length - 1; n >= 0; n--) {
            if (notifications[n].id === notification.id) {
                notifications.splice(n, 1);
                i.changed.removed++;
            }
        }
    }

    i.clear = function () {
        notifications.splice(0, notifications.length);
        i.changed.removed++;
    }

    i.silentDismiss = function (notificationId) {
        for (var n = notifications.length - 1; n >= 0; n--) {
            if (notifications[n].id === notificationId) {
                notifications[n].dismissed = true;
                i.changed.dismissed++;
                break;
            }
        }
    }

    i.snooze = function() {
        i.audio.snoozed = true;
        for(var u in notifications) {
            console.log("Snoozing: " + notifications[u].id);
            i.ignore(notifications[u].id);
        }
    }

    i.dismiss = function (notification) {
        var dismissFunction = function () {
            for (var n = notifications.length - 1; n >= 0; n--) {
                if (notifications[n].id === notification.id) {
                    notifications[n].dismissed = true;
                    i.changed.dismissed++;
                }
            }
        }

        var notificationsHandlers = moduleStore.notificationHandlers();

        if (notification.module && notificationsHandlers[notification.module].dismiss) {
            notificationsHandlers[notification.module].dismiss(notification, dismissFunction);
        } else {
            dismissFunction();
        }
    }

    i.view = function (notification) {

        var notificationsHandlers = moduleStore.notificationHandlers();

        if (notification.module && notificationsHandlers[notification.module].view) {
            notificationsHandlers[notification.module].view(notification);
        } else {
            alert("Viewing notifications not implemented for module " + notification.module);
        }
    }

    i.poll = function () {
        var notificationsHandlers = moduleStore.notificationHandlers();
        for (var k in notificationsHandlers) {
            if (notificationsHandlers[k].poll) {
                notificationsHandlers[k].poll();
            }
        }
    }
    
    i.ignore = function(notificationId) {
        i.ignored[notificationId] = true;
    }

    i.push = function (data, util) {
        var notificationsHandlers = moduleStore.notificationHandlers();
        for (var k in notificationsHandlers) {
            if (notificationsHandlers[k].push) {
                notificationsHandlers[k].push(data, util);
            }
        }
    }

    i.list = function () {
        return notifications;
    }
    i.undismissed = function () {
        var out = [];
        for (var n = 0; n < notifications.length; n++) {
            if (!notifications[n].dismissed) {
                out.push(notifications[n]);
            }
        }
        return out;
    }

    i.getSounds = function() {
        return sounds;
    }

    i.checkSoundData = function(soundData) {

        var ret = {
            redAlarmSound: {muted:false, sound:sounds[0]},
            orangeAlarmSound: {muted:false, sound:sounds[5]},
            greenAlarmSound: {muted:true, sound:sounds[9]},
            cpAlarmSound: {muted:false, sound:sounds[2]}
        }

        if(soundData && soundData["redAlarmSound"]){
            ret["redAlarmSound"] = soundData["redAlarmSound"];
        }

        if(soundData && soundData["orangeAlarmSound"]){
            ret["orangeAlarmSound"] = soundData["orangeAlarmSound"]
        }

        if(soundData && soundData["greenAlarmSound"]){
            ret["greenAlarmSound"] = soundData["greenAlarmSound"]
        }  

        if(soundData && soundData["cpAlarmSound"]){
            ret["cpAlarmSound"] = soundData["cpAlarmSound"]
        }      

        return ret;

    }

    /** Test code for custom notifications*/
    var customNotifications = false;
    var ceMetaKey = 'customNotifications';


    i.registerNotification = function(type, message, object, params) {
       if(!customNotifications) {
            customNotifications = utilService.checkNestedProperty(smarttrackerService.getUserData() ,'user', 'preferences', 'meta', ceMetaKey)?smarttrackerService.getUserData().user.preferences.meta[ceMetaKey]:[]
        }
        customNotifications = customNotifications?customNotifications:[];
        for(var i = 0; i < customNotifications.length;i++){
            var n = customNotifications[i];
            if(n.message == message &&(object&&n.object&&object.id===n.object.id)) {
                return; // Already added
            }
        }
        var ev = {
            createdDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"), 
            object:object, 
            type:type, 
            message:message, 
            messageValues:params
        };
        customNotifications.push(ev);
        saveCustomNotifications();
        i.changed.added++;
    }

    i.dismissCustomNotification = function(notification, preventSave) {
        var index = customNotifications.indexOf(notification);
        if(index > -1) {
            i.changed.dismissed++;
            customNotifications =customNotifications.length == 1?[]: customNotifications.splice(index, 1); // splice doesn't work for arrays with on element for some reason
            if(!preventSave) {
                saveCustomNotifications();
            }
        }
    }

    i.dismissCustomNotifiactionsForObject = function(object) {
        var cn = utilService.clone(customNotifications);
        angular.forEach(cn, function (notification){
            i.dismissCustomNotification(notification, true);
        });
        saveCustomNotifications();
        
    }
    var saveCustomNotifications = function() {
        var data = smarttrackerService.getUserData();
        if(data.user&&data.user.preferences&&data.user.preferences.meta) {
            data.user.preferences.meta[ceMetaKey] = customNotifications;
            smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/index", {user:data.user});
        }
    }

    i.customNotifications = function() {
        if(!customNotifications) {
            customNotifications = utilService.checkNestedProperty(smarttrackerService.getUserData() ,'user', 'preferences', 'meta', ceMetaKey)?smarttrackerService.getUserData().user.preferences.meta[ceMetaKey]:[]
        }
        return customNotifications;
    }

    i.notificationTypes = function() {
        return {
            invitation:{icon:'mdi mdi-account-switch', state:'secure.user', title:'NOTIFICATION_TYPE_INVITATION'}
        };
    }
    /** End Test code for custom notifications*/

    moduleStore.serviceRepository()["notificationService"] = i;
    return i;
});
angular.module('stwo.core').factory('favoritesService',
    function($localStorage) {


        // if favorites do not exist, create it
        if (!$localStorage.favorites) {
            $localStorage.favorites = {};
        }

        // at the end just take the favorites from the local storage
        var favorite = $localStorage.favorites;

        var i = {};

        i.favorites = function() {
            return favorite;
        }

        i.favoritesOfClazz = function(clazz) {
            if (!favorite[clazz]) {
                favorite[clazz] = {};
            }

            return favorite[clazz];
        }

        i.toggle = function(clazz, id) {
            // create any piece of favorites which does not exist
            if (!favorite[clazz]) {
                favorite[clazz] = {};
            }

            favorite[clazz][id] = !(true && favorite[clazz][id]);
        }

        i.isFavorite = function(clazz, id) {
            if (!favorite[clazz]) {
                favorite[clazz] = {};
            }

            return (true && $localStorage.favorites[clazz][id]);
        }

        //return the favorites of clazz as an array (use .join if string is needed)
        i.getListOfFavorites = function(clazz) {
            if (!favorite[clazz]) {
                favorite[clazz] = {};
            }

            var outArray = [];

            for (var k in favorite[clazz]) {
                if (favorite[clazz][k]) {
                    outArray.push(k);
                }
            }

            return outArray;
        }

        return i;
    });
angular.module('stwo.core').service('colorService', function () {

    return {
        toUpper: function (item) {
            return item.toUpperCase()
        },

        alarmColor: function (item) {

            // First one is the log level and the
            // second one is the class what needs to be added
            var danger = [
                    'red_alert',
                    'text-danger'
                ],
                warning = [
                    'warning',
                    'text-warning'
                ],
                success = [
                    'notification',
                    'text-success'
                ];

            if (item.logLevelFormatted == null) {
                return danger[1]
            }

            else {
                if (item.logLevelFormatted == success[0]) {
                    return success[1]
                }
                else if (item.logLevelFormatted == danger[0]) {
                    return danger[1]
                }
                else if (item.logLevelFormatted == warning[0]) {
                    return warning[1]
                }
            }
        },

        rangeColor: function (item) {
            var success = [
                    0, 15,
                    'text-success'
                ],
                warning = [
                    15, 40,
                    'text-warning'
                ],
                danger = [
                    'text-danger'
                ];

            if (item.logLevelFormatted == null) {
                if (item.lastValidPosition.source.type == 'beacon') {
                    return success[2]
                }
                 else {
                    if (item.lastValidPosition.accuracy > success[0] && item.lastValidPosition.accuracy <= success[1]) {
                        return success[2]
                    }
                    else if (item.lastValidPosition.accuracy > warning[0] && item.lastValidPosition.accuracy <= warning[1]) {
                        return warning [2]
                    }
                    else {
                        return danger[0]
                    }
                }
            }

            else {
                if (item.position.source.type == 'beacon') {
                    return success[2]
                }
                else {
                    if (item.position.accuracy > success[0] && item.position.accuracy <= success[1]) {
                        return success[2]
                    }
                    else if (item.position.accuracy > warning[0] && item.position.accuracy <= warning[1]) {
                        return warning [2]
                    }
                    else {
                        return danger[0]
                    }
                }
            }
        }
    };
});
angular.module('stwo.core').service('googlemapsService', function () {
    return {
        googleMaps: function (lat, lng, address) {

            var addressString = lat + ',' + lng;
            if (typeof address === 'string') {

                addressString = encodeURIComponent(address);

            }

            var isiOS = stwoPushNotificationInfo !== null && stwoPushNotificationInfo.type === 'IOS_DEVICE';

            if (isiOS || (/iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(navigator.userAgent) && !window.MSStream)) {

                console.log('opening Apple maps popup to', addressString)
                return window.location.assign('maps://maps.apple.com/maps?daddr=' + addressString + '&amp;ll=');
                
            } else {

                console.log('opening Google maps popup to', addressString)
                return window.location.assign('http://maps.google.com?daddr=' + addressString + '&amp;ll=');

            }
        }
    };
});
angular.module('stwo.core').service('indoorService', function () {

    return {
        toUpper: function (item) {
            return item.toUpperCase()
        },

        indoor: function (item) {
            var icons  = [
                'mdi-home',
                'mdi-earth'
            ]

            if (item.position.source == null) {
                return
            }

            else {
                if (item.position.source.type == 'beacon') {
                    return icons[0]
                }
                else {
                    return icons[1]
                }
            }
        }
    };
});
angular.module('stwo.core').factory('dialogService', function($modal) {

    var i = {};

    i.prompt = function(title, text, config) {
        var cfg = {title: title, text: text};

        for (var k in config) {
            cfg[k] = config[k];
        }


        return $modal.open({
            templateUrl: 'core/html/prompt.html',
            controller: stwoCoreDialogPromptModalController,
            size: "md",
            resolve: {
                promptConfiguration: function() { return cfg }
            }
        }).result;
    }

    i.raiseAlarm = function(title, text, config) {
        var cfg = {title:title, text:text};
        for (var k in config) {
            cfg[k] = config[k];
        }

        cfg["alarmType"] = "0";

        return $modal.open({
            templateUrl: 'core/html/raise_alarm.html',
            controller: stwoCoreDialogRaiseAlarmModalController,
            size: "md",
            resolve: {
                promptConfiguration: function() { return cfg }
            }
        }).result;
    }

    i.getPosition = function(title, text, config) {
        cfg = {title:title, text:text};
        angular.forEach(config, function (v, k) {
            cfg[k] = v;
        });
        console.log(cfg, config);
        return $modal.open({
            templateUrl: 'core/html/positionPicker.html', 
            controller: stwoCoreDialogPositionPickerModalController, 
            size:'lg', 
            resolve: {
                promptConfiguration: function() {return cfg;}
            }
        });
    }

    i.alert = function(title, text, config) {
        cfg = {title:title, text:text};
        angular.forEach(config, function (v, k) {
            cfg[k] = v;
        });
        return $modal.open({
            templateUrl: 'core/html/alertDialog.html', 
            controller: stwoDialogAlertModalController, 
            size:'md', 
            resolve: {
                configuration: function() {return cfg;}
            }
        }).result;
    }

    i.wait = function(title, text, config ) {
        var cfg = {title: title, text: text, showWaitButtons:false};

        for (var k in config) {
            cfg[k] = config[k];
        }
        return $modal.open({
            templateUrl: 'core/html/working.html',
            controller: stwoCoreDialogPromptModalController,
            size: "md",
            resolve: {
                promptConfiguration: function() { return cfg }
            }
        });
    }

    return i;
});

var stwoCoreDialogPromptModalController = function ($scope, $modalInstance, promptConfiguration) {

    $scope.title = promptConfiguration.title;
    $scope.text = promptConfiguration.text;
    $scope.multiline = promptConfiguration.multiline;
    $scope.disablePromptText = promptConfiguration.disablePromptText;
    $scope.nullAllowed = promptConfiguration.nullAllowed;
    $scope.prompt = {text: promptConfiguration.promptText ? promptConfiguration.promptText : ""};
    $scope.placeHolder = promptConfiguration.placeHolder ? promptConfiguration.placeHolder : "";

    $scope.cancelButtonText = promptConfiguration.cancelButtonText ? promptConfiguration.cancelButtonText : "DIALOG_PROMPT_CANCEL";
    $scope.cancelButton = promptConfiguration.cancelButton;

    $scope.okButtonText = promptConfiguration.okButtonText ? promptConfiguration.okButtonText : "DIALOG_PROMPT_OK";
    $scope.nullButtonText = promptConfiguration.nullButtonText ? promptConfiguration.nullButtonText : "DIALOG_PROMPT_NULL";

    $scope.emptyRestricted = promptConfiguration.emptyRestricted;

    $scope.deleteButtonText = promptConfiguration.deleteButtonText ? promptConfiguration.deleteButtonText : "DIALOG_PROMPT_DELETE";
    $scope.deleteButton = promptConfiguration.deleteButton;

    $scope.cancelDisallowed = promptConfiguration.cancelDisallowed;

    $scope.genericData = promptConfiguration.data;

    $scope.pickNull = function() {
        $modalInstance.close({data: $scope.genericData, promptText: null});
    }

    $scope.ok = function() {
        $modalInstance.close({data: $scope.genericData, promptText: $scope.prompt.text});
    }

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};



var stwoCoreDialogPositionPickerModalController = function($scope, $modalInstance, promptConfiguration, leafletData, mapService, $http, $timeout, addressService, smarttrackerService) {

    mapService.basicMapDesign($scope, leafletData);
    $scope.title = promptConfiguration.title;
    $scope.text = promptConfiguration.text;
    
    $scope.paths = [];
    
    $scope.TCAString = "";
    $scope.addressSelected = function(data) {
        var pos = data.point;
        $scope.map.setView(pos, 17);
        if($scope.marker){
            $scope.marker.setLatLng(pos);
        } else{
            createMarker(pos);
            $scope.marker.addTo($scope.map);
        }
        $scope.TCAString = data.TCAString;
    }
   

   var createMarker = function(loc){
        var micon = L.divIcon({
            type: 'div',
            iconAnchor: [18, 32],
            className: 'myleaflet-div-icon',
            html: '<div><div class="pin"><i class="mdi mdi-map-marker" style="color:color:#22b573"></i></div></div>'
        });
        $scope.marker = new L.Marker(loc, {icon:micon, draggable:true});
   }

        $scope.mapData = {
            center:{
                lat: 52.386617,
                lng: 5.799990,
                zoom: 8
            },
            defaults : {
               dragging: true,
               maxZoom: 21
           },
           events: {
               map: {
                   enable:['dragstart', 'zoomstart', 'click'], 
                   logic:'emit'
               }
           }
       };
    leafletData.getMap().then(function (map){
        $scope.map = map;
         var customerMapData = smarttrackerService.getUserData().customer.map.center;
         map.setView(new L.LatLng(promptConfiguration.position?promptConfiguration.position.latitude:customerMapData.latitude,
                promptConfiguration.position?promptConfiguration.position.longitude:customerMapData.longitude), customerMapData.zoom);
       
        console.log(promptConfiguration.position);
        console.log(smarttrackerService.getUserData());
       
        if(promptConfiguration.position) {
            var pos = promptConfiguration.position;
            var loc = new L.LatLng(pos.latitude, pos.longitude);
            createMarker(loc);
            $scope.marker.addTo(map);
        } 
        map.on('click', function mapClickListen(e){
            var loc = new L.LatLng(e.latlng.lat, e.latlng.lng);

            if($scope.marker){
                $scope.marker.setLatLng(loc);
            } else {
                createMarker(loc);
                $scope.marker.addTo(map);
            }
            addressService.addressByCoordinates(loc.lat, loc.lng).then(function (address){
                    //$scope.addressData.selectedAddress = address;
                    var a = address.address;
                    // Tellu Cloud Address String
                    $scope.TCAString = (a.road?a.road + " " :'') + (a.house_number?a.house_number:'') + ", " + a.county + ", " + a.postcode + ", " + a.country_code;
            }, function (error){
                console.error("Something went wrong when communicateing with address api", error);
            });
        });
        $timeout(function () {
            map.invalidateSize();
        }, 200);
    });

    $scope.ok = function() {
        var loc = $scope.marker.getLatLng();
        console.log(loc);
        $modalInstance.close({data:{position:loc, address:$scope.TCAString}});
    }

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    }
}

var stwoDialogAlertModalController = function($scope, $modalInstance, configuration) {
    $scope.title = configuration.title;
    $scope.text = configuration.text;
    $scope.okButtonText = configuration.okButtonText ? configuration.okButtonText : "DIALOG_PROMPT_OK";
    $scope.cancelButtonText = configuration.cancelButtonText ? configuration.cancelButtonText : 'DIALOG_PROMPT_CANCEL';
    $scope.cancelButton = configuration.cancelButton;

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    }

    $scope.ok = function() {
        $modalInstance.close({'title':$scope.title, 'text':$scope.text});
    }
}

var stwoCoreDialogRaiseAlarmModalController = function ($scope, $modalInstance, promptConfiguration) {

    $scope.title = promptConfiguration.title;
    $scope.text = promptConfiguration.text;
    $scope.multiline = true && promptConfiguration.multiline;
    $scope.disablePromptText = true && promptConfiguration.disablePromptText;
    $scope.nullAllowed = true && promptConfiguration.nullAllowed;
    $scope.prompt = {text: promptConfiguration.promptText ? promptConfiguration.promptText : "", alarmType:promptConfiguration.alarmType?promptConfiguration.alarmType:""};
    $scope.placeHolder = promptConfiguration.placeHolder ? promptConfiguration.placeHolder : "";
    $scope.cancelButtonText = promptConfiguration.cancelButtonText ? promptConfiguration.cancelButtonText : "DIALOG_PROMPT_CANCEL";
    $scope.okButtonText = promptConfiguration.okButtonText ? promptConfiguration.okButtonText : "DIALOG_PROMPT_OK";
    $scope.nullButtonText = promptConfiguration.nullButtonText ? promptConfiguration.nullButtonText : "DIALOG_PROMPT_NULL";

    $scope.genericData = promptConfiguration.data;

    $scope.pickNull = function() {
        $modalInstance.close({data: $scope.genericData, promptText: null});
    }

    $scope.ok = function() {
        $modalInstance.close({data: $scope.genericData, promptText: $scope.prompt.text, alarmType:$scope.prompt.alarmType});
    }

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};
angular.module('stwo.core').factory('decorationService', function(moduleStore) {

    var i = {};
    
    var decorations = [];
    var temporaryDecorations = [];
    var status = {downloading: false};
    var offset = 0;
    
    var colors = ["aqua", "aquamarine", "darkturquoise", "lightseagreen", "mediumaquamarine", "mediumturquoise", "paleturquoise", "turquoise", "aliceblue", "blue", "blueviolet", "cornflowerblue", "darkblue", "deepskyblue", "dodgerblue", "lightblue", "lightskyblue", "lightsteelblue", "mediumblue", "midnightblue", "navy", "powderblue", "royalblue", "skyblue", "steelblue", "bisque", "blanchedalmond", "brown", "burlywood", "chocolate", "cornsilk", "darkgoldenrod", "goldenrod", "maroon", "peru", "rosybrown", "saddlebrown", "sandybrown", "sienna", "tan", "wheat", "cadetblue", "cyan", "darkcyan", "lightcyan", "teal", "dimgray", "gray", "antiquewhite", "azure", "beige", "black", "darkgray", "darkgrey", "darkslategray", "darkslategrey", "dimgrey", "floralwhite", "gainsboro", "ghostwhite", "grey", "honeydew", "ivory", "lavenderblush", "lightgrey", "lightslategrey", "linen", "mintcream", "mistyrose", "navajowhite", "oldlace", "seashell", "silver", "slategray", "slategrey", "snow", "white", "whitesmoke", "chartreuse", "darkgreen", "darkolivegreen", "darkseagreen", "forestgreen", "green", "greenyellow", "lawngreen", "lightgreen", "lime", "limegreen", "mediumseagreen", "mediumspringgreen", "olive", "olivedrab", "palegreen", "seagreen", "springgreen", "yellowgreen", "lightgray", "lightslategray", "coral", "darkorange", "gold", "orange", "orangered", "tomato", "deeppink", "hotpink", "lightpink", "mediumvioletred", "palevioletred", "pink", "darkmagenta", "darkorchid", "darkslateblue", "darkviolet", "fuchsia", "indigo", "lavender", "magenta", "mediumorchid", "mediumpurple", "mediumslateblue", "orchid", "plum", "purple", "slateblue", "thistle", "violet", "crimson", "darkred", "darksalmon", "firebrick", "indianred", "lightcoral", "red", "salmon", "lightsalmon", "darkkhaki", "khaki", "lemonchiffon", "lightgoldenrodyellow", "lightyellow", "moccasin", "palegoldenrod", "papayawhip", "peachpuff", "yellow"];
    
    function changeCSS(sheetId, selector, property, value){
        var s = document.getElementById(sheetId).sheet;
        var rules = s.cssRules || s.rules;
        for(var i = rules.length - 1, found = false; i >= 0 && !found; i--){
            var r = rules[i];
            if(r.selectorText == selector){
                r.style.setProperty(property, value);
                found = true;
            }
        }
        if(!found){
            s.insertRule(selector + '{' + property + ':' + value + ';}', rules.length);
        }
    }
    
    for (var n = 0; n < colors.length; n++) {
        var tc = tinycolor(colors[n]);
        changeCSS("decoration-styles", '.decorative-color-' + colors[n],"background-color", colors[n]);
        changeCSS("decoration-styles", '.decorative-color-' + colors[n],"border-color", colors[n]);
        changeCSS("decoration-styles", '.decorative-color-' + colors[n],"color", 
                tinycolor.mostReadable(colors[n], ["#FFF"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString()
            );
    }
    
    i.colors = function() {
        return colors;
    }
    
    i.find = function(itemType, item, partType, specificPart) {
        if (itemType === "location") {
            if (item.connectedTo && item.connectedTo.length > 0) {
                for (var n = 0; n < item.connectedTo.length; n++) {
                    if (item.connectedTo[n].from.type === "asset" || item.connectedTo[n].from._type === "asset") {
                        return i.find("asset", item.connectedTo[n].from, partType, specificPart);
                    } else if (item.connectedTo[n].to.type === "asset" || item.connectedTo[n].to._type === "asset") {
                        return i.find("asset", item.connectedTo[n].to, partType, specificPart);
                    }
                }
            }
        } else {
            var effect = null;
            
            var mergeInDecoration = function(effect, decoration) {
                if (!effect) {
                    effect = {behaviour: null, color: null, image: null};
                }
                if (decoration.image && !effect.image) {
                    effect.image = decoration.image;
                }
                if (decoration.behaviour && !effect.behaviour) {
                    effect.behaviour = decoration.behaviour;
                }
                if (decoration.color && !effect.color) {
                    effect.color = decoration.color;
                }
                
                return effect;
            }
            
            for (var n = 0; n < decorations.length; n++) {
                var d = decorations[n];

                if (d.type === "tag" && item.tags && (!partType || partType === "tag")) {
                    for (var nt = 0; nt < item.tags.length; nt++) {
                        if (item.tags[nt].name === d.filter.value && (!partType || (!specificPart || specificPart === item.tags[nt].name))) {
                            effect = mergeInDecoration(effect, d);
                        }
                    }
                } else if (d.type === "property" && item.properties && (!partType || partType === "property")) {
                    for (var nt = 0; nt < item.properties.length; nt++) {
                        var p = item.properties[nt];

                        if (p.name === d.filter.key && (!partType || (!specificPart || specificPart.typePropertyIdentifier === p.typePropertyIdentifier))) {
                            if (angular.isDefined(p.numberValue) && p.numberValue !== null && !isNaN(p.numberValue)) {
                                if (d.filter.value !== null) {
                                    try {
                                        if (parseFloat(d.filter.value) === p.numberValue) {
                                            effect = mergeInDecoration(effect, d);
                                        }
                                    } catch (err) {

                                    }
                                }
                                if (d.filter.minimum === null && d.filter.maximum !== null) {
                                    if (p.numberValue <= d.filter.maximum) {
                                        effect = mergeInDecoration(effect, d);
                                    }
                                } else if (d.filter.minimum !== null && d.filter.maximum === null) {
                                    if (p.numberValue >= d.filter.minimum) {
                                        effect = mergeInDecoration(effect, d);
                                    }
                                } else if (d.filter.minimum !== null && d.filter.maximum !== null) {
                                    if (p.numberValue >= d.filter.minimum && p.numberValue <= d.filter.maximum) {
                                        effect = mergeInDecoration(effect, d);
                                    }
                                }
                            }
                            if (angular.isDefined(p.value) && p.value !== null) {
                                if (d.filter.value === p.value) {
                                    effect = mergeInDecoration(effect, d);
                                }
                            }
                        }
                    }
                } else if (d.type === "battery" && (!partType || partType === "battery")) {
                    if (item.battery || item.battery === 0) {
                        if (d.filter.minimum === null && d.filter.maximum !== null) {
                            if (item.battery <= d.filter.maximum) {
                                effect = mergeInDecoration(effect, d);
                            }
                        } else if (d.filter.minimum !== null && d.filter.maximum === null) {
                            if (item.battery >= d.filter.minimum) {
                                effect = mergeInDecoration(effect, d);
                            }
                        } else if (d.filter.minimum !== null && d.filter.maximum !== null) {
                            if (item.battery >= d.filter.minimum && item.battery <= d.filter.maximum) {
                                effect = mergeInDecoration(effect, d);
                            }
                        }
                    }
                }
            }
            
            return effect;
        }
    }
    
    i.decorations = function() {
        return decorations;
    }
    
    i.status = function() {
        return status;
    }
    
    i.refresh = function() {
        if (status.downloading) {
            return;
        } else {
            status.downloading = true;
            temporaryDecorations = [];
        }
        
        var sts = moduleStore.serviceRepository()["smarttrackerService"];
        
        var max = 100;
        sts.authGet(sts.getCustomerId() + '/decoration?select=*&max=' + max + "&offset=" + offset + "&sort=priority&order=desc", {onErrorDoNotRedirect: true}).then(function(response) {
            if (response && response.data && response.data.result) {
                for (var n = 0; n < response.data.result.length; n++) {
                    temporaryDecorations.push(response.data.result[n]);
                }

                if (response.data.result.length >= max) {
                    offset += max;
                    downloadDecorations();
                } else {
                    status.downloading = false;
                    decorations.splice(0, decorations.length);
                    for (var n = 0; n < temporaryDecorations.length; n++) {
                        decorations.push(temporaryDecorations[n]);
                    }
                }
            } else {
                status.downloading = false;
            }
            
        }, function() {
            status.downloading = false;
        });
    }
        
    moduleStore.serviceRepository()["decorationService"] = i;
    return i;
});
angular.module('stwo.core').factory('deploymentApiService', function($http, moduleStore) {

    // init
    var i = {};
    var config = {
        base: stwoGlobal.deploymentApiUrl,
    }

    // post
    i.post = function(path, data){

        return i.request('POST', path, data);

    }

    // get
    i.get = function(path, data){

        return i.request('GET', path, data);

    }

    // delete
    i.delete = function(path, data){

        return i.request('DELETE', path, data);

    }

    // request
    i.request = function(method, path, data) {
        return $http({
            method : method,
            url : config.base + path,
            headers : {
                "X-Auth-Token" : localStorage.getItem('authToken'),
            },
            data: data,
        })
    }

    moduleStore.serviceRepository()["deploymentApiService"] = i;
    return i;

});


angular.module('stwo.core').directive("indoorLocationViewer", function ($injector, $modal, $timeout, smarttrackerService, indoorLocationViewerDataService, indoorLocationViewerRenderService)
  {
    return {
        restrict: 'EA',
        scope: {
            data: '='
        },
        /*
        template: "<canvas width='800' height='400'  ondragstart='return false;' ondrop='return false;' background-color: #F00'></canvas>" + 
                "<div class='canvas-controls'>" +
                '<a href="" class="btn btn-lg btn-default" ng-click="zoomIn()"><i class="fa fa-plus"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="zoomOut()"><i class="fa fa-minus"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="pickFloor()"><i class="fa fa-building"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="fitToModel()"><i class="fa fa-arrows-alt"></i></a>' +
                "</div>" + 
                "<div class='canvas-info'>" + '<h4>{{data.basePath}}</h4>' + "</div>" + 
                "<div class='canvas-markers'>" + 
                    '<div ng-repeat="marker in indoorMarkers" ng-click="markerClick(marker)" class="indoor-marker" ng-class="(marker._cluster.index || marker._cluster.index === 0) ? \'cluster cluster-index-\' + marker._cluster.index : \'not-cluster\'" style="left: {{marker.position.px}}px; top: {{marker.position.py}}px;">' +
                    '<span class="marker-name">{{marker.marker.name }}</span>'+
                    '&nbsp;<span class="marker-location">{{marker.marker.lastValidPosition.location.name }}</span>' +
                    '<span class="marker-decorations" ng-class="(marker._decoration ? \'has-decoration \' : \'no-decoration \') + (marker.marker.image ? \'has-asset-image\' : \'no-asset-image\')">' +
                        '<span ng-style="{\'background-image\': \'url(\' + marker._decoration.image + \')\'}" ng-if="marker._decoration" class="marker-decoration" ng-class="marker._decoration && marker._decoration.color ? \'decorative-color decorative-color-\' + marker._decoration.color : \'\'"></span>' +
                        '<span ng-style="{\'background-image\': \'url(\' + marker.marker.image + \')\'}" ng-if="marker.marker.image" class="marker-asset-image"></span>' +
                    '</span>' +
                    '</div>' +
                "</div>",
        */
       
        template: "<canvas width='800' height='400'  ondragstart='return false;' ondrop='return false;' background-color: #F00'></canvas>" + 
                "<div class='canvas-controls'>" +
                '<a href="" class="btn btn-lg btn-default" ng-click="zoomIn()"><i class="fa fa-plus"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="zoomOut()"><i class="fa fa-minus"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="pickFloor()"><i class="fa fa-building"></i></a>' +
                '<a href="" class="btn btn-lg btn-default" ng-click="fitToModel()"><i class="fa fa-arrows-alt"></i></a>' +
                "</div>" + 
                "<div class='canvas-info'>" + '<h4>{{data.basePath}}</h4>' + "</div>" + 
                "<div class='canvas-markers'>" + 
                    '<div ng-repeat="cluster in clusteredMarkers" class="indoor-cluster" ng-class="(cluster.selected ? \' marker-in-cluster-selected\' : \' marker-in-cluster-not-selected\') + (cluster.hovered ? \' marker-in-cluster-hovered\' : \' marker-in-cluster-not-hovered\')" ng-attr-style="left: {{cluster.position.px}}px; top: {{cluster.position.py}}px;">' +
                        '<div ng-repeat="marker in cluster.markers" ng-click="markerClick(marker)" class="indoor-marker">' +
                            '<span class="marker-decorations" ng-class="(marker._decoration ? \'has-decoration \' : \'no-decoration \') + (marker.marker.image ? \'has-asset-image\' : \'no-asset-image\')">' +
                                '<span ng-style="marker._decoration.image ? {\'background-image\': \'url(\' + marker._decoration.image + \')\'} : \'\'" ng-if="marker._decoration" class="marker-decoration" ng-class="marker._decoration && marker._decoration.color ? \'decorative-color decorative-color-\' + marker._decoration.color : \'\'"></span>' +
                                '<span ng-style="{\'background-image\': \'url(\' + marker.marker.image + \')\'}" ng-if="marker.marker.image" class="marker-asset-image"></span>' +
                            '</span>' +
                            '<i style="{{marker.marker.markerStrokeColor ? \'color:\' + marker.marker.markerStrokeColor : \'\' }}" class="marker-alarm-indicator fa fa-bell" ng-if="marker.marker.logLevel || marker.marker.logLevel === 0"></i>' +
                            '<span class="marker-name">{{marker.marker.name }}</span>'+
                            '<span class="marker-location">{{marker.markerPosition.location.name }}</span>' +
                        '</div>' +
                    '</div>' +
                "</div>",
        link: function(scope, element, attrs) {
            
            scope.zoomIn = function() {
                rx.ppm *= 1.5;
                drawModel();
            }
            scope.zoomOut = function() {
                rx.ppm *= 0.66667;
                if (rx.ppm < 2) {
                    rx.ppm = 2;
                }
                drawModel();
            }
            scope.fitToModel = function() {
                indoorLocationViewerDataService.calculateBoundingBox(rx, mx);
                indoorLocationViewerDataService.fitToBoundingBox(rx, mx, mx.boundingBox);
                scope.zoomOut();
                drawModel();
            }
            scope.pickFloor = function() {
                var floors = [];
                
                var findFloors = function(l, floorList) {
                    if (l.id && l.structureType === "floor") {
                        floorList.push(l);
                    }
                    if (l._children) {
                        for (var n = 0; n < l._children.length; n++) {
                            findFloors(l._children[n], floorList);
                        }
                    }
                }
                
                findFloors(mx.hierarchy, floors);
                
                floors.sort(function(a, b) {
                    if (a.path < b.path)
                        return -1;
                    if (a.path > b.path)
                        return 1;
                    return 0;
                })
                
                var modalInstance = $modal.open({
                    templateUrl: 'core/js/indoorViewer/indoor-location-floor-picker-modal.html',
                    controller: stwoCoreIndoorLocationFloorPickerModalController,
                    size: "lg",
                    resolve: {
                        floors: function() { return floors }
                    }
                });

                modalInstance.result.then(function (data) {
                    console.log("new floor", data.floor);
                    
                    mx.baseLocation = data.floor ? data.floor : mx.hierarchy;
                    mx.rawData.basePath = data.floor ? data.floor.path : '';
                    indoorLocationViewerDataService.calculateBoundingBox(rx, mx);
                    indoorLocationViewerDataService.fitToBoundingBox(rx, mx, mx.boundingBox);

                }, function() {

                });
            }

            var dx = {progress: 0, error: null};
            
            var rx = {ctx: element.find('canvas')[0].getContext('2d'),
                        canvas: element.find('canvas')[0],
                        ppm: 10, centeredOnFirstMarkers: false,
                        center: {x: 0, y: 0}};
            
            var mx = {locationsWithMarkers: {},
                        locationsById: {},
                        hierarchy: {_children: []},
                        baseLocation: null,
                        processedMarkers: {},
                        clusteredMarkers: {},
                        locationModelReady: false,
                        boundingBox: null,
                        rawData: scope.data
                    };
            mx.baseLocation = mx.hierarchy;
            
            scope.indoorMarkers = mx.processedMarkers;
            scope.clusteredMarkers = mx.clusteredMarkers;
            
            var lastMousePosition = {x: 0, y: 0};
            
            var tappedMarker = null;
            
            var updateDimension = function() {
                $(rx.canvas)[0].width = $(rx.canvas).parent().width();
                $(rx.canvas).css("width", $(rx.canvas).parent().width() + "px");
                $(rx.canvas)[0].height = $(rx.canvas).parent().height();
                $(rx.canvas).css("height", $(rx.canvas).parent().height() + "px");
                drawModel();
            }
            
            var drawModel = function() {
                var now = (new Date()).getTime();
                var ctx = rx.ctx;
                if (!mx.locationModelReady) {
                    if (dx.error) {
                        ctx.fillStyle = "#00F";
                        ctx.fillRect(0, 0, rx.canvas.width, rx.canvas.height);
                        ctx.fillStyle = "#FFF";
                        ctx.fillText(dx.error,10,20);
                    } else if (dx.progress === 0) {
                        ctx.fillStyle = "#0F0";
                        ctx.fillRect(0, 0, rx.canvas.width, rx.canvas.height);
                        ctx.fillStyle = "#FFF";
                        ctx.fillRect(2, 2, rx.canvas.width - 4, rx.canvas.height - 4);

                        ctx.fillStyle = "#0F0";
                        ctx.fillRect(4, rx.canvas.height - 4, dx.progress * (rx.canvas.width - 8), 20);
                        ctx.fillText("Waiting to download...",10,20);
                    } else {
                        ctx.fillStyle = "#00F";
                        ctx.fillRect(0, 0, rx.canvas.width, rx.canvas.height);
                        ctx.fillStyle = "#FFF";
                        ctx.fillRect(2, 2, rx.canvas.width - 4, rx.canvas.height - 4);

                        ctx.fillStyle = "#00F";
                        ctx.fillRect(4, rx.canvas.height - 24, dx.progress * (rx.canvas.width - 8), 20);
                        ctx.fillText("Downloading...",10,20);
                    }
                } else {
                    ctx.save();
                        ctx.fillStyle = "#FFF";
                        ctx.fillRect(0, 0, rx.canvas.width, rx.canvas.height);

                        
                        ctx.translate(rx.canvas.width / 2, rx.canvas.height / 2);
                        ctx.translate(rx.center.x * rx.ppm, rx.center.y * rx.ppm);
                        
                        for (var n = 0; n < mx.hierarchy._children.length; n++) {
                            indoorLocationViewerRenderService.overlay(rx, mx.hierarchy._children[n]);
                        }
                        indoorLocationViewerRenderService.grid(rx);

                        if (mx.baseLocation.id) {
                            indoorLocationViewerRenderService.location(rx, mx, false, mx.baseLocation);
                        } else {
                            for (var n = 0; n < mx.baseLocation._children.length; n++) {
                                indoorLocationViewerRenderService.location(rx, mx, false, mx.baseLocation._children[n]);
                            }
                        }
                        if (mx.baseLocation.id) {
                            indoorLocationViewerRenderService.location(rx, mx, true, mx.baseLocation);
                        } else {
                            for (var n = 0; n < mx.baseLocation._children.length; n++) {
                                indoorLocationViewerRenderService.location(rx, mx, true, mx.baseLocation._children[n]);
                            }
                        }
                        
                        for (var markerId in mx.processedMarkers) {
                            indoorLocationViewerRenderService.marker(rx, mx, mx.processedMarkers[markerId]);
                        }
                        
                    ctx.restore();
                }
            }
            
            scope.data.centerOnLocationId = function(locationId) {
                indoorLocationViewerDataService.updateCenterLocation(rx, mx, locationId);
                drawModel();
            }
            
            scope.$watch("data.location", function(newVal) {
                indoorLocationViewerDataService.updateCenterLocation(rx, mx, newVal);
                drawModel();
            });
            
            scope.$watch("data.state.selected.id", function(newVal) {
                indoorLocationViewerDataService.processMarkers(rx, mx);
            });
            scope.$watch("data.state.hovered.id", function(newVal) {
                console.log("hovered change", newVal)
                indoorLocationViewerDataService.processMarkers(rx, mx);
            });
            
            indoorLocationViewerDataService.updateCenterLocation(rx, mx, mx.rawData.location);
            
            var findMarkerUnderMouse = function(x, y) {
                /*
                x = x * rx.ppm + rx.center.x * rx.ppm + rx.canvas.width  / 2;
                y = y * rx.ppm + rx.center.x * rx.ppm + rx.canvas.height  / 2;
                */
                
                var distanceTo = function(x, y, ox, oy) {
                    return Math.sqrt(Math.pow(x - ox, 2) + Math.pow(y - oy, 2));
                }
                var closest = null;
                var distance = 99999999;
                for (var markerId in mx.processedMarkers) {
                    var m = mx.processedMarkers[markerId];
                    var d = distanceTo(x, y, m.position.px, m.position.py);
                    
                    if (d < 30 && d < distance) {
                        closest = m;
                        distance = d;
                    }
                }
                if (closest) {
                    return closest;
                }
            }
            
            scope.markerClick = function(m) {
                mx.rawData.onMarkerClick(m.marker._marker ? m.marker._marker : m.marker);
            }
            
            var initialize = function(baseUrl, token, customerId) {
                    console.log("indoorLocationViewerDirective", "token", token);
                    console.log("indoorLocationViewerDirective", "customerId", customerId);
                    indoorLocationViewerDataService.downloadModel(rx, mx, dx, baseUrl, token, customerId);
                    drawModel();
                    
                    element.bind('mousedown', function (e) {
                        if (e.which > 0) {
                            lastMousePosition.x = e.offsetX;
                            lastMousePosition.y = e.offsetY;
                            
                            var m = findMarkerUnderMouse(lastMousePosition.x, lastMousePosition.y);
                            if (m && mx.rawData.onMarkerClick) {
                                mx.rawData.onMarkerClick(m.marker._marker ? m.marker._marker : m.marker);
                            }
                            
                        }
                    });
                    element.bind('mousemove', function (e) {
                        
                        if ((!angular.isDefined(e.buttons) && e.which) || (e.buttons && e.buttons > 0)) {
                            rx.center.x += (e.offsetX - lastMousePosition.x) / rx.ppm;
                            rx.center.y += (e.offsetY - lastMousePosition.y) / rx.ppm;
                            e.preventDefault();
                            drawModel();
                        }
                        
                        lastMousePosition.x = e.offsetX;
                        lastMousePosition.y = e.offsetY;
                        
                        var m = findMarkerUnderMouse(lastMousePosition.x, lastMousePosition.y);
                        if (m) {
                            if (!scope.data.state.hovered || scope.data.state.hovered !== m.marker) {
                                $timeout(function() {
                                    scope.data.state.hovered = m.marker;
                                    indoorLocationViewerDataService.processMarkers(rx, mx);
                                })
                            }
                        } else {
                            if (scope.data.state.hovered) {
                                $timeout(function() {
                                    scope.data.state.hovered = null;
                                    indoorLocationViewerDataService.processMarkers(rx, mx);
                                })
                            }
                        }
                    });
                    element.bind('touchstart', function (e) {
                        if (e.touches.length > 0 && e.touches[0].target.tagName === "CANVAS") {
                            lastMousePosition.x = e.touches[0].offsetX;
                            lastMousePosition.y = e.touches[0].offsetY;
                        }
                        e.offsetX = e.targetTouches[0].pageX - e.touches[0].target.clientTop;
                        e.offsetY = e.targetTouches[0].pageY - e.touches[0].target.clientLeft;
                        tappedMarker = findMarkerUnderMouse(lastMousePosition.x, lastMousePosition.y);
                    });
                    element.bind('touchend', function (e) {
                        if (e.touches.length > 0 && e.touches[0].target.tagName === "CANVAS") {
                            lastMousePosition.x = e.touches[0].offsetX;
                            lastMousePosition.y = e.touches[0].offsetY;
                            
                            e.offsetX = e.targetTouches[0].pageX - e.touches[0].target.clientTop;
                            e.offsetY = e.targetTouches[0].pageY - e.touches[0].target.clientLeft;
                            var touchMarker = findMarkerUnderMouse(lastMousePosition.x, lastMousePosition.y);
                            if (tappedMarker && touchMarker && touchMarker === tappedMarker) {
                                if (mx.rawData.onMarkerClick) {
                                    mx.rawData.onMarkerClick(touchMarker.marker);
                                }
                            }
                        }
                    });
                    element.bind('touchmove', function (e) {
                        if (e.touches.length > 0 && e.touches[0].target.tagName === "CANVAS") {
                            rx.center.x += (e.touches[0].offsetX - lastMousePosition.x) / rx.ppm;
                            rx.center.y += (e.touches[0].offsetY - lastMousePosition.y) / rx.ppm;
                            e.preventDefault();
                            drawModel();
                        
                            lastMousePosition.x = e.touches[0].offsetX;
                            lastMousePosition.y = e.touches[0].offsetY;
                            
                            e.offsetX = e.targetTouches[0].pageX - e.touches[0].target.clientTop;
                            e.offsetY = e.targetTouches[0].pageY - e.touches[0].target.clientLeft;
                            
                            var touchMarker = findMarkerUnderMouse(lastMousePosition.x, lastMousePosition.y);
                            if (!touchMarker || touchMarker !== tappedMarker) {
                                tappedMarker = null;
                            }
                        }
                    });
                    
                    indoorLocationViewerDataService.processMarkers(rx, mx);
            
                    scope.$watch("data.changeCounter", function() {
                        indoorLocationViewerDataService.processMarkers(rx, mx);
                        drawModel();
                    });
                    scope.$watch("data.drawCounter", function() {
                        drawModel();
                    });
            }
            
            scope.data.drawCounter = 0;
            if ($injector.has("moduleStore")) {
                var moduleStore = $injector.get("moduleStore");
                moduleStore.serviceRepository()["smarttrackerService"].isLoggedInDelayed().then(function() {
                    var customerId = moduleStore.serviceRepository()["smarttrackerService"].getCustomerId(); 
                    var token = moduleStore.serviceRepository()["smarttrackerService"].getToken(); 
                    var baseUrl  = moduleStore.serviceRepository()["smarttrackerService"].url(); 
                    if (customerId && token) {
                        initialize(baseUrl, token, customerId);
                    }
                });
            }
            
            drawModel();
            
            updateDimension();
            $(window).resize(updateDimension);
            
            
            // shim layer with setTimeout fallback
            var requestAnimFrame = (function(){
              return  window.requestAnimationFrame       ||
                      window.webkitRequestAnimationFrame ||
                      window.mozRequestAnimationFrame    ||
                      function( callback ){
                        window.setTimeout(callback, 1000 / 30);
                      };
            })();


            // usage:
            // instead of setInterval(render, 16) ....
            
            var keepAnimating = true;
            scope.$on('$destroy', function() {
                keepAnimating = false;
            });
            var animate = function() {
                if (!keepAnimating) {
                    return;
                }
                drawModel();
                requestAnimFrame(function() {
                    animate();
                });
            }
                    animate();
            // place the rAF *before* the render() to assure as close to
            // 60fps with the setTimeout fallback.
        }        
    };
});
angular.module('stwo.core').factory('indoorLocationViewerDataService', function($http, pushService, decorationService) {
    
    var i = {};
    
    var assetsConnectedToLocations = {};
    
    /*
     * 
                        if (mx.baseLocation.id) {
                            indoorLocationViewerRenderService.location(rx, mx, true, mx.baseLocation);
                        } else {
                            for (var n = 0; n < mx.baseLocation._children.length; n++) {
                                indoorLocationViewerRenderService.location(rx, mx, true, mx.baseLocation._children[n]);
                            }
                        }
     */
    
    i.calculateBoundingBox = function(r, m, location, box) {
        if (!location) {
            location = m.baseLocation;
        }
        if (!box) {
            m.boundingBox = {left: 9999999, right: -9999999, top: 9999999, bottom: -9999999};
            box = m.boundingBox;
        }
        
        var shell = i.getShellRecursive(location);
        if (location && shell && shell.length) {
            for (var n = 0; n < shell.length; n++) {
                var p = i.calculateBasePosition(r, m, location, shell[n].x, shell[n].y)
                box.left = Math.min(box.left, p.x);
                box.right = Math.max(box.right, p.x);
                box.top = Math.min(box.top, p.y);
                box.bottom = Math.max(box.bottom, p.y);
            }
        }
        if (location && location._children) {
            for (var ln = 0; ln < location._children.length; ln++) {
                i.calculateBoundingBox(r, m, location._children[ln], box)
            }
        }
    }
    
    i.fitToBoundingBox = function(r, m, box) {
        var cx = -(box.left + box.right) / 2;
        var cy = -(box.top + box.bottom) / 2;
        
        var width = Math.abs(box.left - box.right);
        var height = Math.abs(box.bottom - box.top);
        
        r.center.x = cx;
        r.center.y = cy;
        
        r.ppm = Math.min((r.canvas.width - 40) / width, (r.canvas.height - 40) / height);
    }
    
    i.pushHandler = function(data, util) {
        if (data && data.object && data.object.type === "asset" && assetsConnectedToLocations[data.object.info.id]) {
            util.mergeState(assetsConnectedToLocations[data.object.info.id], data.object.info)
        }
    }
    
    pushService.listen(i.pushHandler);
    
    i.getShellRecursive = function(location) {
        if (location && location.shape && location.shape.shell && location.shape.shell.length > 2) {
            return location.shape.shell;
        } else {
            if (location._parent) {
                return i.getShellRecursive(location._parent);
            } else {
                return null;
            }
        }
    }
                
    i.getHeightRecursive = function(location) {
        if (location && location.shape && location.shape.height) {
            return location.shape.height;
        } else {
            if (location._parent) {
                return i.getHeightRecursive(location._parent);
            } else {
                return null;
            }
        }
    }
    i.getHolesRecursive = function(location) {
        if (location && location.shape) {
            if (location.shape.holes && location.shape.holes.length > 0) {
                return location.shape.holes;
            } else {
                return null;
            }
        } else {
            if (location._parent) {
                return i.getHolesRecursive(location._parent);
            } else {
                return null;
            }
        }
    }
            
            
    i.updateCenterLocation = function(r, m, newVal) {
        if (newVal && m.locationsById[newVal]) {
            
            if (m.baseLocation.id) {
                var potentialFloor = m.locationsById[newVal];
                
                while (potentialFloor && potentialFloor.id) {
                    if (potentialFloor.structureType === "floor") {
                        break;
                    } else {
                        potentialFloor = potentialFloor._parent;
                    }
                }
                if (potentialFloor.structureType === "floor") {
                    m.baseLocation = potentialFloor;
                } else {
                    m.baseLocation = m.hierarchy;
                }
            }
            
            console.log("Center on ", m.locationsById[newVal])

            var newPosition = {x: 0, y: 0};

            var shell = i.getShellRecursive(m.locationsById[newVal]);
            if (shell) {
                var p = {x: 0, y: 0};
                var c = 0;
                for (var n = 0; n < shell.length; n++) {
                    c++;
                    p.x += shell[n].x;
                    p.y += shell[n].y;
                }
                newPosition.x = p.x / c;
                newPosition.y = p.y / c;

                var p = i.calculateBasePosition(r, m, m.locationsById[newVal], newPosition.x, newPosition.y);
                newPosition.x = p.x;
                newPosition.y = p.y;

                r.center.x = -newPosition.x;
                r.center.y = -newPosition.y;
            }
        }
    }
            
    i.calculateBasePosition = function(r, m, location, x, y, skipTransformForParent) {


        var p = {x: x, y: y};

        if (!skipTransformForParent) {

            if (location.transformation && location.transformation.rotation && location.transformation.rotation !== 0) {
                var m = Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
                var r = Math.atan2(p.y, p.x);
                r += ((location.transformation.rotation / 180) * Math.PI);
                p.x = Math.cos(r) * m;
                p.y = Math.sin(r) * m;
            }
            if (location.transformation &&
                    location.transformation.coordinate &&
                    (location.transformation.coordinate.x !== 0 || location.transformation.coordinate.y !== 0 || location.transformation.coordinate.z !== 0)) {
                p.x += location.transformation.coordinate.x;
                p.y += location.transformation.coordinate.y;
                p.z += location.transformation.coordinate.z;
            }
        }



        if (location && location._parent && (!m.baseLocation || location._parent.locationId !== m.baseLocation.locationId)) {
            p = i.calculateBasePosition(r, m, location._parent, p.x, p.y);
        }

        return p;
    }
            
    i.processMarkers = function(r, m) {
        for (var markerId in m.locationsWithMarkers) {
            delete m.locationsWithMarkers[markerId];
        }

        var markerFound = {};

        for (var markerId in m.rawData.markers) {

            var a = m.rawData.markers[markerId];
            
            var markerPosition = (a.logLevel || a.logLevel === 0) ? a.position : a.lastValidPosition;
            
            if (markerPosition && markerPosition.location &&
                markerPosition.location.locationId &&
                m.locationsById[markerPosition.location.locationId]) {


                markerFound[markerId] = true;
                var createdThisProcess = false;

                if (!m.processedMarkers[markerId]) {
                    m.processedMarkers[markerId] = {};
                    m.processedMarkers[markerId].position = {};
                    createdThisProcess = true;
                }
                m.processedMarkers[markerId].marker = a;

                var newPosition = {locationId: markerPosition.location.locationId, x: markerPosition.coordinate.x, y: markerPosition.coordinate.y};

                if (newPosition.x === 0 && newPosition.y === 0) {
                    var shell = i.getShellRecursive(m.locationsById[markerPosition.location.locationId]);
                    if (shell) {
                        var p = {x: 0, y: 0};
                        var c = 0;
                        for (var n = 0; n < shell.length; n++) {
                            c++;
                            p.x += shell[n].x;
                            p.y += shell[n].y;
                        }
                        newPosition.x = p.x / c;
                        newPosition.y = p.y / c;
                    }
                }

                var p = i.calculateBasePosition(r, m, m.locationsById[markerPosition.location.locationId], newPosition.x, newPosition.y);
                newPosition.x = p.x;
                newPosition.y = p.y;
                m.processedMarkers[markerId].markerStrokeColor = a.markerStrokeColor;
                m.processedMarkers[markerId].markerPosition = markerPosition;

                if (createdThisProcess) {
                    console.log("new marker", a);
                    if (!m.locationsWithMarkers[markerPosition.location.locationId]) {
                        m.locationsWithMarkers[markerPosition.location.locationId] = {};
                    }
                    m.locationsWithMarkers[markerPosition.location.locationId][markerId] = a;

                    m.processedMarkers[markerId].position.locationId = newPosition.locationId;
                    m.processedMarkers[markerId].position.x = newPosition.x;
                    m.processedMarkers[markerId].position.y = newPosition.y;
                    m.processedMarkers[markerId].position.time = (new Date()).getTime();
                    m.processedMarkers[markerId].previousPosition = angular.fromJson(angular.toJson(m.processedMarkers[markerId].position));

                } else if (m.processedMarkers[markerId]) {
                    if (angular.toJson(newPosition) === angular.toJson(m.processedMarkers[markerId].position)) {
                        console.log("same position");
                    } else {
                        console.log("new position");
                        if (m.locationsWithMarkers[m.processedMarkers[markerId].locationId]) {
                            delete m.locationsWithMarkers[m.processedMarkers[markerId].locationId][markerId];
                        }
                        if (!m.locationsWithMarkers[newPosition.locationId]) {
                            m.locationsWithMarkers[newPosition.locationId] = {};
                        }
                        m.locationsWithMarkers[newPosition.locationId][markerId] = a;

                        m.processedMarkers[markerId].previousPosition = angular.fromJson(angular.toJson(m.processedMarkers[markerId].position));
                        m.processedMarkers[markerId].position.locationId = newPosition.locationId;
                        m.processedMarkers[markerId].position.x = newPosition.x;
                        m.processedMarkers[markerId].position.y = newPosition.y;
                        m.processedMarkers[markerId].position.time = (new Date()).getTime();
                    }
                }
                

                m.processedMarkers[markerId]._decoration = decorationService.find("asset", m.processedMarkers[markerId].marker);
                console.log("DECO FOR " + m.processedMarkers[markerId].marker.name, m.processedMarkers[markerId].marker , m.processedMarkers[markerId]._decoration)
            }
            


            
            if (m.processedMarkers[markerId] && markerPosition && !markerPosition.location) {
                if (m.locationsWithMarkers[newPosition.locationId]) {
                    delete m.locationsWithMarkers[newPosition.locationId][markerId];
                }
                delete m.processedMarkers[markerId];
                console.log("remove marker");
            }
        }


        for (var markerId in m.processedMarkers) {
            if (!markerFound[markerId]) {
                delete m.processedMarkers[markerId];
            }
        }
        
        var markersPerSpot = {};
        var spotToString = function(marker) {
            return marker.position.locationId + "-" + marker.position.x + "-" + marker.position.y
            
        }
        for (var clusterId in m.clusteredMarkers) {
            delete m.clusteredMarkers[clusterId]
        }
        for (var markerId in m.processedMarkers) {
            var s = spotToString(m.processedMarkers[markerId]);
            if (!markersPerSpot[s]) {
                markersPerSpot[s] = [];
                m.clusteredMarkers[s] = {selected: false, hovered: false, position: m.processedMarkers[markerId].position, markers: markersPerSpot[s]};
            }
            markersPerSpot[s].push(m.processedMarkers[markerId]);
            
            if (m.rawData.state.selected && m.processedMarkers[markerId].marker.id === m.rawData.state.selected.id ) {
                m.clusteredMarkers[s].selected = true;
            }
            if (m.rawData.state.hovered && m.processedMarkers[markerId].marker.id === m.rawData.state.hovered.id ) {
                m.clusteredMarkers[s].hovered = true;
            }
        }
        
        for (var spotId in markersPerSpot) {
            if (markersPerSpot[spotId].length > 1) {
                var meanC = {x: 0, y: 0};
                for (var n = 0; n < markersPerSpot[spotId].length; n++) {
                    meanC.x += markersPerSpot[spotId][n].position.x;
                    meanC.y += markersPerSpot[spotId][n].position.y;
                }
                for (var n = 0; n < markersPerSpot[spotId].length; n++) {
                    markersPerSpot[spotId][n]._cluster = {index: n, x: meanC.x / markersPerSpot[spotId].length, y: meanC.y / markersPerSpot[spotId].length};
                }
            } else {
                for (var n = 0; n < markersPerSpot[spotId].length; n++) {
                    delete markersPerSpot[spotId][n]["_cluster"];
                }
            }
        }
        
        // console.log("clusters", m.clusteredMarkers, m.rawData.state.selected, m.rawData.state.hovered);
    }
    
            
    i.postProcess = function(r, m, flatList) {

        for (var n = 0; n < flatList.length; n++) {
            m.locationsById[flatList[n].locationId] = flatList[n];
            m.locationsById[flatList[n].locationId]._children = [];
        }

        for (var n = 0; n < flatList.length; n++) {
            var l = flatList[n];
            if (m.locationsById[l.parentLocationId]) {
                l._parent = m.locationsById[l.parentLocationId];
                l._parent._children.push(l);
            } else {
                l._parent = null;
                m.hierarchy._children.push(l);
            }
            
            if (l.connectedTo && l.connectedTo.length > 0) {
                for (var nn = 0; nn < l.connectedTo.length; nn++) {
                    if (l.connectedTo[nn].from.type === "asset" && assetsConnectedToLocations[l.connectedTo[nn].from.id]) {
                        l.connectedTo[nn].from = assetsConnectedToLocations[l.connectedTo[nn].from.id];
                        l.connectedTo[nn].from["_type"] = "asset";
                    } else if (l.connectedTo[nn].to.type === "asset" && assetsConnectedToLocations[l.connectedTo[nn].to.id]) {
                        l.connectedTo[nn].to = assetsConnectedToLocations[l.connectedTo[nn].to.id];
                        l.connectedTo[nn].to["_type"] = "asset";
                    }
                }
            }
        }

        i.updateCenterLocation(r, m, m.rawData.location);
        m.locationModelReady = true;
        i.processMarkers(r, m);
        
        i.calculateBoundingBox(r, m);
        
        i.fitToBoundingBox(r, m, m.boundingBox);

        r.ppm *= 0.66667;
        if (r.ppm < 2) {
            r.ppm = 2;
        }

        m.rawData.drawCounter++;
    }
    
    i.downloadAssets = function(r, m, d, baseUrl, token, customerId, flatLocationList, remainingAssetsToDownloadList) {
        
        if (!remainingAssetsToDownloadList) {
            var assetIds = {};
            for (var nn = 0; nn < flatLocationList.length; nn++) {
                if (flatLocationList[nn].connectedTo && flatLocationList[nn].connectedTo.length > 0) {
                    for (var n = 0; n < flatLocationList[nn].connectedTo.length; n++) {
                        if (flatLocationList[nn].connectedTo[n].from.type === "asset") {
                            assetIds[flatLocationList[nn].connectedTo[n].from.id] = true;
                        } else if (flatLocationList[nn].connectedTo[n].to.type === "asset") {
                            assetIds[flatLocationList[nn].connectedTo[n].to.id] = true;
                        }
                    }
                }
            }
            remainingAssetsToDownloadList = [];
            for (var k in assetIds) {
                remainingAssetsToDownloadList.push(k);
            }
        }
        
        if (remainingAssetsToDownloadList.length > 0) {
            var assetsToDownloadThisTime = [];
            for (var n = remainingAssetsToDownloadList.length - 1; n >= 0; n--) {
                if (assetsToDownloadThisTime.length >= 20) {
                    break;
                }
                if (!assetsConnectedToLocations[remainingAssetsToDownloadList[n]]) {
                    assetsToDownloadThisTime.push(remainingAssetsToDownloadList[n]);
                }
                remainingAssetsToDownloadList.splice(n, 1);
            }
            if (assetsToDownloadThisTime.length > 0) {
                $http.get(baseUrl + "api3/" + customerId + "/asset?select=tags%2Bproperties&id:equals=" + assetsToDownloadThisTime.join("%2B"), {
                    headers : {
                            "X-Auth-Token" : token
                    }
                    }).then(
                        function(response) {
                            for (var n = 0; n < response.data.result.length; n++) {
                                assetsConnectedToLocations[response.data.result[n].id] = response.data.result[n];
                            }
                            i.downloadAssets(r, m, d, baseUrl, token, customerId, flatLocationList, remainingAssetsToDownloadList)
                        },
                        function(response) {
                            d.error = "Error during load of assets";
                        }
                    );
            } else {
                i.postProcess(r, m, flatLocationList);
            }
        } else {
            i.postProcess(r, m, flatLocationList);
        }
    }
    
    i.downloadModel = function(r, m, d, baseUrl, token, customerId, flatList) {

        if (!flatList) {
            if (sessionStorage && sessionStorage["stwo-location-model-cache"]) {
                var cachedLocModel = angular.fromJson(sessionStorage["stwo-location-model-cache"]);
                if (cachedLocModel[customerId]) {
                    flatList = angular.fromJson(cachedLocModel[customerId]);
                    i.downloadAssets(r, m, d, baseUrl, token, customerId, flatList);
                    return;
                }
            }
            flatList = [];
            d.progress = 0;
        }
                
        m.rawData.drawCounter++;


        $http.get(baseUrl + "api3/" + customerId + "/location?select=*&offset=" + flatList.length + "&max=100", {
            headers : {
                    "X-Auth-Token" : token
            }
            }).then(
            function(response) {
                for (var n = 0; n < response.data.result.length; n++) {
                    flatList.push(response.data.result[n]);
                }
                d.progress = flatList.length / response.data.total;
                
                if (response.data.result.length === 0 || flatList.length >= response.data.total) {
                    var cachedLocModel = {};
                    if (sessionStorage && sessionStorage["stwo-location-model-cache"]) {
                        cachedLocModel = angular.fromJson(sessionStorage["stwo-location-model-cache"]);
                    }
                    if (sessionStorage) {
                        cachedLocModel[customerId] = flatList;
                        sessionStorage["stwo-location-model-cache"] = angular.toJson(cachedLocModel);
                    }
                    i.downloadAssets(r, m, d, baseUrl, token, customerId, flatList);
                } else {
                    i.downloadModel(r, m, d, baseUrl, token, customerId, flatList);
                }
                
                m.rawData.drawCounter++;
            },
            function(response) {
                d.error = "Error during load";
            }
        );
    }

    return i;
}); 
angular.module('stwo.core').factory('indoorLocationViewerRenderService', function(indoorLocationViewerDataService, decorationService) {
    
    var i = {};
    
    var overlayImages = {};
    
            
    i.grid = function(r) {
        if (stwoGlobal && stwoGlobal.indoorViewer && stwoGlobal.indoorViewer.doNotDrawGrid) {
            return;
        }
        
        var top = -r.center.y * r.ppm - r.canvas.height / 2;
        var left = -r.center.x * r.ppm - r.canvas.width / 2;

        r.ctx.beginPath();
        for (var x = r.ppm * Math.floor(left / r.ppm); x < (left + r.canvas.width); x += r.ppm) {
            r.ctx.moveTo(x, top);
            r.ctx.lineTo(x, r.canvas.height + top);
        }
        for (var y = r.ppm * Math.floor(top / r.ppm); y < (top + r.canvas.height); y += r.ppm) {
            r.ctx.moveTo(left, y);
            r.ctx.lineTo(left + r.canvas.width, y);
        }
        r.ctx.strokeStyle = "rgba(0, 0, 0, 0.15)";
        r.ctx.stroke();
    }
    
    i.text = function(r, text, x, y, fontStyle, fillStyle, shadowStyle) {
        if (fontStyle) {
            r.ctx.font = fontStyle;
        } else {
            r.ctx.font = "bold 12px Verdana"
        }
        if (shadowStyle) {
            r.ctx.fillStyle = shadowStyle;
        } else {
            r.ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
        }
        r.ctx.translate(-2, -2);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(4, 0);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(0, 4);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(-4, 0);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(2, -2);

        r.ctx.translate(0, -2);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(0, 4);
        r.ctx.fillText(text, x, y);
        r.ctx.translate(0, -2);

        if (fillStyle) {
            r.ctx.fillStyle = fillStyle;
        } else {
            r.ctx.fillStyle = "#000";
        }
        r.ctx.fillText(text, x, y);
    }
    
    
    
    i.overlay = function(r, location) {
        r.ctx.save();

        if (location.transformation) {
            r.ctx.translate(location.transformation.coordinate.x * r.ppm, location.transformation.coordinate.y * r.ppm);
            r.ctx.rotate((location.transformation.rotation / 180) * Math.PI);
        }

        if (location._children && location._children.length) {
            for (var n = 0; n < location._children.length; n++) {
                i.overlay(r, location._children[n]);
            }
        }


        if (location.meta && location.meta.overlays) {
            for (var m = 0; m < location.meta.overlays.length; m++) {
                var overlay = location.meta.overlays[m];



                var imageObj = overlayImages[overlay.image.url];
                if (!imageObj) {
                    imageObj = new Image();
                    imageObj.src = overlay.image.url;

                    imageObj.onload = function() {
                        console.log("Image downloaded", imageObj.width, this);
                    };

                    overlayImages[overlay.image.url] = imageObj;
                }

                r.ctx.save();

                r.ctx.translate(overlay.transformation.coordinate.x * r.ppm, overlay.transformation.coordinate.y * r.ppm);
                r.ctx.rotate((overlay.transformation.rotation / 180) * Math.PI);



                if (overlay.transformation.scale > 0) {
                    r.ctx.scale(r.ppm * overlay.transformation.scale, r.ppm * overlay.transformation.scale);
                }
                r.ctx.drawImage(imageObj, -imageObj.width / 2, -imageObj.height / 2);

                r.ctx.restore();
            }
        }

        r.ctx.restore();
    }


    i.marker = function(r, m, markerPosition) {
        r.ctx.save();
        
        var now = (new Date()).getTime();

        var p = {x: markerPosition.position.x, y: markerPosition.position.y};
        var movementTime = 200;

        if (now - markerPosition.position.time < movementTime) {
            var d = (now - markerPosition.position.time) / movementTime;
            //d = d * d;
            p.x = markerPosition.position.x * d + (1 - d) * markerPosition.previousPosition.x;
            p.y = markerPosition.position.y * d + (1 - d) * markerPosition.previousPosition.y;
        }
        
        var r1 = ((now % 2000) / 2000);
        var r2 = (((now + 1000) % 2000) / 2000);
        r.ctx.beginPath();
        r.ctx.arc(p.x * r.ppm, p.y * r.ppm, 15 * r1, 0, 2 * Math.PI, false);
        r.ctx.lineWidth = 3;
        if (markerPosition.markerStrokeColor && markerPosition.markerStrokeColor.indexOf(" 1)")) {
            r.ctx.strokeStyle = markerPosition.markerStrokeColor.replace(" 1)", (1 - r1));
        } else {
            r.ctx.strokeStyle = 'rgba(0, 0, 255, ' + (1 - r1) + ")";
        }
        r.ctx.stroke();
        r.ctx.beginPath();
        r.ctx.arc(p.x * r.ppm, p.y * r.ppm, 15 * r2, 0, 2 * Math.PI, false);
        r.ctx.lineWidth = 3;
        if (markerPosition.markerStrokeColor && markerPosition.markerStrokeColor.indexOf(" 1)")) {
            r.ctx.strokeStyle = markerPosition.markerStrokeColor.replace(" 1)", (1 - r2));
        } else {
            r.ctx.strokeStyle = 'rgba(100, 150, 255, ' + (1 - r2) + ")";
        }
        r.ctx.stroke();
        
        if (markerPosition._cluster) {
            p.y = p.y - markerPosition._cluster.index * 40 / r.ppm;
        }

        r.ctx.font = "bold 12px Verdana"

        var yScale = 1;
        
        var textMeasurement = r.ctx.measureText(markerPosition.marker.name);
        r.ctx.beginPath();
        
        markerPosition.position.px = markerPosition.position.x * r.ppm + r.center.x * r.ppm + r.canvas.width  / 2;
        markerPosition.position.py = markerPosition.position.y * r.ppm + r.center.y * r.ppm + r.canvas.height / 2;
        markerPosition.position.style = {left: markerPosition.position.px, top: markerPosition.position.py};

        r.ctx.restore();
    }

    i.location = function(r, m, textOnly, location, depth) {
        r.ctx.save();
        
        var now = (new Date()).getTime();

        if (!location._lastDecoRuleCheck || (now - location._lastDecoRuleCheck) > 5000) {
            location._decoration = decorationService.find("location", location);
            location._gradient = null;
            location._lastDecoRuleCheck = now;
        }

        if (!depth) {
            depth = "above";
        }

        var locationHasMarkers = false
        for (var k in m.locationsWithMarkers[location.locationId]) {
            depth = "current";
            locationHasMarkers = true
        }

        if (location.transformation) {
            r.ctx.translate(location.transformation.coordinate.x * r.ppm, location.transformation.coordinate.y * r.ppm);
            r.ctx.rotate((location.transformation.rotation / 180) * Math.PI);
        }

        var shell = indoorLocationViewerDataService.getShellRecursive(location);
        var holes = indoorLocationViewerDataService.getHolesRecursive(location);



        if (!textOnly) {
            if (shell && shell.length) {

                var colorFillStyle = null;
                if (location._decoration && location._decoration.color) {
                    colorFillStyle = location._decoration.color;
                    if (true || !location._gradient) {
                        var bound = {};
                        for (var n = 0; n < shell.length; n++) {
                            bound["l"] = Math.min(bound["l"] ? bound["l"] : 0, shell[n].x * r.ppm);
                            bound["r"] = Math.max(bound["r"] ? bound["r"] : 0, shell[n].x * r.ppm);
                            bound["t"] = Math.min(bound["t"] ? bound["t"] : 0, shell[n].y * r.ppm);
                            bound["b"] = Math.max(bound["b"] ? bound["b"] : 0, shell[n].y * r.ppm);
                        }
                        location._gradient=r.ctx.createRadialGradient((bound["l"] + bound["r"]) / 2,(bound["t"] + bound["b"]) / 2,
                                                5,
                                                (bound["l"] + bound["r"]) / 2,(bound["t"] + bound["b"]) / 2,
                                                Math.max(Math.abs(bound["l"] - bound["r"]), Math.abs(bound["t"] - bound["b"]))
                                        );
                        location._gradient.addColorStop(0,"transparent");
                        location._gradient.addColorStop(1, location._decoration.color);
                    }
                    colorFillStyle = location._gradient;
                }

                r.ctx.beginPath();
                r.ctx.moveTo(shell[0].x * r.ppm, shell[0].y * r.ppm);
                for (var n = 1; n < shell.length; n++) {
                    r.ctx.lineTo(shell[n].x * r.ppm, shell[n].y * r.ppm);
                }
                r.ctx.lineTo(shell[0].x * r.ppm, shell[0].y * r.ppm);


                r.ctx.lineWidth = 1;
                r.ctx.strokeStyle = "#000";
                r.ctx.fillStyle =  "rgba(240, 240, 240, 0.1)";

                if (colorFillStyle) {
                    r.ctx.fillStyle = colorFillStyle;
                }

                if (location.structureType === "floor") {
                    r.ctx.lineWidth = 6;
                    r.ctx.fillStyle =  "rgba(240, 240, 240, 0.3)";
                } else if (location.structureType === "room") {
                    r.ctx.lineWidth = 2;
                    r.ctx.strokeStyle = "#666";
                } else {
                    r.ctx.strokeStyle = "#666";
                }

                /*
                if (depth === "current") {
                    r.ctx.lineWidth = 3;
                    r.ctx.strokeStyle = "#00F";
                    r.ctx.fillStyle = colorFillStyle ? colorFillStyle : "rgba(200, 200, 200, 0.0)";
                } else if (depth === "below") {
                    r.ctx.strokeStyle = "#000";
                    r.ctx.fillStyle = colorFillStyle ? colorFillStyle : "rgba(255, 255, 255, 0.2)";
                } else {
                    r.ctx.strokeStyle  = "rgba(0, 0, 0, 0.2)";
                    r.ctx.fillStyle = colorFillStyle ? colorFillStyle : "rgba(200, 200, 200, 0.00)";
                }
                */
                r.ctx.fill();
                
                if (locationHasMarkers) {
                    r.ctx.lineWidth = 3;
                    r.ctx.strokeStyle = "#00F";
                }
                
                if (!stwoGlobal || !stwoGlobal.indoorViewer || !stwoGlobal.indoorViewer.doNotDrawLocationBorder) {
                    r.ctx.stroke();
                }
                
                if (location._decoration && location._decoration.image) {
                    var rct_l = 999999;
                    var rct_r = -999999;
                    var rct_t = 999999;
                    var rct_b = -999999;
                    
                    for (var n = 0; n < shell.length; n++) {
                        rct_l = Math.min(rct_l, shell[n].x * r.ppm);
                        rct_r = Math.max(rct_r, shell[n].x * r.ppm);
                        rct_t = Math.min(rct_t, shell[n].y * r.ppm);
                        rct_b = Math.max(rct_b, shell[n].y * r.ppm);
                    }
                    
                    var cx = (rct_l + rct_r) / 2;
                    var cy = (rct_t + rct_b) / 2;
                    
                    

                    if (overlayImages[location._decoration.image] && overlayImages[location._decoration.image].width) {
                        var w = overlayImages[location._decoration.image].width;// Math.abs(rct_l - rct_r) * 0.9;
                        var dw = Math.abs(rct_l - rct_r) * 0.5;
                        var h = overlayImages[location._decoration.image].height; //Math.abs(rct_t - rct_b) * 0.9;
                        var dh = Math.abs(rct_t - rct_b) * 0.5;
                        
                        if (w > dw) {
                            var scale = dw / w;
                            w = w * scale;
                            h = h * scale;
                        }
                        if (h > dh) {
                            var scale = dh / h;
                            w = w * scale;
                            h = h * scale;
                        }
                        
                        r.ctx.drawImage(overlayImages[location._decoration.image], rct_r - w - 10, rct_b - h - 10, w, h);
                    } else {
                        var imageObj = overlayImages[location._decoration.image];
                        if (!imageObj) {
                            imageObj = new Image();
                            imageObj.src = location._decoration.image;

                            imageObj.onload = function() {
                                console.log("Overlay decoration image downloaded", imageObj.width, this);
                            };

                            overlayImages[location._decoration.image] = imageObj;
                        }
                    }
                }
            }
            if (holes) {
                for (var m = 0; m < holes.length; m++) {
                    if (holes[m].length > 2) {
                        r.ctx.beginPath();
                        r.ctx.moveTo(holes[m][0].x * r.ppm, holes[m][0].y * r.ppm);
                        for (var n = 1; n < holes[m].length; n++) {
                            r.ctx.lineTo(holes[m][n].x * r.ppm, holes[m][n].y * r.ppm);
                        }
                        r.ctx.lineTo(holes[m][0].x * r.ppm, holes[m][0].y * r.ppm);
                        r.ctx.lineWidth = 1;
                        if (depth === "current") {
                            r.ctx.strokeStyle = "#333";
                            r.ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
                        } else if (depth === "below") {
                            r.ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
                            r.ctx.fillStyle = "rgba(0, 0, 0, 0.3)";
                        } else {
                            r.ctx.strokeStyle  = "rgba(0, 0, 0, 0.1)";
                            r.ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
                        }
                        r.ctx.fill();
                        r.ctx.stroke();
                    }
                }
            }
        } else {
            if (shell || holes) {

                var p = {x: 0, y: 0};
                var c = 0;
                for (var n = 0; n < shell.length; n++) {
                    c++;
                    p.x += shell[n].x * r.ppm;
                    p.y += shell[n].y * r.ppm;
                }

                r.ctx.font = "12px Verdana";
                if (depth === "current") {
                    r.ctx.font = "bold 14px Verdana";
                    i.text(r, location.name, p.x / c - r.ctx.measureText(location.name).width / 2, p.y / c + 10, r.ctx.font, "rgba(0, 0, 0, 1)", "rgba(255, 255, 255, 1)");
                } else if (depth === "below") {
                    i.text(r, location.name, p.x / c - r.ctx.measureText(location.name).width / 2, p.y / c + 10, r.ctx.font, "rgba(0, 0, 0, 1)", "rgba(255, 255, 255, 1)");
                } else {
                    i.text(r, location.name, p.x / c - r.ctx.measureText(location.name).width / 2, p.y / c + 10, r.ctx.font, "rgba(0, 0, 0, 1)", "rgba(255, 255, 255, 1)");
                }
            }
        }



        if (location._children && location._children.length) {
            for (var n = 0; n < location._children.length; n++) {
                i.location(r, m, textOnly, location._children[n], depth === "current" ? "below" : depth);
            }
        }

        r.ctx.restore();
    }

    return i;
}); 

	
var stwoCoreIndoorLocationFloorPickerModalController = function ($scope, $modalInstance, floors) {
    
    $scope.floors = floors;
    
    $scope.ok = function (floor) {
        $modalInstance.close({floor: floor});
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};
angular.module('stwo.core').directive('deviceCommands', function() {
    return {
      restrict: 'AE',
      scope: {
        commands: '=commands'
      },
      templateUrl: 'core/html/sent_command_list.html',
      controller: function($scope, $modal) {
          $scope.moreInfo = function(command) {
                $modal.open({
                    templateUrl: 'core/html/sent_command_modal.html',
                    controller: stwoCommonSentCommandDetailsModalController,
                    size: "lg",
                    resolve: {
                        sentCommandConfiguration: function() { return {command: command} }
                    }
                });
          }
      }
    };
  });


var stwoCommonSendCommandModalController = function ($scope, $modal, $controller, $modalInstance, smarttrackerService, sendCommandConfiguration) {
    $scope.item = null;
    $scope.itemType = null;
    $scope.availableCommands = [];
    
    $scope.chosenCommand = null;
    $scope.commandData = {};
    
    $scope.commandSent = false;
    
    if (sendCommandConfiguration.asset) {
        $scope.item = sendCommandConfiguration.asset;
        $scope.itemType = "asset";
        smarttrackerService.isLoggedInDelayed().then(function() {
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/asset/' + $scope.item.id + '?select=name+deviceCommands').then(function(response) {
                $scope.item = response.data.result[0];
                $scope.availableCommands = $scope.item.deviceCommands;
            });
        });
    }
    
    if (sendCommandConfiguration.device) {
        $scope.item = sendCommandConfiguration.device;
        $scope.itemType = "device";
        smarttrackerService.isLoggedInDelayed().then(function() {
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/device/' + $scope.item.id + '?select=name+deviceCommands').then(function(response) {
                $scope.item = response.data.result[0];
                $scope.availableCommands = $scope.item.deviceCommands;
            });
        });
    }
    
    $scope.chooseCommand = function(command) {
        $scope.chosenCommand = command;
        $scope.numParamsInChosen = 0;
        
        for (var k in $scope.commandData) {
            delete $scope.commandData[k];
        }
        if (command && command.parameters) {
            for (var k in command.parameters) {
                $scope.numParamsInChosen++;
            }
        }
    }
    
    $scope.sendCommand = function () {
        
        var dataToSend = {command: $scope.chosenCommand.name, parameters: $scope.commandData};
        if ($scope.itemType === "asset") {
            dataToSend["asset"] = $scope.item;
        }
        if ($scope.itemType === "device") {
            dataToSend["device"] = $scope.item;
        }
        
        $scope.commandSent = true;
        smarttrackerService.authPost(smarttrackerService.getCustomerId() + '/deviceCommand',
                        [dataToSend]
                                )
        .then(function(response) {
            $modalInstance.close({});
    
            $modal.open({
                templateUrl: 'core/html/sent_command_modal.html',
                controller: stwoCommonSentCommandDetailsModalController,
                size: "lg",
                resolve: {
                    sentCommandConfiguration: function() { return {command: response.data.result[0]} }
                }
            });
        }, function(response) {
            $scope.commandSent = false;
            console.log("Error while posting command", response)
            alert("Error while posting command");
        });
    };
    
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
    
    
    if (sendCommandConfiguration.command) {
        $scope.chooseCommand(sendCommandConfiguration.command);
        $scope.sendCommand();
    }
}

var stwoCommonSentCommandDetailsModalController = function ($scope, $controller, $modalInstance, smarttrackerService, sentCommandConfiguration) {
    $scope.shown = {moreInfo: false};

    $scope.command = sentCommandConfiguration.command;
    $scope.downloadCommand = function() {
        $scope.downloadingCommandData = true;
        return smarttrackerService.authGet(smarttrackerService.getCustomerId() + '/deviceCommand/' + $scope.command.id + '?select=*').then(function(response) {
            $scope.command = response.data.result[0];
            $scope.lastDownload = new Date();
            $scope.downloadingCommandData = false;
        });
    }
    
    smarttrackerService.isLoggedInDelayed().then(function() {
        $scope.downloadCommand();
    });
    
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};


	
var stwoCommonFilterModalController = function ($scope, $timeout, $modalInstance, availableFilters, filterValues) {

    $scope.availableFilters = availableFilters;
    $scope.filterValues = {};
    
    for (var k in filterValues) {
        $scope.filterValues[k] = filterValues[k];
    }
    $timeout(function() {
        $('.filter-form select:first-of-type').focus();
        $('.filter-form input:first-of-type').focus();
    },100)
    
    
    for (var n = 0; n < $scope.availableFilters.length; n++) {
        var f = $scope.availableFilters[n];
        var v = $scope.filterValues[f.id];

        var valueFound = false;
        if (v && v !== "") {
            if (f.type === "list") {
                for (var m = 0; m < f.list.length; m++) {
                    if (f.list[m].value === v) {
                        valueFound = true;
                        $scope.filterValues[f.id] = f.list[m];
                        break;
                    }
                }
            }
        }
        if (f.type === "list" && !valueFound) {
            $scope.filterValues[f.id] = f.list[0];
        }
    }
    
    $scope.ok = function () {
        var filterUrlString = "";
        
        for (var n = 0; n < $scope.availableFilters.length; n++) {
            var f = $scope.availableFilters[n];
            var v = $scope.filterValues[f.id];
            
            if (v && v !== "") {
                if (f.type === "string") {
                    filterUrlString += "&" + f.field + ":" + f.comparator + "=" + encodeURI(v);
                } else if (f.type === "list") {
                    if (v.value && v.value !== "") {
                        filterUrlString += "&" + f.field + ":" + f.comparator + "=" + encodeURI(v.value);
                    }
                    $scope.filterValues[f.id] = v.value;
                }
            }
        }
        
        
        $modalInstance.close({filterValues: $scope.filterValues, filterUrlString: filterUrlString});
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};
	
var stwoCommonMapModalController = function ($scope, $modalInstance, mapService, leafletData, mapData) {

    $scope.markers = mapData.markers ? mapData.markers : {};
    $scope.mapData = {
            center : (mapData.center ? mapData.center : {
                    lat : 0,
                    lng : 0,
                    zoom : 1			
            })
    };
    mapService.basicMapDesign($scope, leafletData);

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};

angular.module('stwo.core').directive('infiniteScroll', function($timeout, $window) {
    var isAtBottom = function() {
        if ($(document).height() - 500 < this.scrollY + $window.innerHeight) {
            return true;
        } else {
            return false;
        }
    }
    
    return {
        template: '',
        restrict: "EA",
        scope: {
            infiniteProgress: "="
        },
        link: function(scope, element, attr) {
            
            scope.$watch("infiniteProgress.bottom", function(a, b) {
                if (scope.infiniteProgress && !a) {
                    $timeout(function(){
                        scope.infiniteProgress.bottom = isAtBottom();
                    });
                } 
            });
            
            if (scope.infiniteProgress) {
                $timeout(function(){
                    scope.infiniteProgress.bottom = isAtBottom();
                });
            }
            //var raw = element[0]; // this should be the element handling the scrool. But in my case it seams we need the window to handle the scroll.
            angular.element($window).bind('scroll', function() {
                if (scope.infiniteProgress) {
                    $timeout(function(){
                        scope.infiniteProgress.bottom = isAtBottom();
                    });
                }
            });
        }
    };
});

angular.module('stwo.core').controller('BaseListContentController', function ($scope, $state, $stateParams, $modal, moduleStore, favoritesService, smarttrackerService, contentCacheService) {
    $scope.filterValues = {};
	$scope.filterUrlString = "";
	$scope.filterChanged = 0;
	$scope.itemsChanged = 0;
    
    $scope.availableFilters = [];
    $scope.predefinedFilters = {};
    $scope.filterMessage = "";
    $scope.filterMessage2 = "";
    
    
    $scope.selectedItems = [];
    $scope.selectedItemsMap = {};
    $scope.favorites = {};
    
    $scope.infiniteScrollHandler = null;
    $scope.downloadProgress = {active: false};
    $scope.infiniteScrollProgress = {bottom: false};
    
    $scope.startDownload = function() {
        $scope.downloadProgress.active = true;
    }
    $scope.finishDownload = function() {
        $scope.downloadProgress.active = false;
        $scope.infiniteScrollProgress.bottom = false;
    }
    $scope.downloading = function() {
        return $scope.downloadProgress.active;
    }
    
    $scope.items = [];
    $scope.pagination = {offset: 0, total: -1, max: 30, complete: false};
    $scope.clazz = null;
    $scope.downloadUrl = null;
	
    $scope.refresh = function() {
        $scope.clearItems();
        $scope.downloadMore();
    }
    
    $scope.clearItems = function() {
        $scope.items.splice(0, $scope.items.length);
        $scope.pagination.offset = 0;
        $scope.pagination.next = $scope.pagination.max;
        $scope.pagination.total = -1;
        $scope.pagination.left = -1;
        $scope.pagination.complete = false;
        $scope.itemsChanged++;
    }
    $scope.downloadMore = function() {
        if (!$scope.downloadUrl) {
            return;
        }
        if ($scope.downloading()) { 
            return;
        }
        if (!smarttrackerService.getCustomerId()) { 
            return;
        }
        if ($scope.pagination.total === 0 || $scope.pagination.complete) { 
            return;
        }
        $scope.startDownload();
        smarttrackerService.authGet(smarttrackerService.getCustomerId() + $scope.downloadUrl + '&offset=' + $scope.pagination.offset + '&max=' + $scope.pagination.max + $scope.filterUrlString, {onErrorDoNotRedirect: true}).then(function(response) {
            for (var n = 0; n < response.data.result.length; n++) {
                $scope.items.push(response.data.result[n]);
            }
            $scope.itemsChanged++;
            $scope.pagination.offset += response.data.result.length;
            $scope.pagination.total = response.data.total;
            $scope.pagination.next = Math.min($scope.pagination.max, $scope.pagination.total - $scope.pagination.offset);
            $scope.pagination.left = $scope.pagination.total - $scope.pagination.offset;
            if (response.data.total <= $scope.pagination.offset) {
                $scope.pagination.complete = true;
            }
            contentCacheService.putMany($scope.clazz, response.data.result);
            $scope.clearSelection();
            $scope.finishDownload();
        }, function() {
            $scope.finishDownload();
        });
    }
    
    /*$scope.$watch("infiniteScrollProgress.bottom", function(a, b){
        if (a && !b) {
            $scope.downloadMore();
        }
    });*/
    
    $scope.toggleSelect = function(item) {
        if ($scope.selectedItemsMap[item.id]) {
            delete $scope.selectedItemsMap[item.id];
            for (var n = $scope.selectedItems.length - 1; n >= 0; n--) {
                if ($scope.selectedItems[n].id === item.id) {
                    $scope.selectedItems.splice(n, 1);
                }
            }
        } else {
            $scope.selectedItemsMap[item.id] = item;
            $scope.selectedItems.push(item);
        }
    }
    
    $scope.showFavorites = function(){
        var favoritesListAsString = favoritesService.getListOfFavorites($scope.clazz).join("%2B");
        $scope.clearFilter();
        $scope.clearSelection();
        $scope.filterUrlString = "&id:equals=" + (favoritesListAsString.length > 0 ? favoritesListAsString : "-1");
        $scope.filterMessage = "FAVORITE_ITEMS";
    }

    $scope.toggleFavorite = function(id) {
    	favoritesService.toggle($scope.clazz, id);
    }
    $scope.isFavorite = function(id) {
    	favoritesService.isFavorite($scope.clazz, id);
    }
    
    $scope.clearFilter = function() {
        $scope.filterValues = {};
        $scope.filterUrlString = "";
        $scope.filterMessage = "";
        $scope.filterMessage2 = "";
    }
    
    $scope.clearSelection = function() {
        $scope.selectedItems = [];
        $scope.selectedItemsMap = {};
    }

    $scope.openFilter = function() {
        var modalInstance = $modal.open({
            templateUrl: 'core/html/filter_modal.html',
            controller: stwoCommonFilterModalController,
            size: "lg",
            resolve: {
                availableFilters: function() { return $scope.availableFilters },
                filterValues: function() { return $scope.filterValues }
            }
        });
        
        modalInstance.result.then(function (newFilterData) {
            $scope.filterValues = newFilterData.filterValues;
            $scope.filterUrlString = newFilterData.filterUrlString;
        }, function() {
            
        });
    }
    
    $scope.addPredefinedFilter = function(predefinedIdentifier, listOfFilterValues, filterUrlString) {
        //filterIdentifier, filterValues
        var predefinedFilterStructure = {'filterValues': {}, 'filterUrlString': {}};
        for (var n = 0; n < listOfFilterValues.length; n++) {
            predefinedFilterStructure["filterValues"][listOfFilterValues[n].filterId] = listOfFilterValues[n].value;
        }
        predefinedFilterStructure["filterUrlString"] = filterUrlString;
        
        $scope.predefinedFilters[predefinedIdentifier] = predefinedFilterStructure;
    }
    
    $scope.addAvailableFilter = function(identifier, fieldDescription) {
        fieldDescription.id = identifier;
        $scope.availableFilters.push(fieldDescription);
    }
    
    
    $scope.super = function(setup) {
        if (!setup || !setup.clazz) {
            alert("Base Data Controller is missing setup and/or setup.clazz");
        }
        
        $scope.clazz = setup.clazz;
        
        if (setup.pagination && setup.pagination.max) {
            $scope.pagination.max = setup.pagination.max;
        }
        
        var moduleDefinedFilters = moduleStore.getPossibleFiltersForClazz(setup.clazz);
        if (moduleDefinedFilters) {
            for (var n = 0; n < moduleDefinedFilters.length; n++) {
                $scope.addAvailableFilter(moduleDefinedFilters[n].id, moduleDefinedFilters[n]);
            }
        }
        
        smarttrackerService.isLoggedInDelayed().then(function() {
            if ($stateParams.filter && $scope.predefinedFilters[$stateParams.filter]) {
                $scope.filterValues = $scope.predefinedFilters[$stateParams.filter].filterValues;
                $scope.filterUrlString = $scope.predefinedFilters[$stateParams.filter].filterUrlString;
            }
            if ($stateParams.filter === "favorites") {
                $scope.showFavorites();
            }
            
            if ($stateParams.filter && $stateParams.filter.indexOf("~") && $stateParams.filter.split("~").length === 4) {
                var advancedFilter = $stateParams.filter.split("~");
                $scope.clearFilter();
                $scope.clearSelection();
                $scope.filterUrlString = "&" + advancedFilter[1] + "=" + advancedFilter[3];
                $scope.filterMessage = advancedFilter[0];
                $scope.filterMessage2 = advancedFilter[2];
            }
            
            if (setup && setup.clazz && setup.downloadUrl) {
                $scope.downloadUrl = setup.downloadUrl;
            }
        
            $scope.favorites = favoritesService.favoritesOfClazz(setup.clazz);
            
            $scope.downloadMore();
        });
    }
    
    
    
    $scope.$watch("filterUrlString", function(newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.filterChanged++;
            $scope.clearItems();
            $scope.downloadMore();
        }
    });


});

angular.module('stwo.core').controller('BaseDetailContentController', function ($scope, $state, favoritesService, smarttrackerService) {
    
    $scope.favorites = {};
    
    $scope.go = function(state, params) {
        $state.go(state, params);
    }
    
    $scope.toggleFavorite = function(id) {
    	favoritesService.toggle($scope.clazz, id);
    }
    $scope.isFavorite = function(id) {
    	favoritesService.isFavorite($scope.clazz, id);
    }
    
    $scope.super = function(setup) {
        if (!setup || !setup.clazz) {
            alert("Base Detail Data Controller is missing setup and/or setup.clazz");
        }
        
        $scope.clazz = setup.clazz;
        
        smarttrackerService.isLoggedInDelayed().then(function() {
            $scope.favorites = favoritesService.favoritesOfClazz(setup.clazz);
        });
    }

});


var stwoCommonPickerModalController = function ($scope, $controller, $modalInstance, pickerConfiguration) {

    $controller('BaseListContentController', {$scope: $scope});
    
    

    $scope.pickMultipleMode = true && pickerConfiguration.multiple;
    $scope.fieldsToShow = pickerConfiguration.fieldsToShow ? pickerConfiguration.fieldsToShow : ["id"];
    
    $scope.genericData = pickerConfiguration.data;
    $scope.title = pickerConfiguration.title;
    
    $scope.pickNullAllowed = true && pickerConfiguration.nullAllowed;
    $scope.pickNullButtonText = pickerConfiguration.nullButtonText;
    
    $scope.disabledIDs = pickerConfiguration.disabledIDs?pickerConfiguration.disabledIDs:[];

    //map of items who are disabled. key value is .id for quick lookup
    $scope.disabledItems = pickerConfiguration.disabledItems ? pickerConfiguration.disabledItems : {};
    $scope.downloadUrl = pickerConfiguration.downloadUrl;
    $scope.pagination.max = pickerConfiguration.max?pickerConfiguration.max:30;
    

    
    $scope.filters = pickerConfiguration.filters ? pickerConfiguration.filters : {};
    var index = 0;
    var filterString = '';
    var filterValues = {};
    angular.forEach($scope.filters, function (filter) {
        filterValues[filter.id] = "<b>";
        filterString += (index++==0&&$scope.downloadUrl.indexOf('?')<0?'?':'&') + filter.value;
    });
    if(filterString != '') {
        $scope.filterUrlString = filterString;
        $scope.filterValues = filterValues;
    }
    $scope.super({clazz: pickerConfiguration.clazz, downloadUrl: $scope.downloadUrl});

    $scope.$watch("itemsChanged", function() {
        if($scope.itemsChanged > 0) {
            if(pickerConfiguration.fieldsToShow.indexOf('assets') > -1) {
                angular.forEach($scope.items, function (v){
                    if(!v.processed) {
                        var assets = [];
                        angular.forEach(v.assets, function (vv) {
                            console.log(vv);
                            assets.push(vv.name);
                        });
                        v.assets = assets.join();
                        v.processed = true;
                    }
                });
            }
        }
    });

    $scope.itemClicked = function(item) {
        if (!$scope.pickMultipleMode) {
            $scope.pickOne(item);
        } else {
            $scope.toggleSelect(item);
            item.selected = !item.selected
        }
    }
    
    $scope.pickNull = function() {
        $modalInstance.close({data: $scope.genericData, selectedItems: [null]});
    }
    
    $scope.pickOne = function(item) {
        $scope.toggleSelect(item);
        $modalInstance.close({data: $scope.genericData, selectedItems: $scope.selectedItems});
    }

    $scope.pickMultiple = function () {
        $modalInstance.close({data: $scope.genericData, selectedItems: $scope.selectedItems});
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.textInput = {nameSearchValue: ""};
    $scope.applyNameSearch = function($event) {
        var keyCode = $event.which || $event.keyCode;
        if(keyCode === 13){
            $scope.filterValues = {"name":$scope.textInput.nameSearchValue};
            $scope.filterUrlString = "&name:contains=" + $scope.textInput.nameSearchValue;
        }
    };
};
angular.module('stwo.core').directive('phoneField', function ($compile) {
    return {
        restrict: 'E',
        scope: {
            phone: '=',
            callback: '&',
            phonePlaceHolder: '='
            //bindAttr: '='
        },

        templateUrl: 'core/html/phone-field.html',
        controller: ['$scope', '$translate', '$timeout', function MyTabsController($scope, $translate, $timeout) {



            $translate(["COUNTRY_CODE_EMPTY", "COUNTRY_CODE_NORWAY", "COUNTRY_CODE_NETHERLANDS", "COUNTRY_CODE_ROMANIA", "COUNTRY_CODE_HUNGARY", "COUNTRY_CODE_CZECH_REPUBLIC",
                    "COUNTRY_CODE_SWEDEN", "COUNTRY_CODE_MALAYSIA", "COUNTRY_CODE_THAILAND", "COUNTRY_CODE_UNITDED_KINGDOM", "COUNTRY_CODE_GERMANY",
                    "COUNTRY_CODE_PERU", "COUNTRY_CODE_BONAIRE", "COUNTRY_CODE_CHINA", "COUNTRY_CODE_FINLAND", "COUNTRY_CODE_DENMARK",
                    "COUNTRY_CODE_IRELAND", "COUNTRY_CODE_POLAND", "COUNTRY_CODE_MADAGASCAR", "COUNTRY_CODE_FRANCE", "COUNTRY_CODE_UKRAINE",
                    "COUNTRY_CODE_BELGIUM", "COUNTRY_CODE_AUSTRALIA"
                ])
                .then(function (data) {
                    console.log(data);
                    $scope.translations = {
                        Netherlands: data['COUNTRY_CODE_NETHERLANDS'],
                        Norway: data['COUNTRY_CODE_NORWAY'],
                        Romania: data['COUNTRY_CODE_ROMANIA'],
                        Hungary: data['COUNTRY_CODE_HUNGARY'],
                        Czech: data['COUNTRY_CODE_CZECH_REPUBLIC'],
                        Sweden: data['COUNTRY_CODE_SWEDEN'],
                        Malaysia: data['COUNTRY_CODE_MALAYSIA'],
                        Thailand: data['COUNTRY_CODE_THAILAND'],
                        UK: data['COUNTRY_CODE_UNITDED_KINGDOM'],
                        Germany: data['COUNTRY_CODE_GERMANY'],
                        Peru: data['COUNTRY_CODE_PERU'],
                        Bonaire: data['COUNTRY_CODE_BONAIRE'],
                        China: data['COUNTRY_CODE_CHINA'],
                        Finland: data['COUNTRY_CODE_FINLAND'],
                        Denmark: data['COUNTRY_CODE_DENMARK'],
                        Ireland: data['COUNTRY_CODE_IRELAND'],
                        Poland: data['COUNTRY_CODE_POLAND'],
                        Madagascar: data['COUNTRY_CODE_MADAGASCAR'],
                        France: data['COUNTRY_CODE_FRANCE'],
                        Ukraine: data['COUNTRY_CODE_UKRAINE'],
                        Belgium: data['COUNTRY_CODE_BELGIUM'],
                        Australia: data['COUNTRY_CODE_AUSTRALIA'],
                        Empty: data['COUNTRY_CODE_EMPTY']
                    };


                    $scope.countryCodes = [{
                        'label': $scope.translations.Netherlands,
                        'code': '+31',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Norway,
                        'code': '+47',
                        'mask': '99999999'
                    }, {
                        'label': $scope.translations.Romania,
                        'code': '+40',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Hungary,
                        'code': '+36',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Czech,
                        'code': '+420',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Sweden,
                        'code': '+46',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Malaysia,
                        'code': '+60',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Thailand,
                        'code': '+66',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.UK,
                        'code': '+44',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Germany,
                        'code': '+49',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Peru,
                        'code': '+51',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Bonaire,
                        'code': '+599',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.China,
                        'code': '+86',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Finland,
                        'code': '+358',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Denmark,
                        'code': '+45',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Ireland,
                        'code': '+353',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Poland,
                        'code': '+48',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Madagascar,
                        'code': '+261',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.France,
                        'code': '+33',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Ukraine,
                        'code': '+380',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Belgium,
                        'code': '+32',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Australia,
                        'code': '+61',
                        'mask': '9999999999'
                    }, {
                        'label': $scope.translations.Empty,
                        'code': ' ',
                        'mask': '9999999999'
                    }];
                    $scope.currentCC = $scope.countryCodes[0];

                    $scope.phoneNbrPlaceHolder = $scope.phonePlaceHolder ? $scope.phonePlaceHolder : 'PHONE_FIELD_PHONE_PLACEHOLDER';
                    parseNbr();

                });
            $scope.uniqueID = "ccdd" + Math.floor(Math.random() * 1000000);
            $scope.ccSearch = "";
            $scope.selectedCCIndex = 0;
            $scope.ccExpanded = function ($event) {
                $timeout(function () {
                    console.log($scope.uniqueID, $("#" + $scope.uniqueID));
                    $("#" + $scope.uniqueID).focus();
                }, 50);
            }

            $scope.searchFieldKeyPressed = function ($event, maxIndex, cc) {
                var keyCode = $event.which || $event.keyCode;
                if (keyCode === 13 && cc) {
                    $scope.changeCC(cc);
                    $scope.ccSearch = "";
                    $scope.selectedCCIndex = 0;
                    $("#" + $scope.uniqueID).parent().click();
                } else if (keyCode == 38 /*UpArrow*/ ) {
                    $scope.selectedCCIndex = Math.max(0, $scope.selectedCCIndex - 1);
                } else if (keyCode == 40 /*Down Arrow*/ ) {
                    $scope.selectedCCIndex = Math.min(maxIndex - 1, $scope.selectedCCIndex + 1);
                } else {
                    $scope.selectedCCIndex = 0;
                }
            }

            $scope.getCountryCodes = function (callback) {
                callback($scope.countryCodes);
            }

            var parseNbr = function () {
                console.log("Parse number called for number" + $scope.phone);
                if ($scope.phone) {
                    for (var i in $scope.countryCodes) {
                        if ($scope.phone.indexOf($scope.countryCodes[i].code) == 0) {
                            $scope.currentCC = $scope.countryCodes[i];
                            break;
                        }
                    }
                    if ($scope.currentCC) {
                        $scope.nbr = $scope.phone.substring($scope.currentCC.code.length);
                    }
                }
            }

            $scope.changeCC = function (cc) {

                $scope.currentCC = cc;
                console.log("changeCC", cc, $scope.currentCC);
                $scope.phone = $scope.nbr && $scope.nbr != '' ? $scope.currentCC.code + $scope.nbr : '';
            }

            $scope.$watch('phone', function (newValue, oldValue) {
                if ($scope.callback) {
                    $scope.callback();
                }
                parseNbr(); // in case it has been updated from outside
            });

            $scope.nbrChanged = function () {
                $scope.phone = $scope.nbr && $scope.nbr != '' ? $scope.currentCC.code + $scope.nbr : '';
            }


        }],
        replace: true,
        //require: 'ngModel',
        link: function ($scope, elem, attr, ctrl) {
            console.debug("link" + $scope);
            //var textField = $('input', elem).attr('ng-model', 'myDirectiveVar');
            // $compile(textField)($scope.$parent);
        }
    };
});

angular.module('stwo.core').directive('contactEditor', function ($compile, dialogService) {
    return {
        restrict: 'E',
        scope: {
            type: '@',
            readonly: '=',
            object: '=',
            callback: '&'
        },
        templateUrl: 'core/html/directives/contact-editor.html',
        controller: ['$scope', '$translate', 'smarttrackerService', 'utilService', '$timeout', function MyTabsController($scope, $translate, smarttrackerService, utilService, $timeout) {


            var translations = {};
            $translate(["MANAGEMENT_ASSET_WORKHOUR_DAY_MON", "MANAGEMENT_ASSET_WORKHOUR_DAY_TUE", "MANAGEMENT_ASSET_WORKHOUR_DAY_WED", "MANAGEMENT_ASSET_WORKHOUR_DAY_THU",
                "MANAGEMENT_ASSET_WORKHOUR_DAY_FRI", "MANAGEMENT_ASSET_WORKHOUR_DAY_SAT", "MANAGEMENT_ASSET_WORKHOUR_DAY_SUN", "MANAGEMENT_ASSET_WORKHOUR_DAY_WORKWEEK", "MANAGEMENT_ASSET_WORKHOUR_DAY_WHOLEWEEK",
                "MANAGEMENT_ASSET_WORKHOUR_DAY_SELECT", "MANAGEMENT_ASSET_WORKHOUR_ERROR_INCONSISTENT", "MANAGEMENT_ASSET_WORKHOUR_ERROR_NODAY"
            ]).then(function (data) {
                angular.forEach(data, function (value, key) {
                    var formattedKey = key.substring(key.lastIndexOf("_") + 1, key.length);
                    translations[formattedKey] = value;
                });
                var days = {};
                days[translations.WHOLEWEEK] = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
                days[translations.WORKWEEK] = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
                angular.forEach(days[translations.WHOLEWEEK], function (value) {
                    days[translations[value]] = [value];
                });


                $scope.workhoursData = {
                    days: days,
                    fromHours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
                    fromMinutes: ['00', '15', '30', '45'],
                    toHours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
                    toMinutes: ['00', '15', '30', '45'],
                    errors: {
                        'inconsistent': translations['INCONSISTENT'],
                        'noday': translations['NODAY']
                    }
                };
            });

            var correctWHOrder = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
            var failedContacts = [];
            var prepareContactsFor = function () {
                if (!$scope.object) return;
                $scope.object.contacts = [];
                var index = 0;
                $scope.object.originalContacts = {};
                console.log("Asset initiated", $scope.object);

                angular.forEach($scope.object.labels, function (v, k) {
                    if (v.code == 'ACR_CONTACT') {
                        var contact = prepareContact($scope.object, v, k);
                        if (contact) {
                            $scope.object.contacts.push(contact);
                        }
                    }
                });
                console.log("Contacts added", $scope.object.contacts);

                if (failedContacts.length > 0) {
                    var fcString = "";
                    angular.forEach(failedContacts, function (value) {
                        fcString += "<li>" + value + "</li>";
                    });
                    $translate(['MANAGEMENT_ASSET_CONTACT_ERROR_TITLE', 'MANAGEMENT_ASSET_CONTACT_ERROR_CONTACT', 'MANAGEMENT_ASSET_CONTACT_ERROR_CONTACTS',
                        'MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_TITLE', 'MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_CONTACT', 'MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_CONTACTS'
                    ], {
                        contacts: fcString
                    }).then(function (data) {

                        var message = failedContacts.length > 1 ? data['MANAGEMENT_ASSET_CONTACT_ERROR_CONTACTS'] : data['MANAGEMENT_ASSET_CONTACT_ERROR_CONTACT'];
                        var promise = dialogService.prompt('MANAGEMENT_ASSET_CONTACT_ERROR_TITLE', message, {
                            promptText: "",
                            disablePromptText: true,
                            deleteButton: true
                        });
                        promise.then(function () {
                            var labels = utilService.clone($scope.object.labels);
                            angular.forEach($scope.object.labels, function (value, name) {
                                if (failedContacts.indexOf(name) > -1) {
                                    delete labels[name];
                                }
                            });
                            smarttrackerService.authPut(smarttrackerService.getCustomerId() + '/' + $scope.type + '/' + $scope.object.id, {
                                'labels': labels
                            }).then(function (response) {
                                $scope.object.labels = response.data.result[0].labels;
                                //$scope.assetClicked(asset);
                                dialogService.alert('MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_TITLE', failedContacts.length > 1 ? data['MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_CONTACTS'] : data['MANAGEMENT_ASSET_CONTACT_ERROR_RESOLVED_CONTACT']);
                            });
                        });
                    });
                }

                $scope.object.contacts.sort(function (a, b) {
                    return a.priority - b.priority;
                });

            };

            var prepareContact = function (asset, label, name) {
                var contact = false;
                try {
                    contact = JSON.parse(label.value);
                } catch (e) {
                    failedContacts.push(name);
                }
                contact.index = name;
                contact.name = name;
                asset.originalContacts[contact.index] = utilService.clone(contact);

                angular.forEach(contact.workhours, function (wh) {
                    if (!wh.hours) {
                        wh.hours = "0000-2400";
                        contact.dirty = true;
                    }
                    var whFormatted = {
                        fromHours: wh.hours.substring(0, 2),
                        fromMinutes: wh.hours.substring(2, 4),
                        toHours: wh.hours.substring(5, 7),
                        toMinutes: wh.hours.substring(7, 9),
                        error: ''
                    };

                    wh.weekday.sort(function (a, b) {
                        return correctWHOrder.indexOf(a) - correctWHOrder.indexOf(b);
                    });

                    if (checkWeek(wh.weekday, false)) {
                        whFormatted.day = translations.WORKWEEK;
                    } else if (checkWeek(wh.weekday, true)) {
                        whFormatted.day = translations.WHOLEWEEK;
                    } else {
                        var tmpWH = [];
                        angular.forEach(wh.weekday, function (day) {
                            tmpWH.push(translations[day]);
                        });
                        whFormatted.day = tmpWH.join();
                    }
                    wh.formatted = whFormatted;
                });
                return contact;
            };

            var checkWeek = function (wh, wholeWeek) {
                var test = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
                if (wholeWeek) {
                    test.push('SAT');
                    test.push('SUN');
                }
                for (var i = 0; i < test.length; i++) {
                    if (wh.indexOf(test[i]) < 0)
                        return false;
                }
                return true;
            };


            $scope.expandContact = function (contact) {
                $scope.currentContact = $scope.currentContact == contact ? false : contact;
                $scope.currentContact.workhours = $scope.currentContact.workhours ? $scope.currentContact.workhours : [];
                $scope.animateEditor(contact);
            };

            $scope.updatePriority = function () {
                if ($scope.newContactInProgress) return;
                var priority = 1;
                var save = true;
                var labels = $scope.object.labels;

                angular.forEach($scope.object.contacts, function (v) {
                    v.priority = priority++;
                    var json = JSON.parse(labels[v.index].value);
                    json.priority = v.priority;
                    labels[v.index].value = JSON.stringify(json);
                });
                smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/" + $scope.type + "/" + $scope.object.id, {
                    "labels": labels
                }).then(function (response) {
                    // already updated clientside
                });
            };

            $scope.newContact = function () {
                $scope.object.contacts.push({
                    name: '',
                    phone: '',
                    sms: '',
                    email: '',
                    priority: $scope.object.contacts.length + 1,
                    dirty: true,
                    new: true,
                    workhours: []
                });
                $scope.currentContact = $scope.object.contacts[$scope.object.contacts.length - 1];
                $scope.newContactInProgress = true;
                $scope.animateEditor($scope.currentContact);
            };

            $scope.moveContactPriority = function (direction, contact) {
                var cs = $scope.object.contacts;
                var index = cs.indexOf(contact);
                var newIndex = index + direction;
                if (newIndex >= 0 && newIndex < cs.length) {
                    $scope.object.contacts.splice(index, 1);
                    cs.splice(newIndex, 0, contact);
                    $scope.updatePriority();
                }
            };

            $scope.removeContact = function (contact) {

                $translate(["MANAGEMENT_ASSET_CONFIRM_REMOVE_CONTACT"], {
                    contactName: contact.index
                }).then(function (data) {
                    var promise = dialogService.prompt("MANAGEMENT_ASSET_REMOVE_CONTACT", "MANAGEMENT_ASSET_CONFIRM_REMOVE_CONTACT", {
                        promptText: "",
                        disablePromptText: true,
                        deleteButton: true
                    });
                    promise.then(function (data) {
                        var labels = $scope.object.labels;
                        delete labels[contact.index];
                        $scope.object.contacts.splice($scope.object.contacts.indexOf(contact), 1);
                        $scope.updatePriority();
                    });
                });

                //$translate(["MANAGEMENT_ASSET_CONFIRM_REMOVE_CONTACT"], {contactName:contact.index}).then(function (data){
                //if(confirm(data.MANAGEMENT_ASSET_CONFIRM_REMOVE_CONTACT)) {
                //    var labels = $scope.object.labels;
                //    delete labels[contact.index];
                //    $scope.object.contacts.splice($scope.object.contacts.indexOf(contact), 1);
                //    $scope.updatePriority();
                //}
                //});
            };

            $scope.toggleDrag = function (drag) {
                console.log("disableDrag");
                console.log($('.cecontainer'));
                $('.cecontainer').attr("draggable", drag);
                console.log($('.cecontainer').attr('draggable'));
            };

            $scope.selected = {
                value: null
            };
            $scope.animateEditor = function (contact) {
                var index = $scope.object.contacts.indexOf(contact);

                if ($scope.selected.value == index) {
                    TweenLite.set("#editor-" + index + "-" + $scope.object.resourceId, {
                        overflow: "hidden"
                    });
                    TweenLite.to("#editor-" + index + "-" + $scope.object.resourceId, 0.5, {
                        height: "0px",
                        opacity: 0,
                        ease: "Quart.easeInOut"
                    });
                    TweenLite.set("#editor-" + index + "-" + $scope.object.resourceId, {
                        overflow: "hidden",
                        delay: 0.5
                    });
                    $scope.selected.value = null;
                } else {
                    $timeout(function () {
                        TweenLite.set("#editor-" + index + "-" + $scope.object.resourceId, {
                            height: "auto",
                            opacity: 1
                        });
                        TweenLite.from("#editor-" + index + "-" + $scope.object.resourceId, 0.5, {
                            height: "0px",
                            opacity: 0,
                            ease: "Quart.easeInOut"
                        });
                        TweenLite.set("#editor-" + index + "-" + $scope.object.resourceId, {
                            overflow: "visible",
                            delay: 0.5
                        });
                    }, 20);
                    $scope.selected.value = index;
                }
                if ($scope.selected.value != $scope.previous) {
                    TweenLite.set("#editor-" + $scope.previous + "-" + $scope.object.resourceId, {
                        overflow: "hidden"
                    });
                    TweenLite.to("#editor-" + $scope.previous + "-" + $scope.object.resourceId, 0.5, {
                        height: "0px",
                        opacity: 0,
                        ease: "Quart.easeInOut"
                    });
                    TweenLite.set("#editor-" + $scope.previous + "-" + $scope.object.resourceIdß, {
                        overflow: "hidden",
                        delay: 0.5
                    });
                }
                $scope.previous = $scope.selected.value;

            };

            $scope.checkContact = function (contact) {
                if (contact == $scope.currentContact) {
                    $scope.saveContact(contact, true);
                } else {
                    $scope.expandContact(contact)
                }
            };

            $scope.validateWorkHours = function (wh) {
                var f = wh.formatted;
                var start = f.fromHours + f.fromMinutes;
                var end = f.toHours + f.toMinutes;
                if (f.day == translations.SELECT || !$scope.workhoursData.days[f.day]) {
                    f.error = $scope.workhoursData.errors.noday;
                    errors = true;
                } else if (Number(end) - Number(start) <= 0 && (end != '0000')) {
                    f.error = $scope.workhoursData.errors.inconsistent;
                    errors = true;
                } else {
                    f.error = false;
                }
            };

            $scope.saveContact = function (contact, save) {
                if (!contact || !contact.dirty) {
                    $scope.expandContact(contact);
                    return;
                }
                if (save) {
                    if (!contact.name || contact.name.trim() == '') {
                        $translate(["MANAGEMENT_ASSET_NAME_EMPTY"]).then(function (data) {
                            contact.errors = [data.MANAGEMENT_ASSET_NAME_EMPTY];
                        });
                        return;
                    }
                    delete contact.errors;

                    var verified = [];
                    var errors = false;
                    angular.forEach(contact.workhours, function (wh) {
                        $scope.validateWorkHours(wh);
                        if (wh.formatted.error) {
                            errors = true;
                        } else {
                            var f = wh.formatted;
                            verified.push({
                                "weekday": $scope.workhoursData.days[f.day],
                                "hours": f.fromHours + f.fromMinutes + "-" + f.toHours + f.toMinutes
                            })
                        }
                    });
                    if (errors) return;


                    var data = {
                        phone: contact.phone,
                        sms: contact.sms,
                        email: contact.email,
                        workhours: verified,
                        priority: contact.priority,
                        contactCode: contact.contactCode
                    };
                    var labels = $scope.object.labels;
                    if (!contact.new) {
                        delete labels[contact.index];
                    }
                    if (name != contact.index) {
                        delete labels[contact.index];
                    }
                    labels[contact.name] = {
                        code: 'ACR_CONTACT',
                        value: data
                    };
                    var updateAsset = $scope.object;
                    smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/" + $scope.type + "/" + $scope.object.id, {
                        'labels': labels
                    }).then(function (response) {


                        if (!contact.new && contact.name != contact.index) {
                            delete updateAsset.originalContacts[contact.index];
                        }
                        contact.dirty = false;
                        contact.new = false;

                        updateAsset.originalContacts[contact.name] = utilService.clone(contact);
                        contact.index = contact.name;
                        updateAsset.labels = response.data.result[0].labels;
                        updateAsset.contacts.sort(function (a, b) {
                            return a.priority - b.priority;
                        });

                        $scope.newContactInProgress = false;
                        $scope.expandContact(contact)
                    });
                } else {
                    if (contact.new) {
                        var index = $scope.object.contacts.indexOf(contact);
                        if (index >= 0) $scope.object.contacts.splice(index, 1);
                        $scope.newContactInProgress = false;
                        $scope.expandContact(contact)
                    } else {
                        var cl = $scope.object.contacts;
                        if (cl.indexOf(contact) >= 0) {
                            var nc = utilService.clone($scope.object.originalContacts[contact.index]);
                            cl[cl.indexOf(contact)] = nc;
                            $scope.currentContact = nc;
                            $timeout(function () {
                                $scope.currentContact.dirty = false;
                            }, 500);
                        }
                        $scope.expandContact(contact)
                    }
                }
            };

            $scope.workhoursChanged = function () {
                if ($scope.currentContact)
                    $scope.currentContact.dirty = true;
            };

            $scope.checkContactChanged = function () {
                console.log("currentContact ", $scope.currentContact);
                if ($scope.currentContact && $scope.currentContact.index) {
                    var a = $scope.currentContact;
                    var b = $scope.object.originalContacts[$scope.currentContact.index];
                    var checks = ['name', 'email', 'phone', 'sms', 'contactCode'];
                    $scope.currentContact.dirty = false;
                    angular.forEach(checks, function (v) {
                        if (a[v] != b[v]) {
                            $scope.currentContact.dirty = true;
                        }
                    });

                }
            };

            /**  Workhours related methods*/




            $scope.whSelect = function (key, value, wh) {
                var index = $scope.currentContact.workhours.indexOf(wh);
                $scope.currentContact.workhours[index].formatted[key] = value;
                $scope.currentContact.dirty = true;
                $scope.validateWorkHours(wh)
            };

            $scope.addWorkhour = function () {
                $scope.currentContact.workhours.push({
                    "weekday": [],
                    "hours": "",
                    formatted: {
                        day: translations.SELECT,
                        fromHours: '00',
                        fromMinutes: '00',
                        toHours: '24',
                        toMinutes: '00',
                        error: ''
                    }
                });
                $scope.currentContact.dirty = true;
            };

            $scope.removeWorkhour = function (index) {
                $scope.currentContact.workhours.splice(index, 1);
                $scope.currentContact.dirty = true;
            };
            /** End workhours related methods*/



            $scope.$watch(function () {
                return $scope.object
            }, function (newValue, oldValue) {
                prepareContactsFor();
            });

        }],
        replace: true
    };
});

angular.module('stwo.core').directive('addressField', function ($compile) {
    return {
        restrict: 'E',
        scope: {
            callback: '&',
            placeholder: '@',
            awaitingNavigation: '=',
            searchOverlay: '='
        },

        templateUrl: 'core/html/directives/address-field.html',
        controller: ['$scope', 'addressService', '$timeout', function MyTabsController($scope, addressService, $timeout) {

            $scope.addressData = {
                addressSearch: '',
                addressLoading: false,
                addresses: [],
                selectedIndex: 0,
                selectedAddress: '',
                expanded: false
            };
            $scope.$watch("addressData.addressSearch", function (newVal, oldVal) {
                performAddressRequest();
            }, true);

            $scope.setAddressExpanded = function () {
                $timeout(function () {
                    $scope.addressData.expanded = true
                }, 200);
            }

            var requestString = "";
            var performAddressRequest = function () {
                if ($scope.addressData.addressSearch != '' && !$scope.addressData.addressLoading) {
                    $scope.addressData.addressLoading = true;
                    var requestString = $scope.addressData.addressSearch;
                    addressService.addressListBySearch(requestString).then(function (addressList) {
                        $scope.addressData.addressLoading = false;
                        $scope.addressData.addresses = addressList;
                        if (requestString != $scope.addressData.addressSearch) {
                            console.log(requestString + "!=" + $scope.addressData.addressSearch);
                            performAddressRequest();
                        }
                    }, function (error) {
                        console.error("Error when fetching address", error);
                        $scope.addressData.addressLoading = false;
                    });
                }
            }

            $scope.addressFieldKeyPressed = function ($event) {
                var keyCode = $event.which || $event.keyCode;
                if (keyCode === 13 /*Enter*/ ) {
                    $scope.selectAddress($scope.addressData.addresses[$scope.addressData.selectedIndex]);
                } else if (keyCode == 38 /*Up Arrow*/ ) {
                    $scope.addressData.selectedIndex = Math.max(0, $scope.addressData.selectedIndex - 1);
                } else if (keyCode == 40 /*Down Arrow*/ ) {
                    $scope.addressData.selectedIndex = Math.min($scope.addressData.addresses.length - 1, $scope.addressData.selectedIndex + 1);
                } else {
                    $scope.addressData.selectedIndex = 0;
                }
            }

            var addressSearchKey = "RecentAddressSearches";
            $scope.recentSearches = localStorage[addressSearchKey] ? JSON.parse(localStorage[addressSearchKey]) : [];
            $scope.selectAddress = function (address) {
                $scope.addressData.addresses = [];
                $scope.addressData.addressSearch = "";
                $scope.searchOverlay.toggle = false;
                console.log(address);
                addressService.addressDetails(address).then(function (detailedAddress) {
                    $scope.addressData.selectedAddress = detailedAddress;
                    var a = detailedAddress.address;
                    // Tellu Cloud Address String
                    console.log(detailedAddress);
                    $scope.addressData.selectedAddress.TCAString = (a.road ? a.road + " " : '') + (a.house_number ? a.house_number : '') + (a.road ? ", " : '') + (a.county ? a.country + ", " : '') + (a.postcode ? a.postcode + ", " : '') + a.country_code;
                    var data = {
                        point: new L.latLng(address.lat, address.lon),
                        address: $scope.addressData.selectedAddress,
                        TCAString: $scope.addressData.selectedAddress.TCAString
                    };

                    $scope.recentSearches.splice(0, 0, data);
                    if ($scope.recentSearches.length > 5) {
                        $scope.recentSearches.splice(5, ($scope.recentSearches.length - 5));
                    }
                    localStorage[addressSearchKey] = JSON.stringify($scope.recentSearches);

                    if ($scope.callback) {
                        $scope.callback({
                            data: data
                        });
                    }
                }, function (error)  {
                    console.error("Something went wrong when communicating with address api", error);
                });
            }

            $scope.searchSelected = function (index) {
                var data = $scope.recentSearches[index];
                if (data) {
                    $scope.callback({
                        data: data
                    });
                }
                $scope.searchOverlay.toggle = false;
            }
        }],
        replace: true,
        //require: 'ngModel',
        link: function ($scope, elem, attr, ctrl) {
            console.debug("link" + $scope);
        }
    };
});

angular.module('stwo.core').directive('addressInfo', function ($compile) {
    return {
        restrict: 'E',
        scope: {
            position: '=',
        },
        templateUrl: 'modules/alarm-screen-xguard/directives/address-info.html',
        controller: ['$scope', '$timeout', function MyTabsController($scope, $timeout) {

            $scope.result = false;
            return;

            var geocoder = new google.maps.Geocoder;
            var service = new google.maps.places.PlacesService(document.createElement('div'));
            geocoder.geocode({
                location: {
                    lat: $scope.position.latitude,
                    lng: $scope.position.longitude,
                }
            }, function(results, status) {
                if (status === 'OK') {

                    service.getDetails({
                      placeId: results[0].place_id,

                      // fields: ['name', 'rating', 'formatted_phone_number', 'geometry']
                    }, function callback(place, status) {
                        if (status == google.maps.places.PlacesServiceStatus.OK) {

                            // done
                            $scope.result = place;

                        }
                    });
                }
            });

        }],
        replace: true,
        link: function ($scope, elem, attr, ctrl) {
            console.debug("link addressInfo", { $scope: $scope, elem: elem, attr: attr, ctrl: ctrl });
        }
    };
});

angular.module('stwo.core').directive('durationTime', function ($compile) {
    return {
        restrict: 'E',
        scope: {
            time: '=',
        },
        templateUrl: 'modules/alarm-screen-xguard/directives/durationTime.html',
        controller: ['$scope', '$interval', function MyTabsController($scope, $interval) {

            var start = new Date($scope.time).getTime();
            $interval(function(){

                var duration = moment.duration(new Date().getTime() - start).format("hh:mm:ss", {
                    stopTrim: "mm"
                });
                $scope.timestring = duration;

            }, 100);

        }],
        replace: true,
        link: function ($scope, elem, attr, ctrl) {
            console.debug("link durationTime", { $scope: $scope, elem: elem, attr: attr, ctrl: ctrl });
        }
    };
});


//how to use

//<div time-restriction data="variable which holds the time restriction as json string" edit="true||false"></div>

//watch the variable and persist as needed

﻿angular.module('stwo.core').factory('timeRestrictionService', function(smarttrackerService) {

    var i = {};

    var weekdays = {"MON": 0, "TUE": 1, "WED": 2, "THU": 3, "FRI": 4, "SAT": 5, "SUN": 6};

    i.weekdays = function() {
        return weekdays;
    };

    i.evaluate = function(timeRestrictionJson) {

        var d = timeRestrictionJson && timeRestrictionJson.constructor === Array ? timeRestrictionJson : angular.fromJson(timeRestrictionJson);
        var anyOk = false;

        var wd = moment().isoWeekday();
        var hour = moment().hour() * 100 + moment().minute();

        if (d && d.constructor === Array) {
            for (var n = 0; n < d.length; n++) {
                var wdOk = false;
                var hourOk = false;

                if (d[n].weekday) {
                    for (var n2 = 0; n2 < d[n].weekday.length; n2++) {
                        if ((weekdays[d[n].weekday[n2]] + 1) === wd) {
                            wdOk = true;
                        }
                    }
                }

                if (d[n].hours && d[n].hours.indexOf("-") === 4) {
                    var a = d[n].hours.split("-")[0];
                    var b = d[n].hours.split("-")[1];

                    if (parseInt(a) <= hour && parseInt(b) >= hour) {
                        hourOk = true;
                    }
                }

                if (wdOk && hourOk) {
                    anyOk = true;
                    break;
                }
            }
        }

        return anyOk;
    };

    return i;
});
angular.module('stwo.core')
    .filter('isWithinTimeRestriction', function (timeRestrictionService) {
        return function (obj) {
            return timeRestrictionService.evaluate(obj);
        };
    });
angular.module('stwo.core')
    .filter('isOutsideTimeRestriction', function (timeRestrictionService) {
        return function (obj) {
            return !timeRestrictionService.evaluate(obj);
        };
    });

angular.module('stwo.core').directive("timeRestriction", function ($injector, $modal, $timeout, smarttrackerService, indoorLocationViewerDataService, indoorLocationViewerRenderService, timeRestrictionService)
  {
    return {
        restrict: 'EA',
        scope: {
            data: '=',
            edit: '=',
            waiting: '=',
            callback: '&'
        },
        templateUrl: 'core/js/timeRestriction/time-restriction-table.html',
        link: function(scope, element, attrs) {
            console.log("directive data " + scope.data);
        },
        controller: function($scope) {
            var weekdays = timeRestrictionService.weekdays();

            var updateInternalData = function() {
                $scope.rows = []

                var d = angular.fromJson($scope.data);

                if (d) {
                    for (var n = 0; n < d.length; n++) {
                        var minWeekday = 7;
                        var minHour = 24;
                        d[n]["weekdayToTranslate"] = [];

                        if (d[n].weekday) {
                            for (var n2 = 0; n2 < d[n].weekday.length; n2++) {
                                d[n]["weekdayToTranslate"].push({"key": "DAYS_" + d[n].weekday[n2], "_sort": weekdays[d[n].weekday[n2]]})
                                minWeekday = Math.min(weekdays[d[n].weekday[n2]], minWeekday)
                            }
                        }

                        d[n]["weekdayToTranslate"].sort(function(a, b) {
                            return a._sort - b._sort;
                        });

                        if (d[n].hours) {
                            minHour = Math.min(parseInt(d[n].hours.split("-")[0]), parseInt(d[n].hours.split("-")[1]));
                        }

                        d[n]["_sort"] = minWeekday * 100000 + minHour;

                        $scope.rows.push(d[n]);
                    }
                }

                $scope.rows.sort(function(a, b) {
                    return a._sort - b._sort;
                });
            }

            var updateExternalData = function() {
                var d = [];

                for (var n = 0; n < $scope.rows.length; n++) {
                    d.push({weekday: $scope.rows[n].weekday, hours: $scope.rows[n].hours});
                }

                $scope.data = angular.toJson(d);
            }

            updateInternalData();

            $scope.removeRow = function(idx) {
                $scope.rows.splice(idx, 1);
                updateExternalData();
            }

            var modalController = function ($scope, $modalInstance, row) {
                $scope.state = {mode: row ? 'edit' : 'add'};

                $scope.rowData = {weekday: {}, hoursStart: "", hoursEnd: ""};

                if (row) {
                    for (var wd in weekdays.length) {
                        $scope.rowData.weekday[wd] = false;
                    }
                    for (var n2 = 0; n2 < row.weekday.length; n2++) {
                        $scope.rowData.weekday[row.weekday[n2]] = true;
                    }
                    $scope.rowData.hoursStart = row.hours.split("-")[0];
                    $scope.rowData.hoursEnd = row.hours.split("-")[1];
                }

                $scope.padHours = function() {
                    if ($scope.rowData.hoursStart.length === 0) {
                        $scope.rowData.hoursStart = "0000";
                    }
                    if ($scope.rowData.hoursStart.length === 1) {
                        $scope.rowData.hoursStart = "0" + $scope.rowData.hoursStart + "00";
                    }
                    if ($scope.rowData.hoursStart.length === 2) {
                        $scope.rowData.hoursStart = $scope.rowData.hoursStart + "00";
                    }
                    if ($scope.rowData.hoursStart.length === 3) {
                        $scope.rowData.hoursStart = "0" + $scope.rowData.hoursStart;
                    }
                    if ($scope.rowData.hoursEnd.length === 0) {
                        $scope.rowData.hoursEnd = "2400";
                    }
                    if ($scope.rowData.hoursEnd.length === 1) {
                        $scope.rowData.hoursEnd = "0" + $scope.rowData.hoursEnd + "00";
                    }
                    if ($scope.rowData.hoursEnd.length === 2) {
                        $scope.rowData.hoursEnd = $scope.rowData.hoursEnd + "00";
                    }
                    if ($scope.rowData.hoursEnd.length === 3) {
                        $scope.rowData.hoursEnd = "0" + $scope.rowData.hoursEnd;
                    }
                }

                $scope.ok = function (floor) {
                    $scope.padHours();
                    var returnRow = {weekday: [], hours: $scope.rowData.hoursStart + "-" + $scope.rowData.hoursEnd}

                    for (var wd in $scope.rowData.weekday) {
                        if ($scope.rowData.weekday[wd]) {
                            returnRow.weekday.push(wd);
                        }
                    }

                    $modalInstance.close({row: returnRow});
                };
                $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                };
            };

            $scope.editRow = function(idx) {
                var modalInstance = $modal.open({
                    templateUrl: 'core/js/timeRestriction/time-restriction-picker-modal.html',
                    controller: modalController,
                    size: "lg",
                    resolve: {
                        row: function() { return $scope.rows[idx] }
                    }
                });

                modalInstance.result.then(function (data) {
                    $scope.rows[idx] = data.row;
                    updateExternalData();
                    updateInternalData();

                }, function() {

                });
            }

            $scope.addRow = function() {
                var modalInstance = $modal.open({
                    templateUrl: 'core/js/timeRestriction/time-restriction-picker-modal.html',
                    controller: modalController,
                    size: "lg",
                    resolve: {
                        row: function() { return null }
                    }
                });

                modalInstance.result.then(function (data) {
                    $scope.rows.push(data.row);
                    updateExternalData();
                    updateInternalData();
                }, function() {

                });
            }

            $scope.$watch("data", function() {
                updateInternalData();
                console.log("directive data changed ", $scope.data);
                if($scope.callback) {
                    $scope.callback();
                }

            });


        }
    };
});
angular.module('stwo.core').factory('messageService', function ($modal, smarttrackerService, $translate) {
	var i = {};

 		var messageDataValues = [
            "email_name",
            "email_tags",
            "email_insideZones",
            "email_properties",
            "email_links",
            "email_type",
            "email_position",
            "email_rule",
            "email_messageTime",
            "email_positionTime"
        ];

	var getTableRow = function (col1, col2) {
	    return "<tr><td><b>" + col1 + "</b></td><td>" + col2 + "</td></tr>";
	}
	var getGoogleMapsLink = function (lat, lon) {
    	return "http://maps.google.com/maps?q="+lat+"%2C" + lon;
    }

    var data = {};
    $translate(['MESSAGE_SERVICE_EMAIL_ASSET_NAME', 'MESSAGE_SERVICE_EMAIL_ASSET_IMAGE', 'MESSAGE_SERVICE_EMAIL_ASSET_EXTERNAL_ID', 'MESSAGE_SERVICE_EMAIL_ASSET_LAST_MESSAGE', 
			'MESSAGE_SERVICE_EMAIL_ASSET_CURRENT_POSITION', 'MESSAGE_SERVICE_EMAIL_ASSET_LABELS', 'MESSAGE_SERVICE_EMAIL_ASSET_GOOLE_LINK', 'MESSAGE_SERVICE_EMAIL_ASSET_INSIDE_ZONES_NONE', 
			'MESSAGE_SERVICE_EMAIL_ASSET_SUBJECT', 'MESSAGE_SERVICE_SMS_ASSET_NAME', 'MESSAGE_SERVICE_SMS_ASSET_EXTERNAL_ID', 'MESSAGE_SERVICE_SMS_ASSET_LATEST_POSITION_UPDATE', 'MESSAGE_SERVICE_SMS_ASSET_CURRENT_POSITION',
			'MESSAGE_SERVICE_SMS_ASSET_INSIDE_ZONES', 'MESSAGE_SERVICE_SMS_ASSET_INSIDE_ZONES_NONE', 'MESSAGE_SERVICE_SMS_ASSET_TYPE', 'MESSAGE_SERVICE_SMS_ASSET_PHONE', 'MESSAGE_SERVICE_SMS_ASSET_SMS', 
			'MESSAGE_SERVICE_SMS_ASSET_EMAIL', 'MESSAGE_SERVICE_SMS_ASSET_GOOGLE_MAPS_LINK'])
    		.then(function (translations){
    		data = translations;
    });

    var trimPhoneNumber = function (nbr) {
        return nbr ? nbr.replace(/\+/, "00").replace(/\s/g, "") : nbr;
    }

    var getAssetInformationTable = function(asset, messageData) {
    	
			
			var zones = [];
			angular.forEach(asset.insideZones, function (zone) {
				zones.push(zone.name);
			});
			var insideZonesString = zones.lengh>0?zones.join():data['MESSAGE_SERVICE_EMAIL_ASSET_INSIDE_ZONES_NONE'];

			var assetTable = "<table>" + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_IMAGE'] + ":", "<img src=\"" + asset.image + "\"/>") + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_NAME'] + ":", asset.name) + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_EXTERNAL_ID'] + ":", asset.externalId) + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_LAST_MESSAGE'] + ": ", asset.lastValidPosition.timestampFormatted) + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_CURRENT_POSITION'] + ": ", asset.lastValidPosition.address) + 
			getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_INSIDE_ZONES_NONE'] + ":", zones);

			angular.forEach(asset.properties, function (property) {
				assetTable += getTableRow(property.name + ":", property.value);
			})
			try{
				assetTable += getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_LABELS'] + ":", JSON.stringify(asset.labels));
			} catch(e) {
				console.error("Error when parsing labels for email: " + e);
			} 
			assetTable += getTableRow(data['MESSAGE_SERVICE_EMAIL_ASSET_GOOLE_LINK'] + ":",  getGoogleMapsLink(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude));
			assetTable += "</table>";
			return assetTable;
		
	                // Check highest priority RA to see if it has custom message data
	                
    } 

    var getAssetSMSContent = function(asset, messageData) {
    	var zones = [];
    	angular.forEach(asset.insideZones, function (zone) {
    		zones.push(zone.name);
    	})
    	var insideZones = zones.length>0?zones.join():data['MESSAGE_SERVICE_SMS_ASSET_INSIDE_ZONES_NONE'];

    	var assetInfo =  
    	
    		data["MESSAGE_SERVICE_SMS_ASSET_NAME"] + ": " + asset.name + "\n" +
    		data["MESSAGE_SERVICE_SMS_ASSET_EXTERNAL_ID"] + ": " + asset.externalId + "\n" +
    		data["MESSAGE_SERVICE_SMS_ASSET_LATEST_POSITION_UPDATE"] + ": " + asset.lastValidPosition.timestampFormatted + "\n" +
    		data["MESSAGE_SERVICE_SMS_ASSET_CURRENT_POSITION"] + ": " + asset.lastValidPosition.address + "\n" +
    		data["MESSAGE_SERVICE_SMS_ASSET_INSIDE_ZONES"] + ": " + insideZones + "\n" +
    		(asset.type ? data["MESSAGE_SERVICE_SMS_ASSET_TYPE"] + ": " + asset.type.name + "\n" : '') +
    		(asset.phone ? data["MESSAGE_SERVICE_SMS_ASSET_PHONE"] + ": " + asset.phone + "\n" : "") +
    		(asset.sms ? data["MESSAGE_SERVICE_SMS_ASSET_SMS"] + ": " + asset.sms + "\n" : "") +
    		(asset.email ? data["MESSAGE_SERVICE_SMS_ASSET_EMAIL"] + ": " + asset.email + "\n" : "") +
    		data["MESSAGE_SERVICE_SMS_ASSET_GOOGLE_MAPS_LINK"] + ": " + getGoogleMapsLink(asset.lastValidPosition.latitude, asset.lastValidPosition.longitude) + "\n";

		return assetInfo;
    }

	i.sendAssetByMail = function(message, asset, mail, messageData) {
			var mailContent = "<h1>" + asset.name + "</h1><p>" + message + "</p><div>";
			mailContent += getAssetInformationTable(asset, messageData);
			mailContent += "</div>";
	                
	        var mailBody = {
	        	"to": mail,
	        	"subject": data['MESSAGE_SERVICE_EMAIL_ASSET_SUBJECT'].replace("<ASSET_NAME>", asset.name),//lan['XGUARD_SEND_MAIL_SUBJECT'],
	        	"message": mailContent
	        };

	        return smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/mail/", mailBody);
    	
	}

	i.sendAssetBySMS = function(message, asset, number, messageData) {
		var smsContent = message + "\n";
		smsContent += getAssetSMSContent(asset, messageData);
		var formatNumber = false;
		 try {
            formatNumber = trimPhoneNumber(number);
        } catch (e) {
        	alert("The number: " + number + " is not a valid phone number " + formatNumber);
        	return;
        }

		var smsBody = {
			"to": formatNumber,
            "message": smsContent
		};
		
       return smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/sms/", smsBody);
	}

	return i;
});
angular.module('stwo.core').factory('addressService', function ($modal, $http) {

    var i = {};

    var baseUrl = "https://api.pickpoint.io/v1/";
    var apiKey = "WsxLCvmfN8D8wjJzPzNd";

    i.addressListBySearch = function(searchTerm) {
        return new Promise (function (resolve, reject) {
            $http({
                method:'GET', 
                url: baseUrl + "forward?key=" + apiKey + "&q=" + searchTerm
            }).then(function (response){
                resolve(response.data);
            }, function (response){
                reject(response);
            });
        });
    }

    i.addressDetails = function(address) {
        return new Promise (function (resolve, reject){
            $http({
                method:'GET', 
                url:baseUrl + 'lookup/?key=' + apiKey + '&osm_ids=' + address.osm_type.substring(0,1).toUpperCase() + address.osm_id
            }).then(function (response){
                resolve(response.data[0]);
            }, function (response){
                reject(respons);
            });
        });
    }

    i.addressByCoordinates = function(latitude, longitude) {
        return new Promise (function (resolve, reject){
            $http({
                method:'GET', 
                url:baseUrl + 'reverse/?key=' + apiKey + '&lat=' + latitude + '&lon=' + longitude
            }).then(function (response){
                resolve(response.data);
            }, function (response){
                reject(response);
            });
        });
    }

    return i;
});
angular.module('stwo.core').factory('IPSService', function ($http, smarttrackerService) {

    // radians and degrees helper
    function toRadians(angle) {
        return angle * (Math.PI / 180);
    }

    function toDegrees(rad) {
        return rad * 180 / Math.PI;
    }

    function getLatLngCenter(latLngInDegr) {

        // init
        var sumX = 0;
        var sumY = 0;
        var sumZ = 0;

        for (var i = 0; i < latLngInDegr.length; i++) {

            // get the latlng
            var lat = toRadians(latLngInDegr[i].lat);
            var lng = toRadians(latLngInDegr[i].lng);

            // sum of cartesian coordinates
            sumX += Math.cos(lat) * Math.cos(lng);
            sumY += Math.cos(lat) * Math.sin(lng);
            sumZ += Math.sin(lat);

        }

        var avgX = sumX / latLngInDegr.length;
        var avgY = sumY / latLngInDegr.length;
        var avgZ = sumZ / latLngInDegr.length;

        // convert average x, y, z coordinate to latitude and longtitude
        var lng = Math.atan2(avgY, avgX);
        var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
        var lat = Math.atan2(avgZ, hyp);

        return {
            lat: toDegrees(lat),
            lng: toDegrees(lng)
        };
    }

    function getDistance(lat1, lon1, lat2, lon2, unit) {

        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") {
            dist = dist * 1.609344
        }
        if (unit == "N") {
            dist = dist * 0.8684
        }
        return dist

    }

    // function boundingBoxAroundPolyCoords(coords) {

    //     var latAll = [],
    //         lngAll = []

    //     for (var i = 0; i < coords.length; i++) {
    //         latAll.push(coords[i].lat)
    //         lngAll.push(coords[i].lng)
    //     }

    //     latAll = latAll.sort(function (a, b) {
    //         return a - b
    //     })
    //     lngAll = lngAll.sort(function (a, b) {
    //         return a - b
    //     })

    //     return [
    //         [latAll[0], lngAll[0]],
    //         [latAll[latAll.length - 1], lngAll[lngAll.length - 1]]
    //     ]

    // }

    function returnBestMatchWay(elements, point) {

        // loopt elements
        var bestMatch = null;
        for (var k in elements) {

            // only ways are relevant
            if (elements[k].type === 'way') {

                // try catch because incomplete ways will cause errors (not all nodes are resolved to coordinates)
                try {

                    // calculate center
                    elements[k].center = getLatLngCenter(elements[k].nodes);
                    //elements[k].centerDistance = getDistance(elements[k].center.lat, elements[k].center.lng, point.lat, point.lng);

                    // calculate lowest distance
                    //var lowestDistance = Infinity,
                    var averageDistance = [];
                    for (var n in elements[k].nodes) {

                        averageDistance.push(getDistance(elements[k].nodes[n].lat, elements[k].nodes[n].lng, point.lat, point.lng));

                        // if (dist < lowestDistance) {

                        //     lowestDistance = dist;

                        // }

                    }

                    averageDistance = averageDistance.sort(function (a, b) {
                        return a - b
                    }).splice(0, 5);

                    var avgSum = 0;
                    for (var p in averageDistance) {

                        avgSum += averageDistance[p]

                    }


                    // save
                    // elements[k].lowestDistance = lowestDistance
                    elements[k].averageDistance = avgSum / averageDistance.length

                } catch (e) {

                    // better be safe, right?
                    elements[k].distance = Infinity;

                }

                // check best match
                if (bestMatch === null) {

                    bestMatch = elements[k];

                } else
                if (elements[k].averageDistance < bestMatch.averageDistance) {

                    // if (elements[k].lowestDistance == bestMatch.lowestDistance && elements[k].averageDistance < bestMatch.averageDistance) {

                    bestMatch = elements[k];

                    // }

                }

            }

        }

        return (bestMatch !== null && bestMatch.nodes) || false;

    }

    function resolveNode(elements, nodeId) {

        // loop through elements
        for (var b in elements) {

            // check if this is the node we are looking for
            if (elements[b].type === 'node' && elements[b].id === nodeId) {

                // return lat/lng (written as lon in overpass api)
                return {
                    lat: elements[b].lat,
                    lng: elements[b].lon
                }

            }

        }

    }

    // init
    var i = {
        defaultRadius: 35,
        smallRadius: 1
    };

    // get bounding box of building
    i.getBuildingBoundsData = {
        point: {
            lat: 0,
            lng: 0
        },
        callback: function () {},
        radius: 0,
        radiusStep: 5
    };
    i.getBuildingBounds = function (point, callback, radius) {

        // temp disable
        return callback([]);
        // stop temp disable
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //
        //

        if (typeof radius === 'undefined') {

            radius = 2;

        }

        var script = '[out:json][timeout:25];';
        script += '(';
        script += '    node(around:' + radius + ',' + point.lat + ',' + point.lng + ');';
        script += '    way(around:' + radius + ',' + point.lat + ',' + point.lng + ');';
        script += ');';
        script += 'out;';
        script += '>;';
        script += 'out skel qt;';

        i.getBuildingBoundsData = {
            point: point,
            callback: callback,
            radius: radius,
            radiusStep: i.getBuildingBoundsData.radiusStep
        };

        $http
            .get('https://overpass-api.de/api/interpreter?data=' + encodeURIComponent(script))
            .then(function (response) {

                // init
                var elements = response.data.elements;

                var foundNode = false,
                    foundWay = false;

                for (var node in elements) {

                    // way
                    if (elements[node].type === 'way') {

                        // add all points
                        for (var p in elements[node].nodes) {

                            elements[node].nodes[p] = resolveNode(elements, elements[node].nodes[p])

                        }

                        // mark as found
                        foundWay = true;

                    } else
                    if (elements[node].type === 'node') {

                        foundNode = true;

                    }

                }


                var wayPoints = returnBestMatchWay(elements, i.getBuildingBoundsData.point);

                console.log('foundNode', foundNode)
                console.log('foundWay', foundWay)
                console.log('wayPoints', wayPoints)

                // console.log('boundingBoxAroundPolyCoords', boundingBoxAroundPolyCoords(wayPoints))
                // return;

                // var geod = GeographicLib.Geodesic.WGS84;
                // (function (g) {
                //     "use strict";

                //     /*
                //      * Compute the area of a polygon
                //      */
                //     g.Geodesic.prototype.Area = function (points, polyline) {

                //         var poly = this.Polygon(polyline),
                //             i;

                //         for (i = 0; i < points.length; ++i){
                //             poly.AddPoint(points[i].lat, points[i].lng);
                //         }

                //         return poly.Compute(false, true);

                //     };

                // })(GeographicLib.Geodesic);

                // console.log('AreaCalc', Math.abs(geod.Area(wayPoints, false).area));

                // return;

                if (foundNode && foundWay && wayPoints && wayPoints.length > 2) {

                    return i.getBuildingBoundsData.callback(wayPoints);

                } else
                if (radius < 50) {

                    return i.getBuildingBounds(i.getBuildingBoundsData.point, i.getBuildingBoundsData.callback, i.getBuildingBoundsData.radius + i.getBuildingBoundsData.radiusStep)

                } else {

                    return i.getBuildingBoundsData.callback([], {
                        notice: 'No points found'
                    });

                }

            }, function (err) {

                return i.getBuildingBoundsData.callback(null, err)

            })

    }

    i.checkAddressZoneExists = function(address){
        return new Promise(function (resolve, reject) {

            // check if a zone already exists on this address
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/zone/?name:equals=" + encodeURIComponent(address.address)).then(function (existingZone) {
                if (typeof existingZone.data !== 'undefined' && existingZone.data.total === 0) {

                    resolve(false)

                } else {

                    resolve(true)

                }

            }, function (errorResponse) {

                response(false)

            })

        });
    }

    i.changeArcSize = function(zoneResourceId, map){
        return new Promise(function (resolve, reject) {

            // get the zone
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/zone/"+encodeURIComponent(zoneResourceId)+"?select=@").then(function (response) {
                if (typeof response.data !== 'undefined' && response.data.total === 1) {

                    var zone = response.data.result[0];
                    if(zone.labels.shapeMeta.code === 'ACR_ZCIRCLE'){

                        var p = JSON.parse(zone.labels.shapeMeta.value);
                        var points = [];
                        var labels = {};

                        //new arc
                        // angle that will be increased each loop
                        var theta = 0;

                        // zoom to level 8
                        map.setZoom(8)

                        // create circle on leaflet map
                        var h = p.lat; // x coordinate of circle center
                        var k = p.lng; // y coordinate of circle center
                        var circ = L.circle([h, k], {
                            radius: i.smallRadius
                        });
                        circ.addTo(map);

                        // get steps from circle
                        var step = 360 / 20; // amount to add to theta each time (degrees)
                        var rx = circ.getBounds().getNorthEast().lat - h;
                        var ry = circ.getBounds().getNorthEast().lng - k;
                        circ.remove();
                        var p1 = {
                            'latitude': h + rx * Math.cos(toRadians(theta)),
                            'longitude': k - ry * Math.sin(toRadians(theta))
                        };
                        while (theta < 360) {
                            var lat = h + rx * Math.cos(toRadians(theta));
                            var lng = k - ry * Math.sin(toRadians(theta))
                            points.push({
                                'latitude': lat,
                                'longitude': lng
                            });
                            theta += step;
                        }
                        points.push(p1);

                        // save steps meta
                        labels['shapeMeta'] = {
                            code: 'ACR_ZCIRCLE',
                            value: JSON.stringify({
                                'lat': p.lat,
                                'lng': p.lng,
                                'radius': i.smallRadius
                            })
                        };

                        // send to tellu cloud
                        var body = {
                            'labels': labels,
                            'points': points
                        };

                        // update
                        smarttrackerService.authPut(smarttrackerService.getCustomerId() + "/zone/"+encodeURIComponent(zoneResourceId), body).then(function (response) {

                            resolve(response);

                        }, function (errorResponse) {

                            reject(errorResponse);

                        });

                    }else{

                        return reject();

                    }

                }else{

                    return reject();

                }
            });

        });

    }

    // create new ips points on addresses
    i.newIPSPoint = function (address, map, level) {
        return new Promise(function (resolve, reject) {

            // check if a zone already exists on this address
            smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/zone/?name:equals=" + encodeURIComponent(address.address)).then(function (existingZone) {
                if (typeof existingZone.data !== 'undefined' && existingZone.data.total === 0) {

                    // check if we are able to create zones with rssi-90
                    smarttrackerService.authGet(smarttrackerService.getCustomerId() + "/zoneType/?name:contains=Rssi-90").then(function (response) {
                        if (response && response.data && response.data.result && response.data.result.length > 0) {

                            i.getBuildingBounds(address.point, function (buildingBounds, err) {

                                // temp
                                buildingBounds = [];

                                // set coordinates from point
                                var p = address.point;
                                var points = [];

                                // init labels
                                labels = {};

                                // console.log('debug stop')
                                // return;

                                if (buildingBounds.length > 0) {

                                    for (var j in buildingBounds) {

                                        points.push({
                                            'latitude': buildingBounds[j].lat,
                                            'longitude': buildingBounds[j].lng
                                        });

                                    }


                                } else {

                                    // angle that will be increased each loop
                                    var theta = 0;

                                    // zoom to level 8
                                    map.setZoom(8)

                                    // create circle on leaflet map
                                    var h = p.lat; // x coordinate of circle center
                                    var k = p.lng; // y coordinate of circle center
                                    var circ = L.circle([h, k], {
                                        radius: i.defaultRadius
                                    });
                                    circ.addTo(map);

                                    // get steps from circle
                                    var step = 360 / 20; // amount to add to theta each time (degrees)
                                    var rx = circ.getBounds().getNorthEast().lat - h;
                                    var ry = circ.getBounds().getNorthEast().lng - k;
                                    circ.remove();
                                    var p1 = {
                                        'latitude': h + rx * Math.cos(toRadians(theta)),
                                        'longitude': k - ry * Math.sin(toRadians(theta))
                                    };
                                    while (theta < 360) {
                                        var lat = h + rx * Math.cos(toRadians(theta));
                                        var lng = k - ry * Math.sin(toRadians(theta))
                                        points.push({
                                            'latitude': lat,
                                            'longitude': lng
                                        });
                                        theta += step;
                                    }
                                    points.push(p1);

                                    // save steps meta
                                    labels['shapeMeta'] = {
                                        code: 'ACR_ZCIRCLE',
                                        value: JSON.stringify({
                                            'lat': p.lat,
                                            'lng': p.lng,
                                            'radius': i.defaultRadius
                                        })
                                    };

                                }

                                // format address
                                var formattedAddress = address.address;
                                if(formattedAddress.match(new RegExp('^'+address.placeName, 'i')) === null){

                                    formattedAddress = address.placeName + ', ' + address.address;

                                }

                                // send to tellu cloud
                                var body = {
                                    'name': address.address,
                                    'address': formattedAddress, //address.placeName + address.address, //address.address,
                                    'description': 'IPS_SecureNavigation',
                                    'labels': labels,
                                    'points': points,
                                    //'shareLevel': 'public', // temp
                                    'floor': (level ? level : 0),
                                    'type': {
                                        'id': response.data.result[0].id
                                    },
                                };
                                smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/zone/", body).then(function (response) {
                                    resolve(response);
                                }, function (errorResponse) {
                                    console.log('Something went wrong creating ips point', errorResponse)
                                    reject(errorResponse);
                                });

                            })
                        }else{

                            smarttrackerService.authPost(smarttrackerService.getCustomerId() + "/zoneType/", {
                                'name': 'RSSI-90',
                                'icon': 'https://www.smarttracker.no/web/images/map_icons/house.png'
                            }).then(function (response) {

                                i.newIPSPoint(address, map, level).then(function(response){

                                    resolve(response)

                                }, function(){

                                    alert('RSSI-90 Zone is missing for your account. Please contact X-Guard about this error.\n\ninfo@x-guard.nl or call 088 126 12 12');
                                    reject(response)

                                })

                            }, function (errorResponse) {

                                alert('RSSI-90 Zone is missing for your account. Please contact X-Guard about this error.\n\ninfo@x-guard.nl or call 088 126 12 12');
                                reject(errorResponse);

                            });

                        }

                    }, function (errorResponse) {
                        console.log('Something went wrong creating ips point', errorResponse)
                        reject(errorResponse)
                    })

                } else {

                    // it already exists so we just resolve with the existing address
                    console.log('A zone on this address already exists, we are skipping the creation', existingZone.data.result[0]);
                    resolve(existingZone.data.result[0] || {});

                }

            }, function (errorResponse) {

                // rejection, something went wrong
                console.log('Something went wrong creating ips point', errorResponse)
                reject(errorResponse)

            })
        }); // End promise
    }

    return i;

});
//# sourceMappingURL=stwo_app-core.js.map